webpackJsonp([0],{

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.PRODUCT_CAMPAIGN = 'campaign';
exports.SURVEY_NAME_SHORT_LENGTH = 35;

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"binary_notfound":"_3zxHxmDUwIRB10Ze6mefps","image":"_1YQeUoPr41A-D9ThHMkGuA"};

/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1121);
__webpack_require__(1123);
__webpack_require__(1126);
__webpack_require__(1128);
__webpack_require__(639);
module.exports = __webpack_require__(2420);


/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1124);
__webpack_require__(1125);

/***/ }),

/***/ 1124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1125:
/***/ (function(module, exports) {



/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1127);

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(38);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(508);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReactDOM = __webpack_require__(376);

var _ReactDOM2 = _interopRequireDefault(_ReactDOM);

var _create = __webpack_require__(1404);

var _create2 = _interopRequireDefault(_create);

var _ApiClient = __webpack_require__(1492);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactRedux = __webpack_require__(61);

var _socket = __webpack_require__(1498);

var _socket2 = _interopRequireDefault(_socket);

var _reactRouter = __webpack_require__(281);

var _reduxConnect = __webpack_require__(586);

var _useStandardScroll = __webpack_require__(1568);

var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);

var _routes = __webpack_require__(1574);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = new _ApiClient2.default(); /**
                                         * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
                                         */

var history = null;
if (false) {
  history = (0, _useStandardScroll2.default)(function () {
    return _reactRouter.browserHistory;
  })();
} else {
  history = (0, _useStandardScroll2.default)(function () {
    return _reactRouter.hashHistory;
  })();
}
var dest = document.getElementById('content');
var store = (0, _create2.default)(history, client, window.__data);

function initSocket() {
  var socket = (0, _socket2.default)('', { path: '/ws' });
  socket.on('news', function (data) {
    console.log(data);
    socket.emit('my other event', { my: 'data from client' });
  });
  socket.on('msg', function (data) {
    console.log(data);
  });

  return socket;
}

if (false) {
  global.socket = initSocket();
}

var component = _react2.default.createElement(
  _reactRouter.Router,
  { render: function render(props) {
      return _react2.default.createElement(_reduxConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: { client: client }, filter: function filter(item) {
          return !item.deferred;
        } }));
    }, history: history },
  (0, _routes2.default)(store)
);

_ReactDOM2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (false) {
  window.React = _react2.default; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

if (false) {
  var DevTools = require('./containers/DevTools/DevTools');
  _ReactDOM2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      'div',
      null,
      component,
      _react2.default.createElement(DevTools, null)
    )
  ), dest);
}

/***/ }),

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createStore;

var _redux = __webpack_require__(101);

var _clientMiddleware = __webpack_require__(1418);

var _reactRouterRedux = __webpack_require__(394);

function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  var reduxRouterMiddleware = (0, _reactRouterRedux.syncHistory)(history);

  var middleware = [(0, _clientMiddleware.clientMiddleware)(client), reduxRouterMiddleware];
  var loggerware = [(0, _clientMiddleware.logger)(), reduxRouterMiddleware];
  // const validateware = [validateActivity(client), reduxRouterMiddleware];
  var loggerwareDev = [(0, _clientMiddleware.loggerDev)(), reduxRouterMiddleware];
  var crashReporterware = [(0, _clientMiddleware.crashReporter)(), reduxRouterMiddleware];
  var crashReporterwareLog = [(0, _clientMiddleware.crashReporterLog)(), reduxRouterMiddleware];

  var finalCreateStore = void 0;
  if (false) {
    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    var DevTools = require('../containers/DevTools/DevTools');
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, loggerwareDev),
    // applyMiddleware(...validateware),
    _redux.applyMiddleware.apply(undefined, crashReporterwareLog), _redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
  } else if (false) {
    var _require2 = require('redux-devtools'),
        _persistState = _require2.persistState;

    var _DevTools = require('../containers/DevTools/DevTools');
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, loggerwareDev),
    // applyMiddleware(...validateware),
    _redux.applyMiddleware.apply(undefined, crashReporterwareLog), _redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : _DevTools.instrument(), _persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
  } else {
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, loggerware),
    // applyMiddleware(...validateware),
    _redux.applyMiddleware.apply(undefined, crashReporterware), _redux.applyMiddleware.apply(undefined, middleware))(_redux.createStore);
  }

  var reducer = __webpack_require__(1421);
  var store = finalCreateStore(reducer, data);

  reduxRouterMiddleware.listenForReplays(store);

  if (false) {
    module.hot.accept('./modules/reducer', function () {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  if (false) {
    module.hot.accept('./modules/reducer', function () {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  return store;
}
module.exports = exports['default'];

/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _stringify = __webpack_require__(272);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(38);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(152);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.clientMiddleware = clientMiddleware;
exports.loggerDev = loggerDev;
exports.logger = logger;
exports.crashReporter = crashReporter;
exports.crashReporterLog = crashReporterLog;

var _config = __webpack_require__(273);

var _config2 = _interopRequireDefault(_config);

var _reactCookie = __webpack_require__(212);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clientMiddleware(client) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;

    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState);
        }

        var promise = action.promise,
            types = action.types,
            rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'types']); // eslint-disable-line no-redeclare

        if (!promise) {
          return next(action);
        }

        var REQUEST = types[0],
            SUCCESS = types[1],
            FAILURE = types[2];

        next((0, _extends3.default)({}, rest, { type: REQUEST }));

        var actionPromise = promise(client);
        actionPromise.then(function (result) {
          next((0, _extends3.default)({}, rest, { result: result, type: SUCCESS }));
        }, function (error) {
          var errObj = (0, _extends3.default)({}, rest, { error: error });
          console.log(errObj);
          if (errObj.error.status === 401) {
            var cookieName = _config2.default.env_bf === 'prod' ? 'expiry_time' : _config2.default.env_bf + '_expiry_time';
            var cookiePath = '/';
            var cookieDomain = _config2.default.cookieDomain;

            _reactCookie2.default.remove(cookieName, { path: cookiePath, domain: cookieDomain });

            if (_config2.default.local) {
              if (!window.location.hash.includes('unsubscription')) {
                var sourceUrl = encodeURIComponent(window.location.href.replace('login', ''));
                window.location.href = 'https://' + window.env.loginHost + '?source=' + sourceUrl;
              }
            } else {
              location.reload();
            }
          }
          // alert('There was an error with the server. Please contact us at support@binaryfountain.com or 1-844-225-8155');
          next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        }).catch(function (error) {
          console.error('MIDDLEWARE ERROR:', error);
          next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        });

        return actionPromise;
      };
    };
  };
}

function loggerDev() {
  return function (_ref2) {
    var getState = _ref2.getState;

    return function (next) {
      return function (action) {
        console.log('dispatching', action);
        var result = next(action);
        console.log('next state', getState());
        return result;
      };
    };
  };
}

function logger() {
  return function (_ref3) {
    var getState = _ref3.getState;

    return function (next) {
      return function (action) {
        var result = next(action);
        window.__data = getState();
        return result;
      };
    };
  };
}

function crashReporter() {
  return function (_ref4) {
    var getState = _ref4.getState;

    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          console.error('Caught an exception!', err, ' with action: ', action, ' and state: ', getState());
          throw err;
        }
      };
    };
  };
}

function crashReporterLog() {
  return function (_ref5) {
    var getState = _ref5.getState;

    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          // should use this for dev env only ?
          console.error('Caught an exception!', err, ' with action: ', action, ' and state: ', getState());
          var data = new FormData();
          data.append('json', (0, _stringify2.default)({
            url: window.location.href,
            error: err,
            action: action,
            state: getState()
          }));
          fetch('/api/loadLog', {
            method: 'POST',
            redirect: 'follow',
            body: data,
            headers: new Headers({
              'Content-Type': 'text/plain'
            })
          }).then(function () {});

          throw err;
        }
      };
    };
  };
}

/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _redux = __webpack_require__(101);

var _reactRouterRedux = __webpack_require__(394);

var _reduxConnect = __webpack_require__(586);

var _survey = __webpack_require__(179);

var _survey2 = _interopRequireDefault(_survey);

var _client = __webpack_require__(607);

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import filterDate from './filter/date';

var appReducer = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routeReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  survey: _survey2.default,
  client: _client2.default
  // filterDate,
});

var catchError = function catchError(state, action) {
  var errorsToCatch = ['survey'];
  var handleError = function handleError(actionType) {
    window.actionTypeErrorName = actionType;
    window.location.href = '/#/error';
    // window.location.reload();
  };
  errorsToCatch.forEach(function (error) {
    if (action.type.includes(error)) {
      handleError(error);
    }
  });
};

var rootReducer = function rootReducer(state, action) {
  var newstate = state;
  if (action.type.includes('FAIL')) {
    catchError(state, action);
  }
  return appReducer(newstate, action);
};

exports.default = rootReducer;
module.exports = exports['default'];

/***/ }),

/***/ 1492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(590);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _superagent = __webpack_require__(1493);

var _superagent2 = _interopRequireDefault(_superagent);

var _config = __webpack_require__(273);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  var pathParams = adjustedPath.split('/');
  var url = '';
  if (false) {
    return 'http://' + _config2.default.apiHost + ':' + _config2.default.apiPort + adjustedPath;
  }
  if (pathParams[1] === 'auth') {
    url = 'https://' + window.env.devHost + adjustedPath;
  } else {
    url = 'https://' + window.env.devHost + '/api' + adjustedPath;
  }
  return url;
}

var ApiClient = function () {
  function ApiClient(req) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClient);

    methods.forEach(function (method) {
      _this[method] = function (path) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            data = _ref.data;

        return new _promise2.default(function (resolve, reject) {
          _this.sendRequest(req, params, data, reject, method, resolve, path, 1);
        });
      };
    });
  }

  ApiClient.prototype.retry = function retry(req, params, data, reject, method, resolve, path, retryCount, error) {
    if (retryCount < 3) {
      this.sendRequest(req, params, data, reject, method, resolve, path, retryCount + 1);
    } else {
      reject(error);
    }
  };

  ApiClient.prototype.sendRequest = function sendRequest(req, params, data, reject, method, resolve, path, retryCount) {
    var _this2 = this;

    var request = _superagent2.default[method](formatUrl(path));
    var headers = headers ? headers : { 'Accept': '*/*' };
    if (headers) {
      request.set(headers);
    }
    request.withCredentials();
    if (params) {
      params.random = Math.random();
      request.query(params);
    }
    if (false) {
      request.set('cookie', req.get('cookie'));
    }
    if (data) {
      request.send(data);
    }
    request.end(function (err) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          body = _ref2.body;

      return err ? _this2.retry(req, params, data, reject, method, resolve, path, retryCount, body || err) : resolve(body);
    });
  };

  return ApiClient;
}();

exports.default = ApiClient;
module.exports = exports['default'];

/***/ }),

/***/ 1526:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(281);

var _containers = __webpack_require__(1575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App, history: _reactRouter.hashHistory },
    _react2.default.createElement(
      _reactRouter.Route,
      null,
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.NotFound }),
      _react2.default.createElement(_reactRouter.Route, { path: '/survey/:clientId/:locationId/:surveyId/:providerId', component: _containers.Survey }),
      _react2.default.createElement(_reactRouter.Route, { path: '/survey/:clientId/:locationId/:surveyId/:providerId/:code', component: _containers.Survey }),
      _react2.default.createElement(_reactRouter.Route, { path: '/error', component: _containers.NotFound }),
      _react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe/:clientId/:unsubscribeCode', component: _containers.Unsubscribe }),
      _react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe/v2/:clientId/:unsubscribeCode', component: _containers.UnsubscribeV2 }),
      _react2.default.createElement(_reactRouter.Route, { path: '/:clientId/unsubscription', component: _containers.Unsubscription }),
      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
    )
  );
};

module.exports = exports['default'];

/***/ }),

/***/ 1575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.UnsubscribeV2 = exports.Unsubscription = exports.Unsubscribe = exports.Survey = exports.NotFound = exports.App = undefined;

var _App2 = __webpack_require__(1576);

var _App3 = _interopRequireDefault(_App2);

var _NotFound2 = __webpack_require__(1623);

var _NotFound3 = _interopRequireDefault(_NotFound2);

var _Survey2 = __webpack_require__(2305);

var _Survey3 = _interopRequireDefault(_Survey2);

var _Unsubscribe2 = __webpack_require__(2354);

var _Unsubscribe3 = _interopRequireDefault(_Unsubscribe2);

var _Unsubscription2 = __webpack_require__(2355);

var _Unsubscription3 = _interopRequireDefault(_Unsubscription2);

var _UnsubscribeV2 = __webpack_require__(2419);

var _UnsubscribeV3 = _interopRequireDefault(_UnsubscribeV2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.App = _App3.default;
exports.NotFound = _NotFound3.default;
exports.Survey = _Survey3.default;
exports.Unsubscribe = _Unsubscribe3.default;
exports.Unsubscription = _Unsubscription3.default;
exports.UnsubscribeV2 = _UnsubscribeV3.default;

/***/ }),

/***/ 1576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(273);

var _config2 = _interopRequireDefault(_config);

var _utilElement = __webpack_require__(91);

__webpack_require__(639);

var _reactTapEventPlugin = __webpack_require__(1577);

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _reactHelmet = __webpack_require__(155);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactTapEventPlugin2.default)();

var App = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    if ((0, _utilElement.checkDevice)()) {
      console.log('Mobile device detected!!');
      document.body.addEventListener('focus', _this.focusHandler, true);
      document.body.addEventListener('blur', _this.blurHandler, true);
    }
    var doc = document.body || document.documentElement;
    var style = doc.style;

    if (style.webkitFlexWrap === '' || style.msFlexWrap === '' || style.flexWrap === '') {
      doc.className += ' supports-flex';
    }
    return _this;
  }

  App.prototype.focusHandler = function focusHandler(event) {
    if (event && event.target) {
      var node = event.target.nodeName ? event.target.nodeName.toLowerCase() : '';
      var type = event.target.type ? event.target.type.toLowerCase() : '';
      if ((node === 'input' || node === 'textarea') && type !== 'checkbox' && type !== 'radio') {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          // document.body.addEventListener('touchmove', function clbk(scrollEvent) {scrollEvent.preventDefault();}, false);
        } else {
          document.body.className = 'mobile_device';
        }
      }
    }
  };

  App.prototype.blurHandler = function blurHandler(event) {
    if (event && event.target) {
      var node = event.target.nodeName ? event.target.nodeName.toLowerCase() : '';
      var type = event.target.type ? event.target.type.toLowerCase() : '';
      if ((node === 'input' || node === 'textarea') && type !== 'checkbox' && type !== 'radio') {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          // document.body.removeEventListener('touchmove', function clbk(scrollEvent) {scrollEvent.preventDefault();}, false);
        } else {
          setTimeout(function clbk() {
            document.body.className = document.body.className.replace(/\bmobile_device\b/, '');
          }, 300);
        }
      }
    }
  };

  App.prototype.render = function render() {
    var styles = __webpack_require__(656);
    return _react2.default.createElement(
      'div',
      { className: styles.app },
      _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
      _react2.default.createElement(
        'div',
        { className: styles.appContent },
        _react2.default.createElement(
          'div',
          { style: { height: '100%', width: '100%' } },
          this.props.children
        )
      )
    );
  };

  return App;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object
}, _temp);
exports.default = App;
module.exports = exports['default'];

/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _reactRouterRedux = __webpack_require__(394);

var _redux = __webpack_require__(101);

var _reactHelmet = __webpack_require__(155);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mozart_ui = __webpack_require__(69);

var _reactRouter = __webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = (_dec = (0, _reactRedux.connect)(null, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    pushState: _reactRouterRedux.routeActions.push }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound() {
    (0, _classCallCheck3.default)(this, NotFound);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  NotFound.prototype.render = function render() {
    var styles = __webpack_require__(2304);
    return _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(_reactHelmet2.default, { title: 'Not Found' }),
      _react2.default.createElement(
        'div',
        { className: styles.binary_notfound },
        _react2.default.createElement(
          'div',
          { style: { marginLeft: 'auto', marginRight: 'auto', width: '500px', maxWidth: '100%' } },
          _react2.default.createElement(_mozart_ui.Image, { src: '/img/broken_robot.png' })
        ),
        _react2.default.createElement(
          'p',
          { style: { fontSize: '30px', fontWeight: 300, textAlign: 'center' } },
          'Sorry, we are having technical difficulties.'
        ),
        _react2.default.createElement(
          'p',
          { style: { fontSize: '20px', fontWeight: 300, textAlign: 'center' } },
          'Please try your request again or click',
          _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                _reactRouter.browserHistory.goBack();
                setTimeout(function () {
                  window.location.reload();
                }, 500);
              } },
            ' here'
          ),
          ' to go back.'
        )
      )
    );
  };

  return NotFound;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = NotFound;
module.exports = exports['default'];

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(38);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = survey;
exports.loadSurvey = loadSurvey;
exports.loadLocations = loadLocations;
exports.loadProviders = loadProviders;
exports.loadSurveys = loadSurveys;
exports.saveFeedback = saveFeedback;
exports.loadAudienceInfo = loadAudienceInfo;
exports.createAudience = createAudience;
exports.loadLanguages = loadLanguages;
exports.setLanguage = setLanguage;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SURVEY = 'binary/survey/LOAD_SURVEY';
var LOAD_SURVEY_SUCCESS = 'binary/survey/LOAD_SURVEY_SUCCESS';
var LOAD_SURVEY_FAIL = 'binary/survey/LOAD_SURVEY_FAIL';
var LOAD_LOCATIONS = 'binary/survey/LOAD_LOCATIONS';
var LOAD_LOCATIONS_SUCCESS = 'binary/survey/LOAD_LOCATIONS_SUCCESS';
var LOAD_LOCATIONS_FAIL = 'binary/survey/LOAD_LOCATIONS_FAIL';
var LOAD_PROVIDERS = 'binary/survey/LOAD_PROVIDERS';
var LOAD_PROVIDERS_SUCCESS = 'binary/survey/LOAD_PROVIDERS_SUCCESS';
var LOAD_PROVIDERS_FAIL = 'binary/survey/LOAD_PROVIDERS_FAIL';
var LOAD_SURVEYS = 'binary/survey/LOAD_SURVEYS';
var LOAD_SURVEYS_SUCCESS = 'binary/survey/LOAD_SURVEYS_SUCCESS';
var LOAD_SURVEYS_FAIL = 'binary/survey/LOAD_SURVEYS_FAIL';
var LOAD_LANGUAGES = 'binary/survey/LOAD_LANGUAGES';
var LOAD_LANGUAGES_SUCCESS = 'binary/survey/LOAD_LANGUAGES_SUCCESS';
var LOAD_LANGUAGES_FAIL = 'binary/survey/LOAD_LANGUAGES_FAIL';
var SET_LANGUAGE = 'binary/survey/SET_LANGUAGE';
var SAVE_SURVEY = 'binary/survey/SAVE_SURVEY';
var SAVE_SURVEY_SUCCESS = 'binary/survey/SAVE_SURVEY_SUCCESS';
var SAVE_SURVEY_FAIL = 'binary/survey/SAVE_SURVEY_FAIL';
var LOAD_AUDIENCE_INFO = 'binary/survey/LOAD_AUDIENCE_INFO';
var LOAD_AUDIENCE_INFO_SUCCESS = 'binary/survey/LOAD_AUDIENCE_INFO_SUCCESS';
var LOAD_AUDIENCE_INFO_FAIL = 'binary/survey/LOAD_AUDIENCE_INFO_FAIL';
var CREATE_AUDIENCE_INFO = 'binary/survey/CREATE_AUDIENCE_INFO';
var CREATE_AUDIENCE_INFO_SUCCESS = 'binary/survey/CREATE_AUDIENCE_INFO_SUCCESS';
var CREATE_AUDIENCE_INFO_FAIL = 'binary/survey/CREATE_AUDIENCE_INFO_FAIL';

var initialState = {
  loadedSurvey: false,
  loadingSurvey: false,
  data: false,
  loadedLocations: false,
  loadingLocations: false,
  locations: false,
  loadedProviders: false,
  loadingProviders: false,
  providers: false,
  loadedSurveys: false,
  loadingSurveys: false,
  surveys: false,
  loadedLanguages: false,
  loadingLanguages: false,
  languages: false,
  selectedLanguage: false,
  savingSurvey: false,
  savedSurvey: false,
  savedData: false,
  loadedAudienceInfo: false,
  loadingAudienceInfo: false,
  audienceInfo: false,
  createdAudienceInfo: false
};

function survey() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_SURVEY:
      return (0, _extends3.default)({}, state, {
        loadingSurvey: true
      });
    case LOAD_SURVEY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingSurvey: false,
        loadedSurvey: true,
        data: action.result
      });
    case LOAD_SURVEY_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingSurvey: false,
        loadedSurvey: false,
        error: action.error
      });
    case LOAD_LOCATIONS:
      return (0, _extends3.default)({}, state, {
        loadingLocations: true
      });
    case LOAD_LOCATIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingLocations: false,
        loadedLocations: true,
        locations: action.result
      });
    case LOAD_LOCATIONS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingLocations: false,
        loadedLocations: false,
        error: action.error
      });
    case LOAD_PROVIDERS:
      return (0, _extends3.default)({}, state, {
        loadingProviders: true
      });
    case LOAD_PROVIDERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingProviders: false,
        loadedProviders: true,
        providers: [{ 'id': 913650, 'name': 'Clog_Brand', 'address': 'Clog_Brand,  Clog_BrandClog_Brand,  Clog_BrandClog_BrandClog_Brand' }, { 'id': 913651, 'name': 'Clog_BU', 'address': 'Clog_BU,  Clog_BUClog_BU,  Clog_BUClog_BUClog_BUClog_BU' }, { 'id': 913652, 'name': 'Clog_Region', 'address': 'Clog_Region,  Clog_RegionClog_Region,  Clog_RegionClog_RegionClog_Region' }, { 'id': 1057662, 'name': 'We Care Clinic child - Trivandrum', 'address': 'We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum' }]
      });
    case LOAD_PROVIDERS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingProviders: false,
        loadedProviders: false,
        error: action.error
      });
    case LOAD_SURVEYS:
      return (0, _extends3.default)({}, state, {
        loadingSurveys: true
      });
    case LOAD_SURVEYS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingSurveys: false,
        loadedSurveys: true,
        list: action.result
      });
    case LOAD_SURVEYS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingSurveys: false,
        loadedSurveys: false,
        error: action.error
      });
    case LOAD_LANGUAGES:
      return (0, _extends3.default)({}, state, {
        loadingLanguages: true
      });
    case LOAD_LANGUAGES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingLanguages: false,
        loadedLanguages: true,
        languages: [{ 'id': 913650, 'name': 'Clog_Brand', 'flag': 'Clog_Brand,  Clog_BrandClog_Brand,  Clog_BrandClog_BrandClog_Brand' }, { 'id': 913651, 'name': 'Clog_BU', 'flag': 'Clog_BU,  Clog_BUClog_BU,  Clog_BUClog_BUClog_BUClog_BU' }, { 'id': 913652, 'name': 'Clog_Region', 'flag': 'Clog_Region,  Clog_RegionClog_Region,  Clog_RegionClog_RegionClog_Region' }, { 'id': 1057662, 'name': 'We Care Clinic child - Trivandrum', 'flag': 'We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum,  We Care Clinic child - Trivandrum' }]
      });
    case LOAD_LANGUAGES_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingLanguages: false,
        loadedLanguages: false,
        error: action.error
      });
    case SET_LANGUAGE:
      return (0, _extends3.default)({}, state, {
        selectedLanguage: action.result
      });
    case SAVE_SURVEY:
      return (0, _extends3.default)({}, state, {
        savingSurvey: true
      });
    case SAVE_SURVEY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        savingSurvey: false,
        savedSurvey: true,
        savedData: action.result
      });
    case SAVE_SURVEY_FAIL:
      return (0, _extends3.default)({}, state, {
        savingSurvey: false,
        savedSurvey: false,
        error: action.error
      });
    case LOAD_AUDIENCE_INFO:
      return (0, _extends3.default)({}, state, {
        loadingAudienceInfo: true
      });
    case LOAD_AUDIENCE_INFO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingAudienceInfo: false,
        loadedAudienceInfo: true,
        audienceInfo: action.result
      });
    case LOAD_AUDIENCE_INFO_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingAudienceInfo: false,
        loadedAudienceInfo: false,
        error: action.error
      });
    case CREATE_AUDIENCE_INFO:
      return (0, _extends3.default)({}, state);
    case CREATE_AUDIENCE_INFO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        createdAudienceInfo: action.result
      });
    case CREATE_AUDIENCE_INFO_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error
      });
    default:
      return state;
  }
}

function loadSurvey(clientId, surveyId, locationId, audienceCode) {
  return {
    types: [LOAD_SURVEY, LOAD_SURVEY_SUCCESS, LOAD_SURVEY_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/survey/' + surveyId, {
        params: {
          locationId: locationId,
          audienceCode: audienceCode
        }
      });
    }
  };
}

function loadLocations(clientId, sourceId) {
  //   return {type: LOAD_LOCATIONS_SUCCESS, result: [clientId, sourceId]};
  return {
    types: [LOAD_LOCATIONS, LOAD_LOCATIONS_SUCCESS, LOAD_LOCATIONS_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/locations?sourceId=' + sourceId, {
        params: {}
      });
    }
  };
}

function loadProviders() {
  return { type: LOAD_PROVIDERS_SUCCESS, result: [] };
}

function loadSurveys(clientId, locationId) {
  //   return {type: LOAD_SURVEYS_SUCCESS, result: [clientId, locationId]};
  return {
    types: [LOAD_SURVEYS, LOAD_SURVEYS_SUCCESS, LOAD_SURVEYS_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/surveys?locationId=' + locationId, {
        params: {}
      });
    }
  };
}

function saveFeedback(clientId, data) {
  return {
    types: [SAVE_SURVEY, SAVE_SURVEY_SUCCESS, SAVE_SURVEY_FAIL],
    promise: function promise(client) {
      return client.post('/feedback/' + clientId + '/submit', {
        data: data
      });
    }
  };
}

function loadAudienceInfo(clientId, audienceCode, trackClick) {
  return {
    types: [LOAD_AUDIENCE_INFO, LOAD_AUDIENCE_INFO_SUCCESS, LOAD_AUDIENCE_INFO_FAIL],
    promise: function promise(client) {
      return client.get('/feedback/' + clientId + '/audience/' + audienceCode, {
        params: {
          trackClick: trackClick
        }
      });
    }
  };
}

function createAudience(clientId, data) {
  return {
    types: [CREATE_AUDIENCE_INFO, CREATE_AUDIENCE_INFO_SUCCESS, CREATE_AUDIENCE_INFO_FAIL],
    promise: function promise(client) {
      return client.post('/feedback/' + clientId + '/testimonialsurvey/campaignAudience', {
        data: data
      });
    }
  };
}

function loadLanguages() {
  return { type: LOAD_LANGUAGES_SUCCESS, result: [] };
}

function setLanguage(lang) {
  return { type: SET_LANGUAGE, result: lang };
}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Thankyou = exports.Search = exports.DatePickerWeb = exports.MozartSlider = exports.Languages = exports.SurveyLogo = exports.Surveys = exports.Providers = exports.Locations = exports.SurveyFooter = exports.SurveyHeader = exports.SurveyQuestions = exports.SurveyHome = exports.NoPermission = undefined;

var _NoPermission2 = __webpack_require__(2306);

var _NoPermission3 = _interopRequireDefault(_NoPermission2);

var _SurveyHome2 = __webpack_require__(2308);

var _SurveyHome3 = _interopRequireDefault(_SurveyHome2);

var _SurveyQuestions2 = __webpack_require__(2310);

var _SurveyQuestions3 = _interopRequireDefault(_SurveyQuestions2);

var _SurveyHeader2 = __webpack_require__(2326);

var _SurveyHeader3 = _interopRequireDefault(_SurveyHeader2);

var _SurveyFooter2 = __webpack_require__(2328);

var _SurveyFooter3 = _interopRequireDefault(_SurveyFooter2);

var _Locations2 = __webpack_require__(2330);

var _Locations3 = _interopRequireDefault(_Locations2);

var _Providers2 = __webpack_require__(2332);

var _Providers3 = _interopRequireDefault(_Providers2);

var _Surveys2 = __webpack_require__(2334);

var _Surveys3 = _interopRequireDefault(_Surveys2);

var _SurveyLogo2 = __webpack_require__(2336);

var _SurveyLogo3 = _interopRequireDefault(_SurveyLogo2);

var _Languages2 = __webpack_require__(2338);

var _Languages3 = _interopRequireDefault(_Languages2);

var _MozartSlider2 = __webpack_require__(2340);

var _MozartSlider3 = _interopRequireDefault(_MozartSlider2);

var _DatePickerWeb2 = __webpack_require__(2346);

var _DatePickerWeb3 = _interopRequireDefault(_DatePickerWeb2);

var _Search2 = __webpack_require__(2348);

var _Search3 = _interopRequireDefault(_Search2);

var _Thankyou2 = __webpack_require__(2350);

var _Thankyou3 = _interopRequireDefault(_Thankyou2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NoPermission = _NoPermission3.default; /**
                                                *  Point of contact for component modules
                                                *
                                                *  ie: import { Logo, Footer } from 'components';
                                                *
                                                */

// Components

exports.SurveyHome = _SurveyHome3.default;
exports.SurveyQuestions = _SurveyQuestions3.default;
exports.SurveyHeader = _SurveyHeader3.default;
exports.SurveyFooter = _SurveyFooter3.default;
exports.Locations = _Locations3.default;
exports.Providers = _Providers3.default;
exports.Surveys = _Surveys3.default;
exports.SurveyLogo = _SurveyLogo3.default;
exports.Languages = _Languages3.default;
exports.MozartSlider = _MozartSlider3.default;
exports.DatePickerWeb = _DatePickerWeb3.default;
exports.Search = _Search3.default;
exports.Thankyou = _Thankyou3.default;

/***/ }),

/***/ 2304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"binary_notfound":"_1InndG1iXtCauzHmbAwDy6","image":"_1Nw746oDiZkncV1jZfszas"};

/***/ }),

/***/ 2305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _typeof2 = __webpack_require__(177);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(126);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(272);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(155);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = __webpack_require__(61);

var _redux = __webpack_require__(101);

var _components = __webpack_require__(200);

var _survey = __webpack_require__(179);

var _client = __webpack_require__(607);

var _reactAddonsCssTransitionGroup = __webpack_require__(1100);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _momentTimezone = __webpack_require__(498);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _mozart_ui = __webpack_require__(69);

var _utilElement = __webpack_require__(91);

var _utilConstants = __webpack_require__(1099);

var _utilsStyles = __webpack_require__(2352);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Survey = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data,
    locations: state.survey.locations,
    surveys: state.survey.list,
    clientDetails: state.client,
    selectedLanguage: state.survey.selectedLanguage,
    apiRouter: state.survey
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadSurvey: _survey.loadSurvey, setLanguage: _survey.setLanguage, loadLocations: _survey.loadLocations, loadSurveys: _survey.loadSurveys, saveFeedback: _survey.saveFeedback, loadAudienceInfo: _survey.loadAudienceInfo, loadClient: _client.loadClient }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Survey, _Component);

  function Survey(props) {
    (0, _classCallCheck3.default)(this, Survey);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2353);
    _this.state = {
      start_survey: false,
      location_id: parseInt(_this.props.params.locationId, 10) ? _this.props.params.locationId : 0,
      survey_id: parseInt(_this.props.params.surveyId, 10) ? _this.props.params.surveyId : 0,
      provider_id: parseInt(_this.props.params.providerId, 10) ? _this.props.params.providerId : 0,
      audience_code: _this.props.params.code && _this.props.params.code !== '0' ? _this.props.params.code : 0,
      language_id: false,
      tmp_location: 0,
      tmp_survey: 0,
      tmp_language: 0,
      show_locations: false,
      show_surveys: false,
      show_languages: false,
      current_page: '',
      current_move: 'forward',
      show_back: false,
      show_next: true,
      seq_no: 0,
      show_thankyou: false,
      preview_mode: _this.props.location.query && _this.props.location.query.previewMode && _this.props.location.query.previewMode === 'on' ? true : false,
      redirect_from_thankyou: _this.props.location.query && _this.props.location.query.officeMode && _this.props.location.query.officeMode === 'on' ? true : false,
      track_click: _this.props.location.query && _this.props.location.query.trackClick && _this.props.location.query.trackClick === 'on' ? true : false,
      client_logo_url: 'https://' + window.env.nextgenApiHost + '/api/clients/' + _this.props.params.clientId + '/logo?productId=' + _utilConstants.PRODUCT_CAMPAIGN,
      show_branding: true,
      show_loading: true,
      show_search_page: false,
      survey_submitted: false,
      location_label: 'Please select a practice/location',
      theme: {
        colorCode: '#00397AFF',
        surveyColorType: 'presetColor',
        colorTheme: 'darkBlue',
        customTextColor: '#FFFFFF'
      }
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading home page.');
    return _this;
  }

  Survey.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var clientId = this.props.params.clientId;
    this.props.loadClient(clientId).then(function (clientDetails) {
      var additionalConfig = clientDetails && clientDetails.additionalConfiguration ? clientDetails.additionalConfiguration : [];
      var theme = {};
      additionalConfig.map(function (item) {
        if (item.key === 'surveyColorType' || item.key === 'colorCode' || item.key === 'colorTheme' || item.key === 'customTextColor') {
          theme[item.key] = item.value;
        }
        return theme;
      });

      _this2.setState({ theme: theme });
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = (0, _utilsStyles.loaderOverride)(theme.colorCode) + '  ' + (0, _utilsStyles.buttonOverride)(theme.colorCode, theme.customTextColor);
      document.getElementsByTagName('head')[0].appendChild(style);
      if (_this2.state.audience_code) {
        _this2.props.loadAudienceInfo(clientId, _this2.state.audience_code, _this2.state.track_click).then(function (audienceInfo) {
          if (audienceInfo && audienceInfo.data) {
            if (audienceInfo.data.hasSurveySubmitted) {
              _this2.props.loadSurvey(clientId, _this2.state.survey_id, _this2.state.location_id, _this2.state.audience_code ? _this2.state.audience_code : '').then(function (surveyData) {
                if (surveyData && surveyData.data) {
                  _this2.configureSurvey(surveyData.data);
                  _this2.setState({ show_thankyou: true, start_survey: false, survey_submitted: true });
                }
              });
            } else {
              _this2.loadPreFillData();
            }
          }
        });
      } else {
        _this2.loadPreFillData();
      }
    });
  };

  Survey.prototype.onSurveySubmit = function onSurveySubmit(surveyData, anonymousFlag) {
    var _this3 = this;

    var clientId = this.props.params.clientId;
    var surveyInput = this.prepareSurveyData(surveyData, anonymousFlag);
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_BTN_CLICK, _utilElement.EVENT_BTN_CLICK, 'Feedback submitting with data : ' + (0, _stringify2.default)(surveyInput));
    if (this.state.preview_mode) {
      console.log("You are in preview mode, so submission won't happen");
      console.log(_momentTimezone2.default.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'));
      this.setState({ show_thankyou: true, start_survey: false });
    } else {
      this.props.saveFeedback(clientId, surveyInput).then(function () {
        _this3.setState({ show_thankyou: true, start_survey: false });
      });
    }
  };

  Survey.prototype.getPrePageContent = function getPrePageContent() {
    return _react2.default.createElement(
      'div',
      null,
      this.showLocations() && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Locations, {
          selectedLocation: this.state.location_id,
          key: Math.random(),
          onSelectLocation: this.selectLocation.bind(this),
          clientId: this.props.params.clientId,
          sourceId: this.state.survey_id,
          showSearch: this.state.show_search_page,
          theme: this.state.theme,
          label: this.state.location_label
        })
      ),
      !this.showLocations() && this.showSurveys() && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Surveys, {
          selectedSurvey: this.state.survey_id,
          key: Math.random(),
          onSelectSurvey: this.selectSurvey.bind(this),
          clientId: this.props.params.clientId,
          locationId: this.state.location_id,
          showSearch: this.state.show_search_page,
          previewMode: this.state.preview_mode,
          theme: this.state.theme
        })
      ),
      !this.showLocations() && !this.showSurveys() && this.showLanguages() && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Languages, {
          currentLanguage: this.state.language_id,
          key: Math.random(),
          onSelectLanguage: this.selectLanguage.bind(this),
          showSearch: this.state.show_search_page,
          theme: this.state.theme
        })
      )
    );
  };

  Survey.prototype.getMobileFriendlySurvey = function getMobileFriendlySurvey(surveyList) {
    var _this4 = this;

    var mobileFriendlySurveys = [];
    if (surveyList) {
      surveyList.map(function (item) {
        if (_this4.state.preview_mode) {
          mobileFriendlySurveys.push(item);
        } else if (item.mobileFriendly) {
          mobileFriendlySurveys.push(item);
        }
      });
    }
    return mobileFriendlySurveys;
  };

  Survey.prototype.generateUUID = function generateUUID() {
    var date = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (clbk) {
      var replace = (date + Math.random() * 16) % 16 | 0;
      date = Math.floor(date / 16);
      return (clbk === 'x' ? replace : replace & 0x3 | 0x8).toString(16);
    });
    return uuid;
  };

  Survey.prototype.prepareSurveyData = function prepareSurveyData(surveyData, anonymousFlag) {
    var surveyInput = {};
    var clientId = this.props.params.clientId;

    surveyInput.avatarId = this.state.location_id;
    surveyInput.campaignAudienceCode = this.state.audience_code ? this.state.audience_code : '';
    surveyInput.clientId = clientId;
    surveyInput.fromCampaign = this.state.audience_code ? true : false;
    surveyInput.language = this.state.language_id;
    surveyInput.mentionTime = _momentTimezone2.default.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
    surveyInput.sessionKey = this.generateUUID();
    surveyInput.sourceId = this.state.survey_id;
    surveyInput.anonymousFlag = anonymousFlag;
    surveyInput.surveyresponses = [];
    if (this.state.preview_mode) {
      surveyInput.previewMode = 'ON';
    }

    if ((0, _keys2.default)(surveyData).length > 0) {
      (0, _keys2.default)(surveyData).map(function (item) {
        var responses = [];
        if ((0, _typeof3.default)(surveyData[item].optionId) === 'object') {
          var optionList = surveyData[item].optionId;
          var responseList = surveyData[item].response;
          optionList.map(function (optionitem, index) {
            responses.push({ optionId: optionitem, response: responseList[index] });
          });
        } else {
          responses.push({ optionId: surveyData[item].optionId, response: surveyData[item].response });
        }
        surveyInput.surveyresponses.push({ questionId: item, responses: responses });
      });
    }

    return surveyInput;
  };

  Survey.prototype.loadPreFillData = function loadPreFillData() {
    var _this5 = this;

    var clientId = this.props.params.clientId;
    // Load location list
    if (!this.props.locations && !parseInt(this.props.params.locationId, 10)) {
      this.props.loadLocations(clientId, this.state.survey_id).then(function (locationData) {
        if (locationData && locationData.data && locationData.data.length === 1) {
          _this5.setState({
            location_id: locationData.data[0].id,
            show_locations: false,
            tmp_location: locationData.data[0].id }, function () {
            _this5.handleNextButtonClick();
          });
        } else {
          _this5.setState({ location_id: 0, show_locations: true });
        }
      });
    }
    // Load Survey list
    if (this.state.location_id && !this.props.surveys && !parseInt(this.props.params.surveyId, 10)) {
      this.props.loadSurveys(clientId, this.state.location_id).then(function (surveyListData) {
        if (surveyListData && surveyListData.data && _this5.getMobileFriendlySurvey(surveyListData.data).length === 1) {
          _this5.setState({
            survey_id: _this5.getMobileFriendlySurvey(surveyListData.data)[0].id,
            show_surveys: false,
            tmp_survey: surveyListData.data[0].id }, function () {
            _this5.handleNextButtonClick();
          });
        } else {
          _this5.setState({ survey_id: 0, show_surveys: true });
        }
      });
    }
    // Load survey info
    if (!this.props.survey && this.state.survey_id) {
      this.props.loadSurvey(clientId, this.state.survey_id, this.state.location_id, this.state.audience_code ? this.state.audience_code : '').then(function (surveyData) {
        if (surveyData && surveyData.data) {
          _this5.configureSurvey(surveyData.data);
        }
      });
    }
  };

  Survey.prototype.showLocations = function showLocations() {
    var retVal = false;
    if (!this.defaultLocationId() && this.state.show_locations) {
      this.state.current_page = 'location';
      this.state.tmp_location = this.state.location_id;
      this.state.show_back = false;
      if (this.state.tmp_location) {
        this.state.show_next = true;
      } else {
        this.state.show_next = false;
      }
      retVal = true;
    } else {
      this.state.show_next = false;
    }
    return retVal;
  };

  Survey.prototype.showSurveys = function showSurveys() {
    var retVal = false;
    if (this.state.location_id && !this.defaultSurveyId() && this.state.show_surveys) {
      this.state.current_page = 'survey';
      this.state.tmp_survey = this.state.survey_id;
      this.state.show_back = !this.defaultLocationId() && this.props.locations && this.props.locations.length !== 1;
      this.state.show_next = this.props.surveys && this.props.surveys.data.length && this.state.tmp_survey ? true : false;
      retVal = true;
    } else {
      this.state.show_next = false;
    }
    return retVal;
  };

  Survey.prototype.showLanguages = function showLanguages() {
    var retVal = false;
    if (this.state.location_id && this.state.survey_id && this.state.show_languages) {
      this.state.current_page = 'language';
      this.state.tmp_language = this.state.language_id;
      this.state.show_back = (!this.defaultSurveyId() || !this.defaultLocationId()) && this.props.surveys && this.props.surveys.length !== 1;
      retVal = true;
    }
    return retVal;
  };

  Survey.prototype.startSurvey = function startSurvey() {
    this.setState({ start_survey: true });
  };

  Survey.prototype.selectLocation = function selectLocation(location) {
    var _this6 = this;

    this.state.tmp_location = location.id;
    this.state.location_id = location.id;
    this.state.show_next = true;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_SET_DATA, _utilElement.EVENT_SET_DATA, 'Location selected : ' + location.id);
    this.setState({
      location_id: this.state.location_id
    }, function () {
      _this6.handleNextButtonClick();
    });
  };

  Survey.prototype.selectSurvey = function selectSurvey(survey) {
    var _this7 = this;

    this.state.tmp_survey = survey.id;
    this.state.survey_id = survey.id;
    this.state.show_next = true;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_SET_DATA, _utilElement.EVENT_SET_DATA, 'Survey selected : ' + survey.id);
    this.setState({
      survey_id: this.state.survey_id
    }, function () {
      _this7.handleNextButtonClick();
    });
  };

  Survey.prototype.selectLanguage = function selectLanguage(language) {
    var _this8 = this;

    this.state.tmp_language = language;
    this.state.language_id = language;
    this.state.show_next = true;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_SET_DATA, _utilElement.EVENT_SET_DATA, 'Language selected : ' + language);
    this.setState({
      language_id: this.state.language_id
    }, function () {
      _this8.handleNextButtonClick();
    });
  };

  Survey.prototype.defaultSurveyId = function defaultSurveyId() {
    return parseInt(this.props.params.surveyId, 10);
  };

  Survey.prototype.defaultLocationId = function defaultLocationId() {
    return parseInt(this.props.params.locationId, 10);
  };

  Survey.prototype.configureSurvey = function configureSurvey(survey) {
    this.state.show_branding = survey.showBFBranding;
    this.state.start_survey = !survey.showStartSurveyPage;

    if (survey.showLocationBasedLogo) {
      this.state.client_logo_url = this.state.client_logo_url.split('?')[0];
      this.state.client_logo_url = this.state.client_logo_url + '?avatarId=' + this.state.location_id + '&productId=' + _utilConstants.PRODUCT_CAMPAIGN;
    } else {
      this.state.client_logo_url = this.state.client_logo_url.split('?')[0];
      this.state.client_logo_url = this.state.client_logo_url + '?productId=' + _utilConstants.PRODUCT_CAMPAIGN;
    }
    if (survey.languages && (0, _keys2.default)(survey.languages).length === 1) {
      this.state.language_id = (0, _keys2.default)(survey.languages)[0];
      this.state.show_languages = false;
      this.props.setLanguage((0, _keys2.default)(survey.languages)[0]);
    } else {
      this.state.language_id = 0;
      this.state.show_languages = true;
    }
    if (survey.locationLabel) {
      this.state.location_label = survey.locationLabel;
    }
    this.setState({ language_id: this.state.language_id });
  };

  Survey.prototype.loadSurveyList = function loadSurveyList() {
    var _this9 = this;

    this.props.loadSurveys(this.props.params.clientId, this.state.location_id).then(function (surveyListData) {
      if (surveyListData && surveyListData.data && _this9.getMobileFriendlySurvey(surveyListData.data).length === 1) {
        _this9.state.survey_id = _this9.getMobileFriendlySurvey(surveyListData.data)[0].id;
        _this9.state.tmp_survey = _this9.getMobileFriendlySurvey(surveyListData.data)[0].id;
        _this9.state.show_surveys = false;
        _this9.loadSurveyInfo();
      } else {
        _this9.state.survey_id = 0;
        _this9.state.show_surveys = true;
      }
      _this9.state.show_locations = false;
      if (_this9.state.preview_mode) {
        _this9.state.show_surveys = !_this9.defaultSurveyId() && _this9.props.surveys && _this9.props.surveys.data.length !== 1;
      } else {
        _this9.state.show_surveys = !_this9.defaultSurveyId() && _this9.props.surveys && _this9.getMobileFriendlySurvey(surveyListData.data).length !== 1;
      }
      _this9.state.show_languages = _this9.defaultSurveyId() && _this9.props.survey && (0, _keys2.default)(_this9.props.survey.data.languages).length !== 1;
      _this9.setState({ location_id: _this9.state.tmp_location, tmp_location: 0, current_move: 'forward' });
    });
  };

  Survey.prototype.loadSurveyInfo = function loadSurveyInfo() {
    var _this10 = this;

    this.props.loadSurvey(this.props.params.clientId, this.state.survey_id, this.state.location_id, this.state.audience_code ? this.state.audience_code : '').then(function (surveyData) {
      if (surveyData && surveyData.data) {
        _this10.configureSurvey(surveyData.data);
      }
      _this10.state.show_locations = false;
      _this10.state.show_surveys = false;
      _this10.state.show_languages = _this10.props.survey && (0, _keys2.default)(_this10.props.survey.data.languages).length !== 1;
      if (!_this10.state.show_languages) {
        _this10.props.setLanguage(_this10.state.language_id);
      }
      _this10.setState({ survey_id: _this10.state.tmp_survey, tmp_survey: 0, current_move: 'forward' });
    });
  };

  Survey.prototype.handleNextButtonClick = function handleNextButtonClick() {
    var _this11 = this;

    this.state.seq_no = this.state.seq_no + 1;
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_BTN_CLICK, _utilElement.EVENT_BTN_CLICK, 'Next button clicked.');
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1000);
    if (this.state.tmp_location) {
      if (this.state.location_id && !parseInt(this.props.params.surveyId, 10)) {
        this.loadSurveyList();
      } else if (this.state.location_id && parseInt(this.props.params.surveyId, 10)) {
        this.props.loadSurvey(this.props.params.clientId, this.state.survey_id, this.state.location_id, this.state.audience_code ? this.state.audience_code : '').then(function (surveyData) {
          if (surveyData && surveyData.data) {
            _this11.configureSurvey(surveyData.data);
          }
          _this11.state.show_locations = false;
          _this11.state.show_surveys = false;
          _this11.state.show_languages = _this11.props.survey && (0, _keys2.default)(_this11.props.survey.data.languages).length !== 1;
          if (!_this11.state.show_languages) {
            _this11.props.setLanguage(_this11.state.language_id);
          }
          _this11.setState({ location_id: _this11.state.tmp_location, tmp_location: 0, survey_id: parseInt(_this11.props.params.surveyId, 10), tmp_survey: 0, current_move: 'forward' });
        });
      } else {
        this.state.show_locations = false;
        this.state.show_surveys = !this.defaultSurveyId() && this.props.surveys && this.props.surveys.length !== 1;
        this.state.show_languages = this.defaultSurveyId() && this.props.survey && (0, _keys2.default)(this.props.survey.data.languages).length !== 1;
        this.setState({ location_id: this.state.tmp_location, tmp_location: 0, current_move: 'forward' });
      }
    }
    if (this.state.tmp_survey) {
      if (this.state.survey_id) {
        this.loadSurveyInfo();
      } else {
        this.state.show_locations = false;
        this.state.show_surveys = false;
        this.state.show_languages = this.props.survey && (0, _keys2.default)(this.props.survey.data.languages).length !== 1;
        if (!this.state.show_languages) {
          this.props.setLanguage(this.state.language_id);
        }
        this.setState({ survey_id: this.state.tmp_survey, tmp_survey: 0, current_move: 'forward' });
      }
    }
    if (this.state.tmp_language) {
      this.state.show_locations = false;
      this.state.show_surveys = false;
      this.state.show_languages = false;
      this.props.setLanguage(this.state.tmp_language);
      this.setState({ language_id: this.state.tmp_language, tmp_language: 0, current_move: 'forward' });
    }
  };

  Survey.prototype.handleBackButtonClick = function handleBackButtonClick() {
    this.state.show_search_page = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_BTN_CLICK, _utilElement.EVENT_BTN_CLICK, 'Back button clicked.');
    window.scrollTo(0, 0);
    this.state.seq_no = this.state.seq_no - 1;
    if (this.state.current_page === 'language') {
      if (!this.defaultSurveyId()) {
        this.setState({ show_languages: false, show_locations: false, show_surveys: true, tmp_language: 0, current_page: 'survey', current_move: 'backward' });
      } else if (this.defaultSurveyId() && !this.defaultLocationId()) {
        this.setState({ show_languages: false, show_locations: true, show_surveys: false, tmp_language: 0, current_page: 'location', current_move: 'backward' });
      } else {
        this.setState({ tmp_language: 0, current_move: 'backward' });
      }
    }
    if (this.state.current_page === 'survey') {
      if (!this.defaultLocationId()) {
        this.setState({ tmp_language: false, show_languages: false, show_locations: true, show_surveys: false, tmp_survey: 0, current_page: 'location', current_move: 'backward' });
      } else {
        this.setState({ tmp_survey: 0, current_move: 'backward' });
      }
    }
  };

  Survey.prototype.handleSearchClickMobile = function handleSearchClickMobile() {
    this.setState({ show_search_page: true });
  };

  Survey.prototype.render = function render() {
    this.state.show_loading = this.props.apiRouter.loadingSurveys || this.props.apiRouter.loadingSurvey || this.props.apiRouter.loadingLocations || this.props.apiRouter.loadingProviders || this.props.apiRouter.loadingAudienceInfo || this.props.apiRouter.savingSurvey ? true : false;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.survey_page_container, style: { height: this.state.height }, id: 'customTheme' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Survey' }),
        _react2.default.createElement(_mozart_ui.MozartLoading, {
          id: 'loading',
          loading: this.state.show_loading }),
        this.props.clientDetails && this.props.clientDetails.loadedClient ? _react2.default.createElement(
          'div',
          { className: this.styles.survey_body_container },
          (!this.state.location_id || !this.state.survey_id || !this.state.language_id) && !this.state.show_thankyou ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.SurveyHeader, { params: this.props.params, clientLogoUrl: this.state.client_logo_url, theme: this.state.theme }),
            _react2.default.createElement(
              _reactAddonsCssTransitionGroup2.default,
              { transitionName: this.state.current_move === 'forward' ? 'survey-page-top' : 'survey-page-bottom' },
              this.getPrePageContent()
            ),
            _react2.default.createElement(_components.SurveyFooter, {
              showBack: this.state.show_back,
              showNext: this.state.show_next,
              theme: this.state.theme,
              onNextClick: this.handleNextButtonClick.bind(this),
              onBackClick: this.handleBackButtonClick.bind(this),
              onSearchClick: this.handleSearchClickMobile.bind(this)
            })
          ) : null,
          !this.state.show_thankyou && this.state.location_id && this.state.survey_id && this.state.language_id && !this.state.start_survey ? _react2.default.createElement(_components.SurveyHome, {
            onStartSurvey: this.startSurvey.bind(this),
            params: this.props.params,
            clientLogoUrl: this.state.client_logo_url,
            showBranding: this.state.show_branding,
            theme: this.state.theme
          }) : null,
          !this.state.show_thankyou && this.state.location_id && this.state.survey_id && this.state.language_id && this.state.start_survey && !this.state.show_languages ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.SurveyHeader, { params: this.props.params, clientLogoUrl: this.state.client_logo_url, theme: this.state.theme }),
            _react2.default.createElement(_components.SurveyQuestions, {
              key: 'test',
              locationId: this.state.location_id,
              providerId: this.state.provider_id,
              surveyId: this.state.survey_id,
              params: this.props.params,
              onSubmit: this.onSurveySubmit.bind(this),
              previewMode: this.state.preview_mode,
              theme: this.state.theme
            })
          ) : null,
          this.state.show_thankyou ? _react2.default.createElement(_components.Thankyou, { code: this.state.audience_code,
            params: this.props.params,
            redirectFromThankyou: this.state.redirect_from_thankyou,
            showBranding: this.state.show_branding,
            clientLogoUrl: this.state.client_logo_url,
            previewMode: this.state.preview_mode,
            surveySubmitted: this.state.survey_submitted,
            theme: this.state.theme
          }) : null
        ) : ''
      )
    );
  };

  return Survey;
}(_react.Component), _class2.propTypes = {
  loadSurvey: _react.PropTypes.func,
  loadClient: _react.PropTypes.func,
  loadLanguages: _react.PropTypes.func,
  setLanguage: _react.PropTypes.func,
  loadLocations: _react.PropTypes.func,
  loadSurveys: _react.PropTypes.func,
  saveFeedback: _react.PropTypes.func,
  loadAudienceInfo: _react.PropTypes.func,

  params: _react.PropTypes.object,
  locations: _react.PropTypes.object,
  surveys: _react.PropTypes.object,
  survey: _react.PropTypes.object,
  clientDetails: _react.PropTypes.object,
  apiRouter: _react.PropTypes.object,
  location: _react.PropTypes.object,
  selectedLanguage: _react.PropTypes.string
}, _temp)) || _class);
exports.default = Survey;
module.exports = exports['default'];

/***/ }),

/***/ 2306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoPermission = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NoPermission, _Component);

  function NoPermission(props) {
    (0, _classCallCheck3.default)(this, NoPermission);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2307);
    return _this;
  }

  NoPermission.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.nopermission_container },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('i', { className: 'fa fa-info-circle' })
        ),
        'You don\'t have permission to access this page. Please contact the administrator!'
      )
    );
  };

  return NoPermission;
}(_react.Component), _class.propTypes = {}, _temp);
exports.default = NoPermission;
module.exports = exports['default'];

/***/ }),

/***/ 2307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"nopermission_container":"_1yOSJ6n1W-o12XYyXOKlOA"};

/***/ }),

/***/ 2308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _Grid = __webpack_require__(73);

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = __webpack_require__(69);

var _utilElement = __webpack_require__(91);

var _utilElement2 = __webpack_require__(91);

var _utilConstants = __webpack_require__(1099);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyHome = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SurveyHome, _Component);

  function SurveyHome(props) {
    (0, _classCallCheck3.default)(this, SurveyHome);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2309);
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop'
    };
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_PAGE_LOAD, _utilElement2.EVENT_PAGE_LOAD, 'Loading survey home page.');
    return _this;
  }

  SurveyHome.prototype.componentDidMount = function componentDidMount() {
    console.log(this.props.survey);
  };

  SurveyHome.prototype.startSurvey = function startSurvey() {
    var onStartSurvey = this.props.onStartSurvey;

    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_BTN_CLICK, _utilElement2.EVENT_BTN_CLICK, 'Start survey button clicked.');
    if (onStartSurvey) {
      this.props.onStartSurvey();
    }
  };

  SurveyHome.prototype.render = function render() {
    var survey = this.props.survey;

    var surveyStartTexts = (0, _utilElement.getSurveyStartTexts)();
    var defaultBackground = 'https://static.binaryfountain.com/feedback/v1/BinaryFountain-Survey-Default.jpg';
    var background = survey && survey.startSurveyPageBackground ? survey.startSurveyPageBackground : defaultBackground;
    var currentStartText = surveyStartTexts[this.props.selectedLanguage] ? surveyStartTexts[this.props.selectedLanguage] : surveyStartTexts.en;
    var surveyNameLength = survey && survey.name ? (0, _utilElement.getSurveyNameLength)(survey.name, this.props.selectedLanguage) : '';
    return _react2.default.createElement(
      _Grid2.default,
      null,
      _react2.default.createElement(
        _Row2.default,
        { style: { height: this.state.height, width: '100%', margin: '0px' }, id: 'survey_home_page' },
        _react2.default.createElement(
          _Col2.default,
          { md: 6, sm: 12, className: this.state.device_type === 'mobile' ? this.styles.survey_header_container_sm : this.styles.survey_header_container_md },
          _react2.default.createElement(
            'div',
            { className: this.styles.survey_header, style: { 'background': 'linear-gradient(134.72deg, rgba(48,35,174, 0.85), rgba(255,108,14, 0.85)), url(' + background + ')', 'backgroundRepeat': 'no-repeat', 'backgroundPosition': 'center', 'backgroundSize': 'contain' } },
            _react2.default.createElement(
              'div',
              { className: this.styles.survey_name },
              _react2.default.createElement(
                'div',
                { className: surveyNameLength > _utilConstants.SURVEY_NAME_SHORT_LENGTH ? this.styles.survey_name__long : this.styles.survey_name__short },
                _react2.default.createElement(
                  'span',
                  null,
                  (0, _utilElement.getTextForLanguage)(survey.name, this.props.selectedLanguage)
                )
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { sm: 12, xs: 12, lgHidden: true, mdHidden: true, className: this.styles.survey_description_sm },
              _react2.default.createElement(
                _Row2.default,
                { className: surveyNameLength > _utilConstants.SURVEY_NAME_SHORT_LENGTH ? this.styles.survey_description_sm_text__long : this.styles.survey_description_sm_text__short },
                _react2.default.createElement(
                  _Col2.default,
                  { className: this.styles.survey_description_text_sm + ' no_padding' },
                  _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _utilElement.getTextForLanguage)(survey.description, this.props.selectedLanguage) } })
                )
              )
            ),
            this.props.showBranding && _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(
                _Col2.default,
                { md: 12, smHidden: true, xsHidden: true },
                _react2.default.createElement(
                  'div',
                  { className: this.styles.copy_right_lg },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.powered_by },
                    'POWERED BY'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.powered_by_name },
                    _react2.default.createElement('img', { style: { width: '200px' }, src: 'https://cdn.consumerism.pressganey.com/pgforsta.png' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 6, sm: 12, className: this.state.device_type === 'mobile' ? this.styles.survey_desc_container_sm : this.styles.survey_desc_container_md },
          _react2.default.createElement(
            'div',
            { className: this.styles.survey_description },
            _react2.default.createElement(
              _Row2.default,
              { style: { marginTop: '0px', textAlign: 'center' } },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, mdHidden: true, lgHidden: true, className: this.styles.survey_button_sm },
                _react2.default.createElement(_mozart_ui.MozartButton, {
                  background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                  data: currentStartText,
                  title: currentStartText,
                  onClick: this.startSurvey.bind(this),
                  color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                  style: { height: '40px', paddingTop: '5px', border: '1px solid ' + this.props.theme.colorCode }
                })
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { style: { marginTop: '0px', textAlign: 'center' }, className: 'no_margin' },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, className: this.state.device_type === 'mobile' ? this.styles.client_logo_sm : this.styles.client_logo_md },
                _react2.default.createElement('img', { src: this.props.clientLogoUrl })
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { style: { maxHeight: '75%', overflow: 'auto' }, className: 'no_margin' },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, smHidden: true, xsHidden: true, className: this.styles.survey_description_text + ' no_padding' },
                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _utilElement.getTextForLanguage)(survey.description, this.props.selectedLanguage) } })
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { style: { bottom: '30px', position: 'fixed' } },
              _react2.default.createElement(
                _Col2.default,
                { md: 12, smHidden: true, xsHidden: true, className: this.styles.survey_button_lg },
                _react2.default.createElement(_mozart_ui.MozartButton, {
                  background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                  color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                  style: { height: '40px', paddingTop: '5px', border: '1px solid ' + this.props.theme.colorCode },
                  data: currentStartText,
                  onClick: this.startSurvey.bind(this)
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { sm: 12, mdHidden: true, lgHidden: true, className: 'no_padding' },
          _react2.default.createElement(
            'div',
            { className: this.styles.copy_right_sm },
            _react2.default.createElement(
              'div',
              { className: this.styles.powered_by },
              'POWERED BY ',
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement('img', { style: { width: '200px' }, src: 'https://cdn.consumerism.pressganey.com/pgforsta.png' })
              )
            )
          )
        )
      )
    );
  };

  return SurveyHome;
}(_react.Component), _class2.propTypes = {
  onStartSurvey: _react.PropTypes.func,
  getTextForLanguage: _react.PropTypes.func,
  clientLogoUrl: _react.PropTypes.string,
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  theme: _react.PropTypes.object,
  showBranding: _react.PropTypes.boolean,
  selectedLanguage: _react.PropTypes.string
}, _temp)) || _class);
exports.default = SurveyHome;
module.exports = exports['default'];

/***/ }),

/***/ 2309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"survey_header_container_md":"_2uoPXzcJEsiZ9Olk-q2PFQ","survey_desc_container_md":"_3MeC3OrX_Oowp-DelUBL4H","survey_header_container_sm":"_3K-UGviULC9HvnyiB5V2rS","survey_desc_container_sm":"_3xlcRUNs9EgtNkL8u3gfO2","survey_header":"_2zQRHob2fxBnvybabITgA","survey_name":"_1GzmUBdtfIXUDjvOrSPaT2","survey_name__long":"_3zb7axL7yaTk0kgNEA8wrE","survey_name__short":"_1GRs8EDPljIcWtxpTrYIAx","copy_right_sm":"_3WZBkZAj0UHH4m79nU5hR7","powered_by":"_3dUAWPwJINylLQjLuYYWKd","powered_by_name":"_1JQHo4dyJXraUEYtgyOqsh","copy_right_lg":"_2-fIzTx3sRG6_KeTJgvTA1","survey_description":"_2UuMXMYChf8z2diyTszHVu","survey_description_sm":"_10QFbAkMYeiAQ2GwH1eHYp","survey_description_sm_text__short":"_3YNszB7QwuFPkO_SPNePD3","survey_description_sm_text__long":"_1Paa24-XnDMzDn2H7EsVkZ","survey_description_text":"_2Sdu2RZxhnyKEnKC0DZ36o","survey_description_text_sm":"_2CjB8QRC7khXpXuayQsD2Y","survey_button_lg":"_1hnHrE8iiHMF4fKOXHjV-A","survey_button_sm":"_1cL7oPhNDnUAO3-q_goow0","client_logo_sm":"xoEZlOooDS7APD2PZcVew","client_logo_md":"_2b8c-PD1RALS7vnuZ_08RT"};

/***/ }),

/***/ 2310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _typeof2 = __webpack_require__(177);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _redux = __webpack_require__(101);

var _Grid = __webpack_require__(73);

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = __webpack_require__(69);

var _components = __webpack_require__(200);

var _reactAddonsCssTransitionGroup = __webpack_require__(1100);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactMobileDatepicker = __webpack_require__(2322);

var _reactMobileDatepicker2 = _interopRequireDefault(_reactMobileDatepicker);

var _momentTimezone = __webpack_require__(498);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _utilElement = __webpack_require__(91);

var _survey = __webpack_require__(179);

var _utilElement2 = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyQuestions = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage,
    createdAudienceInfo: state.survey.createdAudienceInfo,
    audienceInfo: state.survey.audienceInfo
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ createAudience: _survey.createAudience }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SurveyQuestions, _Component);

  function SurveyQuestions(props) {
    (0, _classCallCheck3.default)(this, SurveyQuestions);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.handleDatePickerClick = function () {
      _this.setState({ is_datepicker_open: true });
    };

    _this.handleDatePickerCancel = function () {
      _this.setState({ is_datepicker_open: false });
    };

    _this.handleDatePickerSelect = function (time) {
      _this.setState({ is_datepicker_open: false }, function () {
        _this.setData(1, (0, _momentTimezone2.default)(time).format('MM-DD-YYYY'));
        document.getElementById('date_box_mobile_' + _this.state.sequence_no).value = (0, _momentTimezone2.default)(time).format('MM-DD-YYYY');
      });
    };

    _this.styles = __webpack_require__(2325);
    _this.state = {
      current_move: 'forward',
      sequence_no: 1,
      page_no: 1,
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop',
      feedback_data: {},
      current_question: {},
      is_datepicker_open: false,
      disable_next: false,
      current_question_instruction: false,
      anonymous_survey: false,
      show_anonymous_dialog: false
    };
    _this.eval = eval;
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_PAGE_LOAD, _utilElement2.EVENT_PAGE_LOAD, 'Loading survey questions page.');
    return _this;
  }

  SurveyQuestions.prototype.componentDidMount = function componentDidMount() {
    var clientId = this.props.params.clientId;
    var audienceCode = this.props.params.code;
    var sourceId = this.props.surveyId;
    var self = this;
    setTimeout(function clbk() {
      self.setMarginTop();
    }, 100);
    if (!this.props.createdAudienceInfo && this.props.survey.enableRedirection && audienceCode && !this.props.previewMode && !this.props.audienceInfo.data.hasSurveySubmitted) {
      this.props.createAudience(clientId, { parentCode: audienceCode, sourceId: sourceId });
    }
  };

  SurveyQuestions.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    console.log('componenent updated' + prevProps + prevState);
    //     this.setFocus();
    this.setMarginTop();
  };

  SurveyQuestions.prototype.setMarginTop = function setMarginTop() {
    var questionComponentHeight = document.getElementById('survey_questions_options_wrapper').offsetHeight;
    var screenHeight = this.state.height;
    var constantHeight = 110 + 60;
    var availableHeight = screenHeight - constantHeight;
    var fit = availableHeight - questionComponentHeight;
    if (fit < 0) {
      document.getElementById('survey_questions_options_wrapper').style.marginTop = '0px';
    } else {
      document.getElementById('survey_questions_options_wrapper').style.marginTop = Math.ceil(fit / 2) + 'px';
    }
  };

  SurveyQuestions.prototype.getActivePageNumber = function getActivePageNumber() {
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_SET_DATA, _utilElement2.EVENT_SET_DATA, 'Currrent page number : ' + this.state.page_no);
    var style = { color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff', backgroundColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#fff', borderColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#fff' };
    return _react2.default.createElement(
      'div',
      { className: this.styles.sequence_no },
      _react2.default.createElement(
        'span',
        { className: this.styles.sequence_number, style: style },
        this.state.page_no
      )
    );
  };

  SurveyQuestions.prototype.getLogicalOperator = function getLogicalOperator(operatorString) {
    var operator = false;
    switch (operatorString) {
      case 'and':
        operator = '&&';
        break;
      case 'or':
        operator = '||';
        break;
      default:
        operator = false;
        break;
    }
    return operator;
  };

  SurveyQuestions.prototype.getConstraint = function getConstraint(constraintString) {
    var operator = false;
    switch (constraintString) {
      case 'option_eq':
        operator = '===';
        break;
      case 'option_ne':
        operator = '!==';
        break;
      default:
        operator = false;
        break;
    }
    return operator;
  };

  SurveyQuestions.prototype.getInstruction = function getInstruction() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.instruction_container },
      this.state.current_question_instruction && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          this.state.current_question_instruction
        ),
        _react2.default.createElement('div', { className: this.styles.instruction_seperator })
      )
    );
  };

  SurveyQuestions.prototype.getQuestion = function getQuestion() {
    var questions = this.props.survey.questionGroups;
    var currentQuestionTitle = '';
    if (questions && questions.length > 0) {
      if (questions[this.state.sequence_no - 1] !== undefined) {
        if (questions[this.state.sequence_no - 1].type === 'Question') {
          // For single question
          var sequenceQuestion = questions[this.state.sequence_no - 1].questions[0];
          if (!sequenceQuestion.rule) {
            // If no rule is applicable, set the question
            currentQuestionTitle = (0, _utilElement.getTextForLanguage)(sequenceQuestion.title, this.props.selectedLanguage);
            this.state.current_question = sequenceQuestion;
            this.state.current_question_instruction = sequenceQuestion.instruction ? (0, _utilElement.getTextForLanguage)(sequenceQuestion.instruction, this.props.selectedLanguage) : false;
          } else {
            // If rule is applicable
            if (this.checkRule(sequenceQuestion)) {
              // if rule is passed, then set the question
              currentQuestionTitle = (0, _utilElement.getTextForLanguage)(sequenceQuestion.title, this.props.selectedLanguage);
              this.state.current_question = sequenceQuestion;
              this.state.current_question_instruction = sequenceQuestion.instruction ? (0, _utilElement.getTextForLanguage)(sequenceQuestion.instruction, this.props.selectedLanguage) : false;
            } else {
              // If rule failed, go for next question
              if (this.state.current_move === 'forward') {
                this.setNextButtonClick(false);
              } else {
                this.setBackButtonClick(false);
              }
            }
          }
          this.state.current_question.questionGroup = false;
        } else {
          // For group question
          currentQuestionTitle = (0, _utilElement.getTextForLanguage)(questions[this.state.sequence_no - 1].title, this.props.selectedLanguage);
          this.state.current_question = questions[this.state.sequence_no - 1];
          this.state.current_question.questionGroup = true;
          this.state.current_question_instruction = questions[this.state.sequence_no - 1].instruction ? (0, _utilElement.getTextForLanguage)(questions[this.state.sequence_no - 1].instruction, this.props.selectedLanguage) : false;
        }
      } else {
        console.error('Sequence no ' + this.state.sequence_no - 1 + ' is not availabale');
      }
    }
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.instruction_container },
        this.state.current_question_instruction && _react2.default.createElement(
          'div',
          { 'data-qa-type': 'instructions' },
          _react2.default.createElement(
            'span',
            null,
            this.state.current_question_instruction
          ),
          _react2.default.createElement('div', { className: this.styles.instruction_seperator })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: this.styles.question_container },
        _react2.default.createElement(
          'span',
          null,
          currentQuestionTitle
        )
      )
    );
  };

  SurveyQuestions.prototype.setData = function setData(optionId, optionName, questionId) {
    //     const currentQuestion = this.props.surveyprops.survey.questionGroupssequence_no - 1];
    var currentQuestionId = 0;
    if (questionId && (typeof questionId === 'undefined' ? 'undefined' : (0, _typeof3.default)(questionId)) !== 'object') {
      currentQuestionId = questionId;
      this.state.feedback_data[questionId] = { optionId: optionId, response: optionName ? optionName : '' };
    } else {
      var currentQuestion = this.state.current_question;
      currentQuestionId = currentQuestion.id;
      this.state.feedback_data[currentQuestion.id] = { optionId: optionId, response: optionName ? optionName : '' };
    }
    //     if (this.isAutoSkippableQuestion()) {
    //       this.setState({feedback_data: this.state.feedback_data}, () => {
    //         setTimeout( () => {
    //           this.setState({sequence_no: this.state.sequence_no + 1});
    //         }, 1000);
    //       });
    //     } else {
    this.setState({ feedback_data: this.state.feedback_data });
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_SET_DATA, _utilElement2.EVENT_SET_DATA, 'Answering question : ' + currentQuestionId + ' option id : ' + optionId + ' option name : ' + optionName);
    //     }
  };

  SurveyQuestions.prototype.getSingleSelectRatingButtons = function getSingleSelectRatingButtons(options) {
    var _this2 = this;

    // const options = [{id: 1, score: 1, name: {en: '1'}}, {id: 2, score: 2, name: {en: '2'}}, {id: 3, score: 3, name: {en: '3'}}, {id: 4, score: 4, name: {en: '4'}}, {id: 5, score: 5, name: {en: '5'}}, {id: 6, score: 6, name: {en: '6'}}, {id: 7, score: 7, name: {en: '7'}}, {id: 8, score: 8, name: {en: '8'}}, {id: 9, score: 9, name: {en: '9'}}, {id: 10, score: 10, name: {en: '10'}}];
    var component = [];
    var leftlabel = '';
    var rightlabel = '';
    var style = {
      display: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 ? '-webkit-flex' : 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '-webkitAlignTtems': 'center',
      '-webkitJustifyContent': 'center',
      color: '#4A4A4A',
      fontSize: '16px',
      border: 'none'
    };
    var selectedStyle = {
      display: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 ? '-webkit-flex' : 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '-webkitAlignTtems': 'center',
      '-webkitJustifyContent': 'center',
      color: '#ffffff',
      fontSize: '16px',
      boxSizing: 'border-box',
      border: '2px solid #FFFFFF',
      background: 'linear-gradient(180deg, #FCA74F 0%, #F76E27 100%)',
      boxShadow: '0 4px 7px -5px rgba(0,0,0,0.5)'
    };
    if (options) {
      var reversedOptions = options.slice().reverse();
      reversedOptions.map(function (item, index) {
        // const optionLabel = item.name[this.props.selectedLanguage];
        component.push(_react2.default.createElement(_mozart_ui.MozartIcon, {
          height: _this2.state.device_type === 'mobile' ? '30px' : '36px',
          width: _this2.state.device_type === 'mobile' ? '30px' : '36px',
          style: _this2.state.feedback_data[_this2.state.current_question.id] && _this2.state.feedback_data[_this2.state.current_question.id].optionId === item.id ? selectedStyle : style,
          hoverColor: 'white',
          data: index + 1,
          onClick: _this2.setData.bind(_this2, item.id, (0, _utilElement.getTextForLanguage)(options.find(function (current) {
            return current.id === item.id;
          }).name, _this2.props.selectedLanguage))
        }));
      });
    }
    rightlabel = (0, _utilElement.getTextForLanguage)(options[0].name, this.props.selectedLanguage);
    leftlabel = (0, _utilElement.getTextForLanguage)(options[options.length - 1].name, this.props.selectedLanguage);
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.single_select_rating_button_label },
        _react2.default.createElement(
          'div',
          null,
          leftlabel
        ),
        _react2.default.createElement(
          'div',
          null,
          rightlabel
        )
      ),
      _react2.default.createElement(
        'div',
        { className: this.styles.single_select_rating_button_container, 'data-qa-type': 'single_select_rating_container' },
        component
      )
    );
  };

  SurveyQuestions.prototype.getDatePicker = function getDatePicker() {
    var _this3 = this;

    var component = [];
    var dateVal = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response ? (0, _momentTimezone2.default)(this.state.feedback_data[this.state.current_question.id].response, 'MM-DD-YYYY').format('MM-DD-YYYY') : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY');
    if (this.state.device_type === 'mobile') {
      component.push(_react2.default.createElement(
        'div',
        { className: this.styles.datepicker_container },
        _react2.default.createElement(_mozart_ui.MozartTextBox, {
          style: { border: '1px solid ' + this.props.theme.colorCode, height: '36px' },
          ref: 'date_box_mobile',
          id: 'date_box_mobile_' + this.state.sequence_no,
          className: 'comment_textarea',
          name: 'date_box_mobile_' + this.state.sequence_no,
          multiLine: false,
          key: dateVal,
          validationBool: false,
          multipleLineArea: false,
          onChange: this.dateChange.bind(this),
          onBlur: this.dateBlur.bind(this),
          hintText: 'MM-DD-YYYY',
          value: dateVal,
          icon: _react2.default.createElement('span', { className: 'icon-Calendar', onClick: function onClick() {
              _this3.handleDatePickerClick();
              if (_this3.refs['date_picker_mobile_' + _this3.state.sequence_no]) {
                _this3.refs['date_picker_mobile_' + _this3.state.sequence_no].focus();
              }
            } })
        }),
        _react2.default.createElement(_reactMobileDatepicker2.default, {
          ref: 'date_picker_mobile_' + this.state.sequence_no,
          value: new Date(dateVal.split('-').join('/'))
          // value={new Date()}
          , isOpen: this.state.is_datepicker_open,
          onSelect: this.handleDatePickerSelect,
          onCancel: this.handleDatePickerCancel,
          confirmText: 'Ok',
          cancelText: 'Cancel'
        })
      ));
    } else {
      component.push(_react2.default.createElement(
        'div',
        { className: this.styles.datepicker_container },
        _react2.default.createElement(_components.DatePickerWeb, { key: dateVal, value: dateVal, onChange: function onChange(selectedDate) {
            _this3.setData(1, selectedDate);
          } })
      ));
    }
    return _react2.default.createElement(
      'div',
      { style: { width: '100%' }, 'data-qa-type': 'datepicker_container' },
      component
    );
  };

  SurveyQuestions.prototype.getSingleSelectSlider = function getSingleSelectSlider(options) {
    var _this4 = this;

    // const options = [{id: 1, score: 1, name: {en: '1'}}, {id: 2, score: 2, name: {en: '2'}}, {id: 3, score: 3, name: {en: '3'}}, {id: 4, score: 4, name: {en: '4'}}, {id: 5, score: 5, name: {en: '5'}}, {id: 6, score: 6, name: {en: '6'}}, {id: 7, score: 7, name: {en: '7'}}, {id: 8, score: 8, name: {en: '8'}}, {id: 9, score: 9, name: {en: '9'}}, {id: 10, score: 10, name: {en: '10'}}];
    var defaultValue = null;
    defaultValue = options.filter(function (item) {
      return item.defaultOption;
    });
    if (defaultValue.length > 0 && !this.state.feedback_data[this.state.current_question.id]) {
      this.setData(defaultValue[0].id, (0, _utilElement.getTextForLanguage)(defaultValue[0].name, this.props.selectedLanguage));
    }
    var component = [];
    component.push(_react2.default.createElement(_components.MozartSlider, {
      min: options[0].id,
      max: options[options.length - 1].id,
      step: 1,
      labels: [(0, _utilElement.getTextForLanguage)(options[0].name, this.props.selectedLanguage), (0, _utilElement.getTextForLanguage)(options[options.length - 1].name, this.props.selectedLanguage)],
      value: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId !== undefined && this.state.feedback_data[this.state.current_question.id].optionId !== null ? this.state.feedback_data[this.state.current_question.id].optionId : options[options.length - 1].id,
      onChange: function onChange(selectedItem) {
        _this4.setData(selectedItem, (0, _utilElement.getTextForLanguage)(options.find(function (current) {
          return current.id === selectedItem;
        }).name, _this4.props.selectedLanguage));
      }
    }));
    return _react2.default.createElement(
      'div',
      { style: { width: '100%' }, 'data-qa-type': 'single_select_slider_container' },
      component
    );
  };

  SurveyQuestions.prototype.getStarRating = function getStarRating(options) {
    var _this5 = this;

    // const options = [{id: 1, score: 1, name: {en: '1'}}, {id: 2, score: 2, name: {en: '2'}}, {id: 3, score: 3, name: {en: '3'}}, {id: 4, score: 4, name: {en: '4'}}, {id: 5, score: 5, name: {en: '5'}}, {id: 6, score: 6, name: {en: '6'}}, {id: 7, score: 7, name: {en: '7'}}, {id: 8, score: 8, name: {en: '8'}}, {id: 9, score: 9, name: {en: '9'}}, {id: 10, score: 10, name: {en: '10'}}];
    var component = [];
    component.push(_react2.default.createElement(_mozart_ui.MozartStarRating, {
      interactive: true,
      stars: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId ? this.state.feedback_data[this.state.current_question.id].optionId : 0,
      leftLabel: (0, _utilElement.getTextForLanguage)(options[0].name, this.props.selectedLanguage),
      rightLabel: (0, _utilElement.getTextForLanguage)(options[options.length - 1].name, this.props.selectedLanguage),
      onChange: function onChange(selectedItem) {
        _this5.setData(selectedItem, (0, _utilElement.getTextForLanguage)(options.find(function (current) {
          return current.id === selectedItem;
        }).name, _this5.props.selectedLanguage));
      }
    }));
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'star_rating_container', className: this.styles.star_rating_container },
      component
    );
  };

  SurveyQuestions.prototype.getRadioButtons = function getRadioButtons(options) {
    var _this6 = this;

    var component = [];
    if (options) {
      options.map(function (item, index) {
        var optionLabel = (0, _utilElement.getTextForLanguage)(item.name, _this6.props.selectedLanguage);
        component.push(_react2.default.createElement(
          'div',
          { 'data-qa-type': 'radiobutton_item' },
          _react2.default.createElement(
            _mozart_ui.MozartRadio,
            null,
            _react2.default.createElement('input', {
              ref: 'radio_' + _this6.state.sequence_no + '_' + index,
              type: 'radio',
              id: 'radio_' + _this6.state.sequence_no + '_' + index,
              key: Math.random(),
              name: 'radio_' + _this6.state.sequence_no,
              onChange: _this6.setData.bind(_this6, item.id, optionLabel),
              defaultValue: item.id,
              checked: _this6.state.feedback_data[_this6.state.current_question.id] && _this6.state.feedback_data[_this6.state.current_question.id].optionId === item.id ? true : false
            }),
            _react2.default.createElement(
              'label',
              { style: { marginRight: '10px' }, htmlFor: 'radio_' + _this6.state.sequence_no + '_' + index, title: optionLabel },
              optionLabel
            )
          )
        ));
      });
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'radiobutton_container' },
      component
    );
  };

  SurveyQuestions.prototype.getGroupQuestionOptions = function getGroupQuestionOptions(question, options) {
    var _this7 = this;

    var optionComponent = [];
    options.map(function (item) {
      if (_this7.state.current_question.renderType === 'Single Select') {
        optionComponent.push(_react2.default.createElement(
          'div',
          { className: _this7.styles.group_question_item_option, onClick: _this7.setData.bind(_this7, item.id, (0, _utilElement.getTextForLanguage)(item.name, _this7.props.selectedLanguage), question) },
          _react2.default.createElement(
            'div',
            { className: _this7.styles.group_question_item_option_text },
            (0, _utilElement.getTextForLanguage)(item.name, _this7.props.selectedLanguage)
          ),
          _react2.default.createElement(
            'div',
            { className: _this7.styles.group_question_item_option_radio },
            _react2.default.createElement(
              'div',
              { 'data-qa-type': 'radiobutton_item', style: { float: 'right', width: '100%' } },
              _react2.default.createElement(
                _mozart_ui.MozartRadio,
                { style: { textAlign: 'right' } },
                _react2.default.createElement('input', {
                  ref: 'radio_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                  type: 'radio',
                  id: 'radio_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                  key: Math.random(),
                  name: 'radio_' + _this7.state.sequence_no + '_' + question,
                  onChange: _this7.setData.bind(_this7, item.id, (0, _utilElement.getTextForLanguage)(item.name, _this7.props.selectedLanguage), question),
                  defaultValue: item.id,
                  checked: _this7.state.feedback_data[question] && _this7.state.feedback_data[question].optionId === item.id ? true : false
                }),
                _react2.default.createElement('label', { style: { marginRight: '10px' }, htmlFor: 'radio_' + _this7.state.sequence_no + '_' + question + '_' + item.id, title: 'radio' })
              )
            )
          )
        ));
      } else {
        optionComponent.push(_react2.default.createElement(
          'div',
          { className: _this7.styles.group_question_item_option },
          _react2.default.createElement(
            'div',
            { className: _this7.styles.group_question_item_option_textbox },
            _react2.default.createElement(
              'div',
              { 'data-qa-type': 'radiobutton_item', style: { float: 'right', width: '100%' } },
              _react2.default.createElement(_mozart_ui.MozartTextBox, {
                ref: 'textbox_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                id: 'textbox_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                multiLine: false,
                validationBool: false,
                key: 'textbox_' + _this7.state.sequence_no,
                value: _this7.state.feedback_data[question] && _this7.state.feedback_data[question].response,
                onChange: function onChange(value) {
                  _this7.setData(1, value, question);
                },
                name: 'textbox_' + _this7.state.sequence_no + '_' + question + '_' + item.id,
                limit: 500
              })
            )
          )
        ));
      }
    });
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'options_container' },
      optionComponent
    );
  };

  SurveyQuestions.prototype.getGroupQuestionColumnComponents = function getGroupQuestionColumnComponents(question, options) {
    var _this8 = this;

    var optionComponent = [];
    options.map(function (item) {
      if (_this8.state.current_question.renderType === 'Single Select') {
        optionComponent.push(_react2.default.createElement(
          _Col2.default,
          { md: 2, lg: 2, style: { width: 75 / options.length + '%' }, className: _this8.styles.group_question_item_option_radio },
          _react2.default.createElement(
            'div',
            { 'data-qa-type': 'radiobutton_item' },
            _react2.default.createElement(
              _mozart_ui.MozartRadio,
              { style: { textAlign: 'center' } },
              _react2.default.createElement('input', {
                ref: 'radio_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
                type: 'radio',
                id: 'radio_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
                key: Math.random(),
                name: 'radio_' + _this8.state.sequence_no + '_' + question,
                onChange: _this8.setData.bind(_this8, item.id, (0, _utilElement.getTextForLanguage)(item.name, _this8.props.selectedLanguage), question),
                defaultValue: item.id,
                checked: _this8.state.feedback_data[question] && _this8.state.feedback_data[question].optionId === item.id ? true : false
              }),
              _react2.default.createElement('label', { style: { marginRight: '10px' }, htmlFor: 'radio_' + _this8.state.sequence_no + '_' + question + '_' + item.id, title: (0, _utilElement.getTextForLanguage)(item.name, _this8.props.selectedLanguage) })
            )
          )
        ));
      } else {
        optionComponent.push(_react2.default.createElement(
          _Col2.default,
          { md: 2, lg: 2, className: _this8.styles.group_question_item_option_textbox },
          _react2.default.createElement(
            'div',
            { 'data-qa-type': 'radiobutton_item' },
            _react2.default.createElement(_mozart_ui.MozartTextBox, {
              ref: 'textbox_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
              id: 'textbox_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
              multiLine: false,
              validationBool: false,
              key: 'textbox_' + _this8.state.sequence_no,
              value: _this8.state.feedback_data[question] && _this8.state.feedback_data[question].response,
              onChange: function onChange(value) {
                _this8.setData(1, value, question);
              },
              name: 'textbox_' + _this8.state.sequence_no + '_' + question + '_' + item.id,
              limit: 500
            })
          )
        ));
      }
    });
    return optionComponent;
  };

  SurveyQuestions.prototype.getGroupQuestion = function getGroupQuestion() {
    var _this9 = this;

    var component = [];
    var questionComponent = [];
    var currentQuestion = this.state.current_question;
    var groupQuestions = currentQuestion.questions;
    var options = currentQuestion.options;
    //     const groupQuestions = [{'id': 1000006601, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}, {'id': 1000006602, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}, {'id': 1000006603, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}, {'id': 1000006604, 'sequenceNo': 1, 'title': {'en': 'You Consulted: '}, 'type': 'Single Choice (Radio)', 'renderType': 'Single Select', 'description': {'en': ''}, 'groupTitle': {'en': ''}, 'required': false, 'rule': null, 'options': [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}], 'isPhi': false, 'category': null}];
    //     const options = [{'id': 1, 'type': null, 'name': {'en': 'Provider'}, 'categoryId': 0}, {'id': 2, 'type': null, 'name': {'en': 'Nurse Only'}, 'categoryId': 0}, {'id': 3, 'type': null, 'name': {'en': 'Lab Only'}, 'categoryId': 0}, {'id': 4, 'type': null, 'name': {'en': 'EMG Only'}, 'categoryId': 0}, {'id': 5, 'type': null, 'name': {'en': 'Dressing Change Only'}, 'categoryId': 0}];
    if (this.state.device_type === 'mobile') {
      groupQuestions.map(function (item) {
        if (!item.rule) {
          questionComponent.push(_react2.default.createElement(
            'div',
            { className: _this9.styles.group_question_item },
            _react2.default.createElement(
              'div',
              { className: _this9.styles.group_question_item_question },
              (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
            ),
            _react2.default.createElement(
              'div',
              { className: _this9.styles.group_question_item_option_container },
              _this9.getGroupQuestionOptions(item.id, item.options)
            )
          ));
        } else {
          if (_this9.checkRule(item)) {
            // if rule is passed, then set the question
            questionComponent.push(_react2.default.createElement(
              'div',
              { className: _this9.styles.group_question_item },
              _react2.default.createElement(
                'div',
                { className: _this9.styles.group_question_item_question },
                (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
              ),
              _react2.default.createElement(
                'div',
                { className: _this9.styles.group_question_item_option_container },
                _this9.getGroupQuestionOptions(item.id, item.options)
              )
            ));
          }
        }
      });
      if (!questionComponent.length) {
        if (this.state.current_move === 'forward') {
          this.setNextButtonClick(false);
        } else {
          this.setBackButtonClick(false);
        }
      } else {
        component.push(_react2.default.createElement(
          'div',
          { className: this.styles.group_question_container },
          questionComponent
        ));
      }
    } else {
      var optionsColumns = [];
      options.map(function (item) {
        optionsColumns.push(_react2.default.createElement(
          _Col2.default,
          { sm: 2, md: 2, lg: 2, style: { width: 75 / options.length + '%' } },
          (0, _utilElement.getTextForLanguage)(item.name, _this9.props.selectedLanguage)
        ));
      });
      var optionsRow = _react2.default.createElement(
        _Row2.default,
        { className: this.styles.group_question_item_option_container },
        _react2.default.createElement(_Col2.default, { sm: 2, md: 2, lg: 2, style: { width: '25%' } }),
        optionsColumns
      );
      var questionRows = [];
      groupQuestions.map(function (item) {
        if (!item.rule) {
          questionRows.push(_react2.default.createElement(
            _Row2.default,
            { className: _this9.styles.group_question_item },
            _react2.default.createElement(
              _Col2.default,
              { sm: 2, md: 2, lg: 2, style: { width: '25%' }, className: _this9.state.current_question.renderType === 'Single Select' ? _this9.styles.group_question_item_question : _this9.styles.group_question_item_question_large },
              (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
            ),
            _this9.getGroupQuestionColumnComponents(item.id, item.options)
          ));
        } else {
          if (_this9.checkRule(item)) {
            // if rule is passed, then set the question
            questionRows.push(_react2.default.createElement(
              _Row2.default,
              { className: _this9.styles.group_question_item },
              _react2.default.createElement(
                _Col2.default,
                { sm: 2, md: 2, lg: 2, style: { width: '25%' }, className: _this9.state.current_question.renderType === 'Single Select' ? _this9.styles.group_question_item_question : _this9.styles.group_question_item_question_large },
                (0, _utilElement.getTextForLanguage)(item.title, _this9.props.selectedLanguage)
              ),
              _this9.getGroupQuestionColumnComponents(item.id, item.options)
            ));
          }
        }
      });
      //       component.push({optionsRow});
      //       component.push({questionRows});
      if (!questionRows.length) {
        if (this.state.current_move === 'forward') {
          this.setNextButtonClick(false);
        } else {
          this.setBackButtonClick(false);
        }
      } else {
        component.push(_react2.default.createElement(
          'div',
          { className: this.styles.group_question_container },
          this.state.current_question.renderType === 'Single Select' && optionsRow,
          questionRows
        ));
      }
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'groupquestion_container', style: { width: '100%' } },
      component
    );
  };

  SurveyQuestions.prototype.setMultipleChoiceData = function setMultipleChoiceData(elem) {
    var selectedItem = elem.id;
    var currentDataOptions = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId;
    var currentDataResponses = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response;
    if (currentDataOptions && currentDataOptions.indexOf(selectedItem) !== -1) {
      var index = currentDataOptions.indexOf(selectedItem);
      currentDataOptions.splice(index, 1);
      currentDataResponses.splice(index, 1);
      if (currentDataOptions.length === 0) {
        currentDataOptions = undefined;
        currentDataResponses = undefined;
      }
    } else {
      if (!currentDataOptions) {
        currentDataOptions = [];
        currentDataResponses = [];
      }
      currentDataOptions.push(selectedItem);
      currentDataResponses.push((0, _utilElement.getTextForLanguage)(elem.name, this.props.selectedLanguage));
    }
    this.setData(currentDataOptions, currentDataResponses);
  };

  SurveyQuestions.prototype.getCheckBox = function getCheckBox(options) {
    var _this10 = this;

    var component = [];
    if (options) {
      options.map(function (item, index) {
        var optionLabel = (0, _utilElement.getTextForLanguage)(item.name, _this10.props.selectedLanguage);
        component.push(_react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 6, lg: 6, 'data-qa-type': 'checkbox_item', onClick: _this10.setMultipleChoiceData.bind(_this10, item) },
          _react2.default.createElement(
            _mozart_ui.MozartCheckBox,
            { border: _this10.state.device_type === 'mobile' },
            _react2.default.createElement('input', {
              ref: 'checkbox_' + _this10.state.sequence_no + '_' + index,
              type: 'checkbox',
              id: 'checkbox_' + _this10.state.sequence_no + '_' + index,
              name: 'checkbox_' + _this10.state.sequence_no,
              onChange: _this10.setMultipleChoiceData.bind(_this10, item),
              checked: _this10.state.feedback_data[_this10.state.current_question.id] && _this10.state.feedback_data[_this10.state.current_question.id].optionId && _this10.state.feedback_data[_this10.state.current_question.id].optionId.indexOf(item.id) !== -1 ? true : false
            }),
            _react2.default.createElement(
              'label',
              { style: { marginRight: '10px' }, htmlFor: 'checkbox_' + _this10.state.sequence_no + '_' + index, title: 'checkbox' },
              optionLabel
            )
          )
        ));
      });
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'checkbox_container' },
      component
    );
  };

  SurveyQuestions.prototype.getTextArea = function getTextArea() {
    var _this11 = this;

    var component = [];
    component.push(_react2.default.createElement(_mozart_ui.MozartTextBox, {
      style: { border: '1px solid ' + this.props.theme.colorCode },
      ref: 'textarea_' + this.state.sequence_no,
      id: 'textarea_' + this.state.sequence_no,
      className: 'comment_textarea',
      name: 'textarea_' + this.state.sequence_no,
      key: 'textarea_' + this.state.sequence_no,
      multiLine: true,
      validationBool: false,
      value: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response,
      onChange: function onChange(value) {
        _this11.setData(1, value);
      }
    }));
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'textarea_container', className: this.styles.textarea_container },
      component
    );
  };

  SurveyQuestions.prototype.getErrorText = function getErrorText(value, validation) {
    var errorText = '';
    var currentQuestion = this.state.current_question;
    var isRequired = !currentQuestion.questionGroup ? currentQuestion.required : false;

    if (validation === 'email' && value && !this.validateEmail(value)) {
      errorText = 'Invalid email address';
    }
    if (validation === 'phone' && value && !this.validatePhone(value)) {
      errorText = 'Invalid phone number';
    }
    if (errorText !== '' && isRequired) {
      this.state.disable_next = true;
    } else if (errorText === '') {
      this.state.disable_next = false;
    }
    return errorText;
  };

  SurveyQuestions.prototype.getTextField = function getTextField(validation) {
    var _this12 = this;

    var component = [];
    var currentValue = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response;

    component.push(_react2.default.createElement(
      'div',
      { className: this.styles.textfield_container },
      _react2.default.createElement(_mozart_ui.MozartTextBox, {
        style: { border: '1px solid ' + this.props.theme.colorCode },
        ref: 'textbox_' + this.state.sequence_no,
        id: 'textbox_' + this.state.sequence_no,
        multiLine: false,
        validationBool: false,
        validateEmail: validation === 'email' ? true : false,
        validatePhone: validation === 'phone' ? true : false,
        validateNumeric: validation === 'number' ? true : false,
        key: 'textbox_' + this.state.sequence_no,
        value: currentValue,
        onChange: function onChange(value) {
          _this12.setData(1, value);
        },
        name: !validation ? 'textbox_' + this.state.sequence_no : validation,
        limit: 100
      }),
      validation && _react2.default.createElement(
        'span',
        { className: this.styles.errorText },
        this.getErrorText(currentValue, validation)
      )
    ));
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'textfield_container' },
      component
    );
  };

  SurveyQuestions.prototype.getDropDown = function getDropDown(options) {
    var _this13 = this;

    var component = [];
    var selectOptions = [];
    var defaultValue = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId;

    if (options) {
      options.map(function (item) {
        var optionLabel = (0, _utilElement.getTextForLanguage)(item.name, _this13.props.selectedLanguage);
        var optionValue = item.id;
        selectOptions.push({ id: optionValue, value: optionValue, text: optionLabel });
      });
      if (this.props.providerId && !defaultValue && this.state.current_question.type === 'Physician (Radio)') {
        var tempSelected = selectOptions.find(function (current) {
          return current.id === parseInt(_this13.props.providerId, 10);
        });
        if (tempSelected) {
          this.state.feedback_data[this.state.current_question.id] = { optionId: parseInt(this.props.providerId, 10), response: tempSelected.text };
          this.setData(parseInt(this.props.providerId, 10), tempSelected.text);
          defaultValue = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId;
        }
      }
      component.push(_react2.default.createElement(_mozart_ui.MozartSelectField, {
        onChange: function onChange(selectedItem) {
          _this13.setData(selectedItem, selectOptions.find(function (current) {
            return current.id === selectedItem;
          }).text);
        },
        data: selectOptions,
        dropdown: 'dropdownClass',
        defaultValue: defaultValue,
        key: this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].optionId
      }));
    }
    return _react2.default.createElement(
      'div',
      { 'data-qa-type': 'dropdown_container', className: this.styles.dropdown_container },
      component
    );
  };

  SurveyQuestions.prototype.getComponent = function getComponent(type, options) {
    var component = [];
    switch (type) {
      case 'NPS':
        component.push(this.getSingleSelectRatingButtons(options));
        break;
      case 'Single Select':
        component.push(this.getRadioButtons(options));
        break;
      case 'Checkbox':
        component.push(this.getCheckBox(options));
        break;
      case 'Text Area':
        component.push(this.getTextArea(options));
        break;
      case 'Text Box':
        component.push(this.getTextField(false));
        break;
      case 'Slider':
      case 'Number Slider':
        component.push(this.getSingleSelectSlider(options));
        break;
      case 'Email':
        component.push(this.getTextField('email'));
        break;
      case 'Phone':
        component.push(this.getTextField('phone'));
        break;
      case 'Number':
        component.push(this.getTextField('number'));
        break;
      case 'Dropdown':
        component.push(this.getDropDown(options));
        break;
      case 'Date':
        component.push(this.getDatePicker(options));
        break;
      case 'Group Question':
        component.push(this.getGroupQuestion(options));
        break;
      case 'Star Rating':
        component.push(this.getStarRating(options));
        break;
      default:
        component.push([]);
        break;
    }
    return component;
  };

  SurveyQuestions.prototype.getOptions = function getOptions() {
    //     const currentQuestion = this.props.survey.questions[this.state.sequence_no - 1];
    var currentQuestion = this.state.current_question;
    var options = !currentQuestion.questionGroup ? currentQuestion.options : currentQuestion.options;
    var optionType = !currentQuestion.questionGroup ? currentQuestion.renderType : 'Group Question';
    var optionComponent = '';
    if (options) {
      optionComponent = this.getComponent(optionType, options);
    }
    return _react2.default.createElement(
      'div',
      { className: this.styles.option_container, scrollTop: 0, key: 'sdfsds' },
      optionComponent
    );
  };

  SurveyQuestions.prototype.setBackButtonClick = function setBackButtonClick() {
    var changePageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_BTN_CLICK, _utilElement2.EVENT_BTN_CLICK, 'Back button clicked.');
    window.scrollTo(0, 0);
    this.setState({ sequence_no: this.state.sequence_no - 1, current_move: 'backward', page_no: changePageNo !== false ? this.state.page_no - 1 : this.state.page_no });
  };

  SurveyQuestions.prototype.getBackButton = function getBackButton() {
    // logic for back button
    var backButtonValue = this.props.selectedLanguage ? (0, _utilElement.getBackButtonText)()[this.props.selectedLanguage] : 'en';
    return _react2.default.createElement(_mozart_ui.MozartButton, {
      style: { border: '1px solid ' + this.props.theme.colorCode },
      data: backButtonValue,
      key: this.state.sequence_no,
      disabled: this.state.disable_next,
      onClick: this.setBackButtonClick.bind(this)
    });
  };

  SurveyQuestions.prototype.getTotalPageCount = function getTotalPageCount() {
    var _this14 = this;

    var pageCount = 0;
    if (this.props.survey && this.props.survey.questionGroups) {
      this.props.survey.questionGroups.map(function (question) {
        if (question.type === 'Question') {
          if (question.questions[0].rule) {
            if (_this14.checkRule(question.questions[0])) {
              pageCount = pageCount + 1;
            }
          } else {
            pageCount = pageCount + 1;
          }
        } else {
          var groupQuestions = question.questions;
          var failedCount = 0;
          if (groupQuestions) {
            groupQuestions.map(function (groupQuestionEach) {
              if (groupQuestionEach.rule) {
                if (!_this14.checkRule(groupQuestionEach)) {
                  failedCount = failedCount + 1;
                }
              }
            });
            if (failedCount !== groupQuestions.length) {
              pageCount = pageCount + 1;
            }
          }
        }
      });
    }
    return pageCount;
  };

  SurveyQuestions.prototype.getPageNumber = function getPageNumber() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.page_number },
      _react2.default.createElement(
        'span',
        null,
        this.state.page_no + ' of ' + this.getTotalPageCount()
      )
    );
  };

  SurveyQuestions.prototype.setNextButtonClick = function setNextButtonClick(changePageNo) {
    (0, _utilElement2.fireGTMEvent)(_utilElement2.EVENT_BTN_CLICK, _utilElement2.EVENT_BTN_CLICK, 'Next button clicked.');
    window.scrollTo(0, 0);
    this.setState({ sequence_no: this.state.sequence_no + 1, current_move: 'forward', page_no: changePageNo !== false ? this.state.page_no + 1 : this.state.page_no });
  };

  SurveyQuestions.prototype.setAnonymousSurvey = function setAnonymousSurvey() {
    this.setState({
      anonymous_survey: !this.state.anonymous_survey
    });
  };

  SurveyQuestions.prototype.getNextButton = function getNextButton() {
    var currentQuestion = this.state.current_question;
    var nextButton = '';
    if (this.checkRequired()) {
      nextButton = _react2.default.createElement(
        'span',
        { className: this.styles.required_question_label },
        'This is a required question'
      );
    } else if (this.state.page_no === this.getTotalPageCount()) {
      // logic for submit button
      var submitButtonValue = this.props.selectedLanguage ? (0, _utilElement.getSubmitButtonText)()[this.props.selectedLanguage] : 'en';
      nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
        background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
        color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
        data: submitButtonValue,
        style: { border: '1px solid ' + this.props.theme.colorCode },
        disabled: this.state.disable_next,
        onClick: this.props.survey.showAnonymous ? this.toggleAnonymousModal.bind(this) : this.submitSurvey.bind(this)
      });
    } else {
      if (this.isAutoSkippableQuestion() && !(this.state.feedback_data[currentQuestion.id] && this.state.feedback_data[currentQuestion.id].optionId !== undefined && this.state.feedback_data[currentQuestion.id].optionId !== null)) {
        // logic for skip button
        var skipButtonValue = this.props.selectedLanguage ? (0, _utilElement.getSkipButtonText)()[this.props.selectedLanguage] : 'en';
        nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
          data: skipButtonValue,
          key: this.state.sequence_no,
          style: { border: '1px solid ' + this.props.theme.colorCode },
          disabled: this.state.disable_next,
          onClick: this.setNextButtonClick.bind(this)
        });
      } else {
        // logic for Next button
        var nextButtonValue = this.props.selectedLanguage ? (0, _utilElement.getNextButtonText)()[this.props.selectedLanguage] : 'en';
        nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
          background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
          color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
          data: nextButtonValue,
          key: this.state.sequence_no,
          style: { border: '1px solid ' + this.props.theme.colorCode },
          disabled: this.state.disable_next,
          onClick: this.setNextButtonClick.bind(this)
        });
      }
    }
    return nextButton;
  };

  SurveyQuestions.prototype.setFocus = function setFocus() {
    if (!(0, _utilElement.checkDevice)()) {
      var currentQuestion = this.state.current_question;
      var optionType = !currentQuestion.questionGroup ? currentQuestion.renderType : 'Group Question';
      switch (optionType) {
        case 'Date':
        case 'Text Area':
          if (document.getElementById('textarea_' + this.state.sequence_no)) {
            document.getElementById('textarea_' + this.state.sequence_no).focus();
          }
          break;
        case 'Email':
        case 'Phone':
        case 'Number':
        case 'Text Box':
          if (document.getElementById('textbox_' + this.state.sequence_no)) {
            document.getElementById('textbox_' + this.state.sequence_no).focus();
          }
          break;
        case 'Slider':
        case 'Number Slider':
          break;
        case 'Dropdown':
          break;
        default:
          break;
      }
    }
  };

  SurveyQuestions.prototype.getPageContent = function getPageContent() {
    return _react2.default.createElement(
      'div',
      { key: this.state.sequence_no, style: { height: '100%' } },
      _react2.default.createElement(
        'div',
        { style: { zIndex: '-1', height: '100%' } },
        _react2.default.createElement(
          _Row2.default,
          { className: this.styles.survey_questions_options_wrapper, id: 'survey_questions_options_wrapper',
            style: { borderColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#00253B' } },
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, 'data-qa-type': 'page-number', id: 'survey_pagenumber_wrapper' },
            this.getActivePageNumber()
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, 'data-qa-type': 'title', style: { minHeight: '10%' }, id: 'survey_questions_wrapper' },
            this.getQuestion()
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, 'data-qa-type': 'options', style: { height: '90%' }, id: 'survey_options_wrapper' },
            this.getOptions()
          )
        )
      )
    );
  };

  SurveyQuestions.prototype.toggleAnonymousModal = function toggleAnonymousModal() {
    this.setState({
      show_anonymous_dialog: !this.state.show_anonymous_dialog
    });
  };

  SurveyQuestions.prototype.currentDataRequired = function currentDataRequired(currentData) {
    var required = false;
    if (currentData && currentData.optionId && currentData.response) {
      if (Array.isArray(currentData.response)) {
        required = currentData.response.length > 0;
      } else if (typeof currentData.response === 'string') {
        required = currentData.response.trim() !== '';
      }
    }
    return required;
  };

  SurveyQuestions.prototype.checkRequired = function checkRequired() {
    var _this15 = this;

    var required = false;
    var currentQuestion = this.state.current_question;
    if (currentQuestion.questionGroup) {
      var groupQuestions = currentQuestion.questions;
      groupQuestions.map(function (item) {
        var currentData = _this15.state.feedback_data[item.id] ? _this15.state.feedback_data[item.id] : '';
        if (item.required && !_this15.currentDataRequired(currentData)) {
          required = true;
        }
      });
    } else {
      if (currentQuestion.renderType === 'Number Slider') {
        required = currentQuestion.required && !(this.state.feedback_data[currentQuestion.id] && this.state.feedback_data[currentQuestion.id].optionId !== undefined && this.state.feedback_data[currentQuestion.id].optionId !== null && this.state.feedback_data[currentQuestion.id].response.trim() !== '');
      } else {
        var currentData = this.state.feedback_data[currentQuestion.id] ? this.state.feedback_data[currentQuestion.id] : '';
        required = currentQuestion.required && !this.currentDataRequired(currentData);
      }
    }
    return required;
  };

  SurveyQuestions.prototype.validateEmail = function validateEmail(value) {
    var regex = /^(([^<>()\[\]\\,;:\s@"]+(\.[^<>()\[\]\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,20}))$/;
    return regex.test(value);
  };

  SurveyQuestions.prototype.validatePhone = function validatePhone(value) {
    var regex = /^\d{10}$/;
    return regex.test(value);
  };

  SurveyQuestions.prototype.checkRule = function checkRule(question) {
    var _this16 = this;

    var rule = question.rule;
    var rules = rule.rules;
    var ruleLogic = '';
    var logicalOperator = rule.logicalOperator ? this.getLogicalOperator(rule.logicalOperator) : false;
    if (rules.length > 1) {
      rules.map(function (ruleItem, index) {
        var constraint = _this16.getConstraint(ruleItem.constraint);
        var questionId = ruleItem.questionId;
        var optionId = ruleItem.optionId;
        // add new rules
        var typeId = ruleItem.type;
        var value = ruleItem.value;
        if (constraint) {
          if (typeId === 'LocationRule') {
            ruleLogic = ruleLogic + (_this16.props.locationId ? '(' + _this16.props.locationId + ' ' + constraint + ' ' + value + ')' : false);
          } else {
            ruleLogic = ruleLogic + (_this16.state.feedback_data[questionId] ? '(' + _this16.state.feedback_data[questionId].optionId + ' ' + constraint + ' ' + optionId + ')' : false);
          }
          if (index !== rules.length - 1) {
            ruleLogic = ruleLogic + logicalOperator;
          }
        }
      });
    } else {
      var constraint = this.getConstraint(rules[0].constraint);
      var questionId = rules[0].questionId;
      var optionId = rules[0].optionId;
      var typeId = rules[0].type;
      var value = rules[0].value;
      if (constraint) {
        if (typeId === 'LocationRule') {
          ruleLogic = ruleLogic + (this.props.locationId ? '(' + this.props.locationId + ' ' + constraint + ' ' + value + ')' : false);
        } else {
          ruleLogic = this.state.feedback_data[questionId] ? this.state.feedback_data[questionId].optionId + ' ' + constraint + ' ' + optionId : false;
        }
      }
    }
    return this.eval(ruleLogic);
  };

  SurveyQuestions.prototype.isAutoSkippableQuestion = function isAutoSkippableQuestion() {
    var currentQuestion = this.state.current_question;
    var optionType = !currentQuestion.questionGroup ? currentQuestion.renderType : 'Group Question';
    return ['Single Select', 'Date', 'NPS', 'Star Rating', 'Slider', 'Number Slider', 'Dropdown'].indexOf(optionType) !== -1 ? true : false;
  };

  SurveyQuestions.prototype.showLocations = function showLocations() {
    var retVal = false;
    if (!this.props.locationId && this.state.show_locations) {
      this.state.current_page = 'location';
      this.state.tmp_location = this.state.location_id;
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.showSurveys = function showSurveys() {
    var retVal = false;
    if (this.state.location_id && !this.props.surveyId && this.state.show_surveys) {
      this.state.current_page = 'survey';
      this.state.tmp_survey = this.state.survey_id;
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.showProviders = function showProviders() {
    var retVal = false;
    if (this.state.location_id && this.state.survey_id && !this.props.providerId && this.state.show_providers) {
      this.state.current_page = 'provider';
      this.state.tmp_provider = this.state.provider_id;
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.showQuestions = function showQuestions() {
    var retVal = false;
    if (this.state.location_id && this.state.survey_id && this.state.provider_id && this.state.show_questions) {
      this.state.current_page = 'questions';
      retVal = true;
    }
    return retVal;
  };

  SurveyQuestions.prototype.selectLocation = function selectLocation(location) {
    this.state.tmp_location = location.id;
    this.state.location_id = location.id;
  };

  SurveyQuestions.prototype.selectSurvey = function selectSurvey(survey) {
    this.state.tmp_survey = survey.id;
    this.state.survey_id = survey.id;
  };

  SurveyQuestions.prototype.selectProvider = function selectProvider(provider) {
    this.state.tmp_provider = provider.id;
    this.state.provider_id = provider.id;
  };

  SurveyQuestions.prototype.submitSurvey = function submitSurvey() {
    var _this17 = this;

    if (this.props.survey.showAnonymous) {
      this.setState({
        show_anonymous_dialog: !this.state.show_anonymous_dialog
      }, function () {
        _this17.props.onSubmit(_this17.state.feedback_data, _this17.state.anonymous_survey);
      });
    } else {
      this.props.onSubmit(this.state.feedback_data, this.state.anonymous_survey);
    }
  };

  SurveyQuestions.prototype.dateChange = function dateChange(value) {
    var dateVal = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response ? (0, _momentTimezone2.default)(this.state.feedback_data[this.state.current_question.id].response, 'MM-DD-YYYY').format('MM-DD-YYYY') : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY');
    if (this.checkDate(value)) {
      this.setData(1, (0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    } else {
      this.refs.date_box_mobile.value = dateVal;
    }
  };

  SurveyQuestions.prototype.dateBlur = function dateBlur(event) {
    var value = event.target.value;
    var dateVal = this.state.feedback_data[this.state.current_question.id] && this.state.feedback_data[this.state.current_question.id].response ? (0, _momentTimezone2.default)(this.state.feedback_data[this.state.current_question.id].response, 'MM-DD-YYYY').format('MM-DD-YYYY') : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY');
    if (!this.checkDate(value)) {
      this.setData(1, (0, _momentTimezone2.default)(dateVal, 'MM-DD-YYYY').format('MM-DD-YYYY'));
      document.getElementById('date_box_mobile_' + this.state.sequence_no).value = dateVal;
    }
  };

  SurveyQuestions.prototype.checkDate = function checkDate(date) {
    var allowedDateFormats = ['MM-DD-YYYY'];
    return (0, _momentTimezone2.default)(date, allowedDateFormats, true).isValid();
  };

  SurveyQuestions.prototype.hideDoneButton = function hideDoneButton() {
    document.body.className = document.body.className.replace(/\bmobile_device\b/, '');
    document.body.className = document.body.className.replace(/\mobile_device_iphone\b/, '');
  };

  SurveyQuestions.prototype.render = function render() {
    var _this18 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.survey_question_container, style: { width: '100%', margin: '0px' }, id: 'survey_questions_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            { transitionName: this.state.current_move === 'forward' ? 'slide-top' : 'slide-bottom' },
            this.getPageContent()
          ),
          _react2.default.createElement(
            _Row2.default,
            { className: this.styles.survey_questions_footer, id: 'survey_questions_footer' },
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4, className: this.styles.footer_button_container },
              _react2.default.createElement(
                'div',
                { className: this.styles.back_button_container },
                this.state.sequence_no !== 1 && this.getBackButton()
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4, className: this.styles.footer_button_container },
              _react2.default.createElement(
                'div',
                { className: this.styles.page_number_container },
                this.getPageNumber()
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4, className: this.styles.footer_button_container },
              _react2.default.createElement(
                'div',
                { className: this.styles.next_button_container },
                this.getNextButton()
              )
            )
          ),
          _react2.default.createElement(
            _Row2.default,
            { className: this.styles.mobile_done_button_wrapper, id: 'mobile_done_button_wrapper' },
            _react2.default.createElement(_Col2.default, { xs: 4, sm: 4, md: 4 }),
            _react2.default.createElement(_Col2.default, { xs: 4, sm: 4, md: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, sm: 4, md: 4 },
              _react2.default.createElement(_mozart_ui.MozartButton, {
                background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                style: { border: '1px solid ' + this.props.theme.colorCode },
                data: 'Done',
                onClick: this.hideDoneButton.bind(this)
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_mozart_ui.MozartModal, {
            title: 'Survey Submission',
            key: 'anonymousSurveyDialog',
            children: _react2.default.createElement(
              'div',
              { className: this.styles.anonymous_checkbox },
              _react2.default.createElement(
                _mozart_ui.MozartCheckBox,
                null,
                _react2.default.createElement('input', {
                  ref: 'checkbox_anonymous_survey',
                  type: 'checkbox',
                  id: 'checkbox_anonymous_survey',
                  name: 'checkbox_anonymous_survey',
                  onChange: this.setAnonymousSurvey.bind(this),
                  checked: this.state.anonymous_survey
                }),
                _react2.default.createElement(
                  'label',
                  { style: { marginRight: '10px' }, htmlFor: 'checkbox_anonymous_survey', title: 'checkbox' },
                  'Submit survey as anonymous'
                )
              )
            ),
            submitLabel: 'Submit',
            handleSubmit: this.submitSurvey.bind(this),
            show: this.state.show_anonymous_dialog,
            width: this.state.device_type === 'mobile' ? '80%' : '700px',
            onClose: function onClose() {
              _this18.toggleAnonymousModal();
            }
          })
        )
      )
    );
  };

  return SurveyQuestions;
}(_react.Component), _class2.propTypes = {
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  theme: _react.PropTypes.object,
  createdAudienceInfo: _react.PropTypes.object,

  audienceInfo: _react.PropTypes.object,
  onSubmit: _react.PropTypes.func,
  checkDevice: _react.PropTypes.func,
  createAudience: _react.PropTypes.func,
  getTextForLanguage: _react.PropTypes.func,

  surveyId: _react.PropTypes.number,
  locationId: _react.PropTypes.number,
  providerId: _react.PropTypes.number,

  selectedLanguage: _react.PropTypes.string,

  previewMode: _react.PropTypes.boolean
}, _temp)) || _class);
exports.default = SurveyQuestions;
module.exports = exports['default'];

/***/ }),

/***/ 2325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"masking_div":"_fgXCZ9oc-OnHjaj8HsxC","survey_question_container":"zCCfWMh3H8KTGtEmlvT0l","survey_question_header":"DRBIyDeekJX32rsKbTeLd","logo_container":"U1Z7Id9kpprW2THBX0vmL","survey_name":"_37PGZ-64ornoz7k4l06toO","powered_by":"_1EKRtLO5EIbbWcOc6dvyVA","powered_by_name":"_1KJTX3RMa96WUHciSrO7oA","signature_container":"MAS6eUl_aOGzmZjGENgtk","sequence_no":"_2Hs-5WLaVvr8lOOF1Rb3Wj","sequence_number":"_3SEt72ZKwM6UjXUn383ons","skyBlue":"_2X_2bgnfpdGzmp_8V111V5","brightYellow":"_1g7MjAa5K32tBncbu-nyGY","azure":"_33cXsH1bAIkRBPraSiGD89","orange":"_2sBRpMhm5X-_Aey3xeNYfA","darkBlue":"_2dcK3ft5TuC0xxgrt4crLq","magenta":"_1XUMT3z6O32CNSRo0IeUhi","yellowGreen":"_3DsT7EWT5b5FPxLeD4qWUH","pink":"_1B_esTTOGU9-K4OCG_k6x7","green":"_3MUTMHTQM7kEAgHCJgcYdW","red":"_2PaijIn8067xMGxE5k_0Su","darkGreen":"_2KRlJuc3amuFC4lqmxuW19","brown":"_1xJRKhKfBcosT23NFcwEXp","survey_questions_options_wrapper":"_2i-hGbFcM23pLLphRSJwIi","question_container":"_2mG3jZvs2zzLt1DCWsh9rw","instruction_container":"ijQAQcUB3jy6J-qvKFmgl","instruction_seperator":"_33O_4_4OqwcFhOjvlwBKtt","option_container":"_1uEsIpkkuUR9D5LHnJrfkV","survey_questions_footer":"hm6ds82LEpTkjql2XmNdX","page_number":"_1Nbz9vycpqrT4Nl3ZeNpIM","required_question_label":"_1yV-Z6t6yRatxOadKTx1qo","back_button_container":"KBxFAb16EMUU92IsPJgjr","page_number_container":"_3Fepx2ztzyvrKzE2Y51AwQ","next_button_container":"_3iu1QbkBQi_bOIRAc6fIhU","footer_button_container":"_1lEjYMa0BJTntbi-oINLWZ","single_select_rating_button_container":"_2aJwgg-ozCMO-mCALIZLoz","nps_style":"_1rbmGi5e5rjdEZQnEJH0u5","selected_nps_style":"_3z16adu1w1BKQHarSLJqXH","single_select_rating_button_label":"_2glQPDyQaB_jRbnnWlpH8l","datepicker_container":"_2L5ZJ3uqhMvECFfUP43OfL","dropdown_container":"_3RJOWXDMY-a3q0JvCDdPDS","textfield_container":"_2YEwYMounDvE1Zo5Chhey3","textarea_container":"_1f9xaE3FzrC5Af_ueTEawK","star_rating_container":"_3eNVTGuvFW_Uibl4k0aEzX","group_question_container":"_3XmZX3QHv1J23wrC53e-y5","group_question_item":"_2iJblUhjw_6eKD0DDXjHB_","group_question_item_option_container":"_2xiF0sWtwGTJODxj7GhMXD","group_question_item_question":"_3WD9d_RySLPxTBQ8Driax6","group_question_item_question_large":"Bd13Pe_fNJl3ocrbmuQyD","group_question_item_option_radio":"_1PjIjx5OgOAPaKz9sKHX7K","group_question_item_option_textbox":"_36GCpWsD-UcBh9KNa_TQrA","mobile_done_button_wrapper":"_2z1SjxKpxhqWkaqdNQZvRJ","errorText":"lZPmTW9WLlNY_MlT8mFr8","group_question_item_option":"_1vKJ0aQDAemDli51OTUDdU","group_question_item_option_text":"_37JRKJMgjABD--ZX35c-hc","group_question_item_option_text_textbox":"_8C43Y8HJODF2eMfZv8d62","anonymous_checkbox":"_2vzdqIJZm6nHH_9ZlCzPG1"};

/***/ }),

/***/ 2326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _keys = __webpack_require__(126);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _utilElement = __webpack_require__(91);

var _components = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyHeader = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SurveyHeader, _Component);

  function SurveyHeader(props) {
    (0, _classCallCheck3.default)(this, SurveyHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2327);
    _this.buttonStyle = { borderRadius: '25px' };
    _this.state = {
      current_move: 'forward',
      sequence_no: 1,
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop',
      theme: _this.props.theme
    };
    return _this;
  }

  SurveyHeader.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.theme.colorCode !== this.props.theme.colorCode && (0, _keys2.default)(this.props.theme.length > 0)) {
      this.updateTheme(this.props.theme);
    }
  };

  SurveyHeader.prototype.updateTheme = function updateTheme(theme) {
    this.setState({ theme: theme });
  };

  SurveyHeader.prototype.render = function render() {
    var survey = this.props.survey;

    var style = { color: this.state.theme && this.state.theme.customTextColor ? this.state.theme.customTextColor : '#fff' };
    return _react2.default.createElement(
      'div',
      { className: this.styles.survey_header_container },
      _react2.default.createElement(
        _Row2.default,
        { className: this.styles.survey_question_header, style: { zIndex: '10' } },
        _react2.default.createElement(_components.SurveyLogo, { theme: this.state.theme.colorCode }),
        _react2.default.createElement(
          _Col2.default,
          { md: 3, sm: 3, xs: 4 },
          _react2.default.createElement(
            'div',
            { className: this.styles.logo_container },
            _react2.default.createElement('img', { src: this.props.clientLogoUrl })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 7, sm: 7, xs: 8 },
          survey && _react2.default.createElement(
            'div',
            { className: this.styles.survey_name, style: style },
            (0, _utilElement.getTextForLanguage)(survey.name, this.props.selectedLanguage)
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 2, sm: 2, xsHidden: true },
          this.props.showBranding && _react2.default.createElement(
            'div',
            { className: this.styles.signature_container },
            _react2.default.createElement(
              'div',
              { className: this.styles.powered_by, style: style },
              'POWERED BY',
              _react2.default.createElement('br', null)
            ),
            _react2.default.createElement(
              'div',
              { className: this.styles.powered_by_name },
              _react2.default.createElement('img', { src: 'https://cdn.consumerism.pressganey.com/pgforsta.png', title: 'Powered by Press Ganey Consumer Experience' })
            )
          )
        )
      )
    );
  };

  return SurveyHeader;
}(_react.Component), _class2.propTypes = {
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  theme: _react.PropTypes.object,
  getTextForLanguage: _react.PropTypes.func,
  clientLogoUrl: _react.PropTypes.string,
  selectedLanguage: _react.PropTypes.string,
  showBranding: _react.PropTypes.boolean
}, _temp)) || _class);
exports.default = SurveyHeader;
module.exports = exports['default'];

/***/ }),

/***/ 2327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"survey_header_container":"_22Ta5U5lvaICLtaAXqSx3S","logo_container":"l5i8M1_o9vpQYvudr_5TO","survey_name":"_1L8hbwyrDMGKJib30poAe_","powered_by":"CT6NdmZsnQebAfgb0u4-v","powered_by_name":"EP0FqY6HunBm-1dMcG3o4","signature_container":"c3WLBw544ZuaKP-UetRaP"};

/***/ }),

/***/ 2328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyFooter = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SurveyFooter, _Component);

  function SurveyFooter(props) {
    (0, _classCallCheck3.default)(this, SurveyFooter);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2329);
    _this.state = {
      isHovering: false,
      current_move: 'forward',
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop'
    };
    return _this;
  }

  SurveyFooter.prototype.componentDidMount = function componentDidMount() {
    //     console.log(this.props.survey);
  };

  SurveyFooter.prototype.onBackClick = function onBackClick() {
    if (this.props.onBackClick) {
      this.props.onBackClick();
    }
  };

  SurveyFooter.prototype.onNextClick = function onNextClick() {
    if (this.props.onNextClick) {
      this.props.onNextClick();
    }
  };

  SurveyFooter.prototype.getBackButton = function getBackButton() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_mozart_ui.MozartButton, {
        style: { border: '1px solid ' + this.props.theme.colorCode },
        data: 'Back',
        onClick: this.onBackClick.bind(this)
      })
    );
  };

  SurveyFooter.prototype.getFooterLabel = function getFooterLabel() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.page_number },
      _react2.default.createElement(
        'span',
        null,
        this.props.label
      )
    );
  };

  SurveyFooter.prototype.getNextButton = function getNextButton() {
    var nextButton = '';
    nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
      style: { border: '1px solid ' + this.props.theme.colorCode },
      color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
      background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
      data: 'Next',
      onClick: this.onNextClick.bind(this),
      disabled: !this.props.showNext
    });
    return nextButton;
  };

  SurveyFooter.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.survey_footer_container },
        _react2.default.createElement(
          _Row2.default,
          { className: this.styles.survey_questions_footer },
          _react2.default.createElement(
            _Col2.default,
            { xs: 4, sm: 6, md: 6, className: this.styles.footer_button_container + ' ' + this.styles.footer_button_container_left },
            _react2.default.createElement(
              'div',
              { className: this.styles.back_button_container },
              this.props.showBack && this.getBackButton()
            )
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 4, smHidden: true, mdHidden: true, lgHidden: true, className: this.styles.search_mobile_container, 'data-qa-type': 'search_mobile_container' },
            _react2.default.createElement(
              'div',
              { className: this.styles.mobile_search_round_button, style: { backgroundColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#403788' } },
              _react2.default.createElement('span', { style: { cursor: 'pointer', color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff' }, className: 'icon-Search', onClick: function onClick() {
                  if (_this2.props.onSearchClick) {
                    _this2.props.onSearchClick();
                  }
                } })
            )
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 4, sm: 6, md: 6, className: this.styles.footer_button_container + ' ' + this.styles.footer_button_container_right },
            _react2.default.createElement(
              'div',
              { className: this.styles.next_button_container },
              this.getNextButton()
            )
          )
        )
      )
    );
  };

  return SurveyFooter;
}(_react.Component), _class.propTypes = {
  onNextClick: _react.PropTypes.func,
  onBackClick: _react.PropTypes.func,
  onSearchClick: _react.PropTypes.func,

  showBack: _react.PropTypes.bool,
  showNext: _react.PropTypes.bool,
  showLabel: _react.PropTypes.bool,

  label: _react.PropTypes.string,

  theme: _react.PropTypes.object
}, _class.defaultProps = {
  showBack: true,
  showNext: true,
  showLabel: false
}, _temp);
exports.default = SurveyFooter;
module.exports = exports['default'];

/***/ }),

/***/ 2329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"survey_footer_container":"_2q3gk97E5GryKOUMjP9MOm","survey_questions_footer":"HuPzBKEDi1owr-zW4-n-_","page_number":"_1iUclttx110-G2eXqoH4zo","required_question_label":"_3DH9U3TeEDk1EBdy4O3CQn","back_button_container":"_1OxmV5rOYwT0dwv9Gra5zG","page_number_container":"D_MNqvH9JiloOXWeFlFlg","next_button_container":"_1uzYGwmvPiELZaiPd7TCM4","footer_button_container":"_1eZ-f0DU80_0VxfU3ifZC8","footer_button_container_left":"_1XU5Hmv-EQSDeceX2tl7LO","footer_button_container_right":"_2WyR3i8hGtwrp9mOoa5_fZ","search_mobile_container":"_1qHW-G2ltlGMxh7-mknoES","mobile_search_round_button":"_3GmL69KjAMCbMPv3H9AvXW","skyBlue":"MMRfqV0w1fCjSg39GKV3Y","brightYellow":"_3-Su2FbesuC5WPxqquI7Ha","azure":"pWSmuZwl10Hqr_T232Cev","orange":"KUSrWilOJOoieJFKCuAVR","darkBlue":"_3i6zZkn5jdNS3bKuk7Fe6I","magenta":"_2Piw76uqkOGGjX7b4NsV2H","yellowGreen":"_3nyJN7_7EGAhypi2KF2GOF","pink":"_3SLcQ5Ga4HnBqQOWAFNgTu","green":"_33gzt0c5aaQHWuCKRtmQU5","red":"UiFfMh65PlkinF7n13ixO","darkGreen":"_1sJmu3BlptjoTOyFQ2_0z_","brown":"apO4prMfabdYOo27dlPKA"};

/***/ }),

/***/ 2330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _redux = __webpack_require__(101);

var _Grid = __webpack_require__(73);

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _components = __webpack_require__(200);

var _mozart_ui = __webpack_require__(69);

var _survey = __webpack_require__(179);

var _utilElement = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Locations = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    locations: state.survey.locations,
    survey: state.survey.data
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadLocations: _survey.loadLocations }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Locations, _Component);

  function Locations(props) {
    (0, _classCallCheck3.default)(this, Locations);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2331);
    _this.state = {
      hover: false,
      cardId: '',
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop',
      selected_location: _this.props.selectedLocation,
      search_text: false,
      show_search: _this.props.showSearch ? _this.props.showSearch : false
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading locations listing page.');
    return _this;
  }

  Locations.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.locations) {
      this.props.loadLocations(this.props.clientId, this.props.sourceId);
    }
  };

  Locations.prototype.setLocation = function setLocation(location) {
    this.setState({ selected_location: location.id });
    this.props.onSelectLocation(location);
  };

  Locations.prototype.getSingleLocation = function getSingleLocation(location) {
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 6, md: 4, lg: 4 },
      _react2.default.createElement(
        'div',
        { 'data-qa-type': 'list_item', title: location.name, className: this.state.selected_location === location.id ? this.styles.location_container + ' ' + this.styles.location_selected : this.styles.location_container,
          onClick: this.setLocation.bind(this, location),
          onMouseEnter: this.handleMouseEnter.bind(this, location),
          onMouseLeave: this.handleMouseLeave.bind(this),
          id: location.id },
        _react2.default.createElement(
          'div',
          { className: this.styles.location_id },
          location.id
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.location_name },
          location.name
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.location_address },
          location.address
        )
      )
    );
  };

  Locations.prototype.getLocations = function getLocations() {
    var _this2 = this;

    var locations = this.props.locations;

    var locationElem = [];
    if (locations && locations.data.length) {
      locations.data.map(function (item) {
        if (_this2.state.search_text) {
          if (item.name.toLowerCase().search(_this2.state.search_text.toLowerCase()) !== -1) {
            locationElem.push(_this2.getSingleLocation(item));
          }
        } else {
          locationElem.push(_this2.getSingleLocation(item));
        }
      });
    } else {
      locationElem.push(_react2.default.createElement(
        'p',
        null,
        'This practice/brand does not appear to have locations that administer surveys. Please contact your practice/brand for assistance.'
      ));
    }
    if (!locationElem.length) {
      locationElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_locations },
        'Sorry ! no items found.'
      ));
    }
    return locationElem;
  };

  Locations.prototype.handleSearch = function handleSearch(searchText) {
    if (searchText.length >= 1 || searchText === '') {
      this.setState({ search_text: searchText, show_search: false });
    }
  };

  Locations.prototype.handleMouseEnter = function handleMouseEnter(location) {
    this.setState({ cardId: location.id });
    document.getElementById(location.id).style.border = '1px solid' + this.props.theme.colorCode;
  };

  Locations.prototype.handleMouseLeave = function handleMouseLeave() {
    document.getElementById(this.state.cardId).style.border = '1px solid #E5E5E5';
  };

  Locations.prototype.render = function render() {
    var _this3 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.locations_page_container, style: { width: '100%' }, id: 'locations_listing_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.location_wrapper },
            !this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.location_header_container, style: { width: '90%', position: 'inherit' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 8, md: 8, lg: 8 },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.location_heading },
                    this.props.label
                  )
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 4, md: 4, lg: 4, xsHidden: true },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.search_container },
                    _react2.default.createElement(_components.Search, {
                      label: '',
                      placeholder: 'Search',
                      handleSearch: this.handleSearch.bind(this),
                      style: { 'float': 'right', 'marginRight': '-15px' }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                {
                  className: this.styles.location_list_container, 'data-qa-type': 'list_container' },
                this.getLocations()
              )
            ),
            this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.location_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, style: { marginTop: '20px' } },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.location_heading },
                    'Search a practice/location'
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.location_list_container + ' mobile_search_elements' },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_text_field' },
                  _react2.default.createElement(_mozart_ui.MozartTextBox, {
                    ref: 'textbox_mobile_search',
                    id: 'textbox_mobile_search',
                    multiLine: false,
                    validationBool: false,
                    key: 'textbox_mobile_search',
                    limit: 100
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, tabindex: '0', smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Cancel',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch('');
                      }
                    }
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Search',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch(document.getElementById('textbox_mobile_search').value);
                      }
                    }
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return Locations;
}(_react.Component), _class2.propTypes = {
  onSelectLocation: _react.PropTypes.func,
  loadLocations: _react.PropTypes.func,

  locations: _react.PropTypes.object,
  survey: _react.PropTypes.object,

  selectedLocation: _react.PropTypes.number,

  theme: _react.PropTypes.string,
  clientId: _react.PropTypes.string,
  sourceId: _react.PropTypes.string,
  label: _react.PropTypes.string,

  showSearch: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Locations;
module.exports = exports['default'];

/***/ }),

/***/ 2331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"locations_page_container":"tWz4LxwBF1A2tJYtO24LB","location_heading":"_3LxapCjwZjbjtRIEjCYxrf","location_container":"_3ca4aaF9v72YppDeVO5i8f","location_selected":"_10ZVE3JOQC9_VlTF1f7We0","location_id":"_1R0myub-cJArmzakG3gNbh","location_name":"_3VypBtMBZ9aORa0RyA_fOA","location_address":"_2jAn59k9nXlC7gXUTZ5D2H","location_wrapper":"_2RRiDoSSm2MRYAC-eh_bny","location_header_container":"_3rdgSNO_QsB2dctlBpcuEW","location_list_container":"_2YDyhmTSbJ_sSq4QEaNvUK","search_container":"_1OdGfYmU5a4F0KHIH98JVb","no_locations":"I6hU8lBZe5A6mHOZWmKOr","skyBlue":"_2fpuD_aiz_4ON--NDdUULi","brightYellow":"_2apq6jO1mhWWLzsGJ0tbO6","azure":"oGIFuPnJmyrP8Qgm5Z5NZ","orange":"_1IvzoxiVivkJmj_boPX1t0","darkBlue":"_1kAF04FsEs1--YmHz7TRlD","magenta":"_3o1YsKnADo-9ya5CJqOdaP","yellowGreen":"_3vqR8W9GGYZNQSHCryoBxq","pink":"_1FuICCiaxL1EucUgb3_9id","green":"_3lJ9UitcvB4g2gWacZ57My","red":"_1Jj73qXIAkkLJLa6aGDL_5","darkGreen":"_1IMhJvPeDbQbcnEWYhbjwN","brown":"_2rsAuEBSLeCtdXN5bpGY_w"};

/***/ }),

/***/ 2332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _keys = __webpack_require__(126);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _redux = __webpack_require__(101);

var _Grid = __webpack_require__(73);

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _survey = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Providers = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    providers: state.survey.providers,
    survey: state.survey.data
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadProviders: _survey.loadProviders }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Providers, _Component);

  function Providers(props) {
    (0, _classCallCheck3.default)(this, Providers);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2333);
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop',
      default_lang: _this.props.survey.languages.en ? 'en' : (0, _keys2.default)(_this.props.survey.languages)[0],
      selected_provider: _this.props.selectedProvider
    };
    return _this;
  }

  Providers.prototype.componentWillMount = function componentWillMount() {
    this.props.loadProviders();
  };

  Providers.prototype.componentDidMount = function componentDidMount() {
    console.log(this.props.providers);
  };

  Providers.prototype.setProvider = function setProvider(provider) {
    this.setState({ selected_provider: provider.id });
    this.props.onSelectProvider(provider);
  };

  Providers.prototype.getSingleProvider = function getSingleProvider(provider) {
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 4, md: 4, lg: 4 },
      _react2.default.createElement(
        'div',
        { className: this.state.selected_provider === provider.id ? this.styles.provider_container + ' ' + this.styles.provider_selected : this.styles.provider_container, onClick: this.setProvider.bind(this, provider) },
        _react2.default.createElement(
          'div',
          { className: this.styles.provider_name },
          provider.name
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.provider_address },
          provider.address
        )
      )
    );
  };

  Providers.prototype.getProviders = function getProviders() {
    var _this2 = this;

    var providers = this.props.providers;

    var providerElem = [];
    if (providers && providers.length) {
      providers.map(function (item) {
        providerElem.push(_this2.getSingleProvider(item));
      });
    }
    return providerElem;
  };

  Providers.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.providers_page_container, style: { height: this.state.height, width: this.state.width } },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.provider_wrapper },
            _react2.default.createElement(
              _Row2.default,
              { className: this.styles.provider_header_container },
              _react2.default.createElement(
                _Col2.default,
                { xs: 12, sm: 12, md: 12, lg: 12 },
                _react2.default.createElement(
                  'span',
                  { className: this.styles.provider_heading },
                  'Please select a provider'
                )
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { className: this.styles.provider_list_container },
              this.getProviders()
            )
          )
        )
      )
    );
  };

  return Providers;
}(_react.Component), _class2.propTypes = {
  loadProviders: _react.PropTypes.func,
  onSelectProvider: _react.PropTypes.func,

  providers: _react.PropTypes.object,
  survey: _react.PropTypes.object,
  theme: _react.PropTypes.object,

  selectedProvider: _react.PropTypes.number
}, _temp)) || _class);
exports.default = Providers;
module.exports = exports['default'];

/***/ }),

/***/ 2333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"providers_page_container":"_3SL5m3MY7-R7kHjhESz_Bt","provider_heading":"_1DstKxoI13bTVOZAhj9pUk","provider_container":"_1JHNhhy-dWZC4frEMgof7G","provider_selected":"_21rcHwv4418YPYdO7hyWFq","skyBlue":"Ua2lbojs6SKZ-0trGP11c","brightYellow":"A-MVw_-S6oXd5t1PXil89","azure":"_1kJArLXb26bxRMTh6fs5b5","orange":"_3TaXl1RX7YgBGjG83C1Cj1","darkBlue":"Y4oFPp4B6aUm8-S7qZk6s","magenta":"_1rIbI0oZi9bkRqQyDB6d69","yellowGreen":"_1LFfvOODCtNPLIAAO70E07","pink":"_258aLxNeAEt-VLOmUTKzgD","green":"_1s-t7MPZWgdQhWvs3QfKIw","red":"SjPN0wMDzBVO9vAN82UWy","darkGreen":"_1f1T7eehst7zo_YHmhXtxO","brown":"_25FxkgoApMc48PtZltE2IZ","provider_id":"UlBvydHg_kD2nr8n9Pjme","provider_name":"_3BF6F4iYt8al5d5P8kHPR2","provider_address":"_2ALgjgSCheszNZZV3Fsoll","provider_wrapper":"_3llYjyaSvbwR0PJ4NRxLyn","provider_header_container":"fht9brjp3Wsi_KrzZd0O","provider_list_container":"UW4sdxPjwBcfP52i42f0"};

/***/ }),

/***/ 2334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _redux = __webpack_require__(101);

var _Grid = __webpack_require__(73);

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _components = __webpack_require__(200);

var _mozart_ui = __webpack_require__(69);

var _survey = __webpack_require__(179);

var _utilElement = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Surveys = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    surveys: state.survey.list,
    survey: state.survey.data
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadSurveys: _survey.loadSurveys }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Surveys, _Component);

  function Surveys(props) {
    (0, _classCallCheck3.default)(this, Surveys);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2335);
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop',
      selected_survey: _this.props.selectedSurvey,
      search_text: false,
      show_search: _this.props.showSearch ? _this.props.showSearch : false
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading surveys listing page.');
    return _this;
  }

  Surveys.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.surveys) {
      this.props.loadSurveys(this.props.clientId, this.props.locationId);
    }
  };

  Surveys.prototype.setSurvey = function setSurvey(survey) {
    this.setState({ selected_survey: survey.id });
    this.props.onSelectSurvey(survey);
  };

  Surveys.prototype.getSingleSurvey = function getSingleSurvey(survey) {
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 6, md: 6, lg: 6 },
      _react2.default.createElement(
        'div',
        { 'data-qa-type': 'list_item', title: survey.name, className: this.state.selected_survey === survey.id ? this.styles.survey_container + ' ' + this.styles.survey_selected : this.styles.survey_container, onClick: this.setSurvey.bind(this, survey) },
        _react2.default.createElement(
          'div',
          { className: this.styles.survey_name },
          _react2.default.createElement('span', { className: 'icon-BFSurvey ' + this.styles.survey_icon }),
          survey.name
        )
      )
    );
  };

  Surveys.prototype.getSurveys = function getSurveys() {
    var _this2 = this;

    var _props = this.props,
        surveys = _props.surveys,
        previewMode = _props.previewMode;

    var surveyElem = [];
    if (surveys && surveys.data.length) {
      surveys.data.map(function (item) {
        if (previewMode) {
          if (_this2.state.search_text) {
            if (item.name.toLowerCase().search(_this2.state.search_text.toLowerCase()) !== -1) {
              surveyElem.push(_this2.getSingleSurvey(item));
            }
          } else {
            surveyElem.push(_this2.getSingleSurvey(item));
          }
        } else if (item.mobileFriendly) {
          if (_this2.state.search_text) {
            if (item.name.toLowerCase().search(_this2.state.search_text.toLowerCase()) !== -1) {
              surveyElem.push(_this2.getSingleSurvey(item));
            }
          } else {
            surveyElem.push(_this2.getSingleSurvey(item));
          }
        }
      });
    } else {
      surveyElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_survey },
        'There are no surveys that have been set up for the practice/location at the moment. Please check back later or contact your practice/brand for assistance.'
      ));
    }
    if (!surveyElem.length) {
      surveyElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_survey },
        'Sorry ! no items found.'
      ));
    }
    return surveyElem;
  };

  Surveys.prototype.handleSearch = function handleSearch(searchText) {
    if (searchText.length >= 1 || searchText === '') {
      this.setState({ search_text: searchText, show_search: false });
    }
  };

  Surveys.prototype.render = function render() {
    var _this3 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('div', { className: 'masking_div' }),
      _react2.default.createElement(
        'div',
        { className: this.styles.surveys_page_container, style: { width: '100%' }, id: 'surveys_listing_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.survey_wrapper },
            !this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6 },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.survey_heading },
                    'Please select a survey'
                  )
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6, xsHidden: true },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.search_container },
                    _react2.default.createElement(_components.Search, {
                      label: '',
                      placeholder: 'Search',
                      handleSearch: this.handleSearch.bind(this),
                      style: { 'float': 'right', 'marginRight': '-15px' }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_list_container, 'data-qa-type': 'list_container' },
                this.getSurveys()
              )
            ),
            this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, style: { marginTop: '20px' } },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.survey_heading },
                    'Search a survey'
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_list_container + ' mobile_search_elements' },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_text_field' },
                  _react2.default.createElement(_mozart_ui.MozartTextBox, {
                    ref: 'textbox_mobile_search',
                    id: 'textbox_mobile_search',
                    multiLine: false,
                    validationBool: false,
                    key: 'textbox_mobile_search',
                    limit: 100
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                    data: 'Cancel',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch('');
                      }
                    }
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                    data: 'Search',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch(document.getElementById('textbox_mobile_search').value);
                      }
                    }
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return Surveys;
}(_react.Component), _class2.propTypes = {
  onSelectSurvey: _react.PropTypes.func,
  loadSurveys: _react.PropTypes.func,

  surveys: _react.PropTypes.object,
  survey: _react.PropTypes.object,
  theme: _react.PropTypes.object,

  selectedSurvey: _react.PropTypes.number,

  clientId: _react.PropTypes.string,
  locationId: _react.PropTypes.string,

  showSearch: _react.PropTypes.bool,
  previewMode: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Surveys;
module.exports = exports['default'];

/***/ }),

/***/ 2335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"surveys_page_container":"_3eOgEu8f1pIflMZ3GJBNba","survey_heading":"w7kgYDrvG7KyVghTXyHnt","survey_container":"_2VGNkvOU1yiFzla_jyui35","survey_selected":"_19_IJIGQTk3r6qtQSPYUVa","skyBlue":"_1A3bVgGod-fxoZCidyUPrV","brightYellow":"_3pn5Xx7_giFbbep8MXkGO6","azure":"_3WPBA7KTQ-KJEGmu-J0LcV","orange":"_1TG44UvbGwsktBp2BU460r","darkBlue":"UN_gWOmo4I1MvzAc1BzWu","magenta":"_2jsm-5O24M8JM2F-56Rx8V","yellowGreen":"_7oxefqa70P_10Llrqagvq","pink":"_1naz-NXRKcNonR4ZMaz2ug","green":"GeUqFD7aKaCPk1mrJups0","red":"_3Gc3Ya9BjNakDiyrJGOUGf","darkGreen":"ObuixZXY_gPUTNq4Zi0Jf","brown":"_2St9s9LNoxrECHT5sLF6i4","survey_id":"_1xvHfNwCv8ES8FEAca6Mcu","survey_name":"_2gEXlC-FYRNd4M9CNmpOuF","survey_icon":"_1X-Yd8u5RaRzAlmFjZ0Hj3","survey_address":"u9TLoVnVdTjDP17nG41Ay","survey_wrapper":"_27kAUF-UjDs64wL9bSHCbC","survey_header_container":"eegEPeVMg3J9zXeVkQeDB","survey_list_container":"_1u5nb0zME6dANVZoxQkOV1","no_survey":"_22WAFKnA_7WM-dp5UyZItk","search_container":"_3nx-i7AFufwETW_zE8Gear"};

/***/ }),

/***/ 2336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyLogo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SurveyLogo, _Component);

  function SurveyLogo(props) {
    (0, _classCallCheck3.default)(this, SurveyLogo);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2337);
    return _this;
  }

  SurveyLogo.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'svg',
        {
          version: '1.0',
          xmlns: 'http://www.w3.org/2000/svg',
          width: '600',
          height: '60',
          className: this.styles.svgStyles
        },
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(0.000000,146.000000) scale(0.100000,-0.100000)',
            fill: this.props.theme,
            stroke: 'none'
          },
          _react2.default.createElement('path', {
            d: 'M0 1390 l0 -70 1853 -2 1852 -3 63 -29 c128 -59 206 -173 315 -466\n72 -191 97 -247 145 -317 77 -114 163 -176 287 -209 41 -11 1127 -14 6318 -14\nl6267 0 0 590 0 590 -8550 0 -8550 0 0 -70z'
          })
        )
      )
    );
  };

  return SurveyLogo;
}(_react.Component), _class.propTypes = {
  colorcode: _react.PropTypes.string,
  theme: _react.PropTypes.object
}, _temp);
exports.default = SurveyLogo;
module.exports = exports['default'];

/***/ }),

/***/ 2337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"svgStyles":"_3iWOCiuBGOTS2ngmYabIZo"};

/***/ }),

/***/ 2338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _keys = __webpack_require__(126);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _Grid = __webpack_require__(73);

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = __webpack_require__(69);

var _components = __webpack_require__(200);

var _utilElement = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Languages = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data,
    client: state.client.data,
    selectedLanguage: state.survey.selectedLanguage
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Languages, _Component);

  function Languages(props) {
    (0, _classCallCheck3.default)(this, Languages);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2339);
    _this.state = {
      Ishovering: false,
      cardId: '',
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop',
      selected_language: _this.props.currentLanguage,
      search_text: false,
      show_search: _this.props.showSearch ? _this.props.showSearch : false
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading languages listing page.');
    return _this;
  }

  Languages.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var survey = this.props.survey;

    var languages = survey && survey.data ? survey.data.languages : [];
    var defaultLanguage = survey && survey.data ? survey.data.defaultLanguage : null;
    (0, _keys2.default)(languages).map(function (key) {
      if (key === defaultLanguage) {
        _this2.setLanguage(defaultLanguage);
      }
    });
  };

  Languages.prototype.setLanguage = function setLanguage(language) {
    this.setState({ selected_language: language });

    this.props.onSelectLanguage(language);
  };

  Languages.prototype.getSingleLanguage = function getSingleLanguage(language, languageName) {
    var survey = this.props.survey;

    var style = {
      width: this.state.device_type === 'mobile' ? '50px' : '100px',
      margin: 'auto',
      height: this.state.device_type === 'mobile' ? '50px' : '100px',
      fontSize: this.state.device_type === 'mobile' ? '20px' : '35px',
      color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
      backgroundColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#00253b'
    };
    var languageAbbrev = (0, _utilElement.getLanguageAbbreviation)();
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 12, md: 6, lg: 3 },
      _react2.default.createElement(
        'div',
        { 'data-qa-type': 'list_item', title: survey.data.languages[language], className: this.state.selected_language === language ? this.styles.language_container + ' ' + this.styles.language_selected : this.styles.language_container, onClick: this.setLanguage.bind(this, language),
          onMouseEnter: this.handleMouseEnter.bind(this, language),
          onMouseLeave: this.handleMouseLeave.bind(this),
          id: language
        },
        _react2.default.createElement(
          'div',
          { className: this.styles.language_flag },
          _react2.default.createElement(
            'div',
            { style: style, className: this.styles.laguage_circle },
            _react2.default.createElement(
              'span',
              null,
              languageAbbrev[language] ? languageAbbrev[language] : languageName.substring(0, 3).toUpperCase()
            )
          )
        ),
        survey && _react2.default.createElement(
          'div',
          { className: this.styles.language_survey_name },
          survey.data.name[language] ? survey.data.name[language] : ''
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.language_name },
          _react2.default.createElement(
            _Col2.default,
            { xs: 12, sm: 12, md: 12, lg: 12 },
            _react2.default.createElement(_mozart_ui.MozartButton, {
              data: survey.data.languages[language],
              style: {
                height: '30px',
                width: '90px',
                marginTop: '10px',
                fontSize: '14px',
                border: '1px solid ' + this.props.theme.colorCode
              }
            })
          )
        )
      )
    );
  };

  Languages.prototype.getLanguages = function getLanguages() {
    var _this3 = this;

    var survey = this.props.survey;

    var languages = survey && survey.data ? survey.data.languages : [];
    var languageElem = [];
    if (languages && (0, _keys2.default)(languages).length) {
      (0, _keys2.default)(languages).map(function (key) {
        if (_this3.state.search_text) {
          if (languages[key].toLowerCase().search(_this3.state.search_text.toLowerCase()) !== -1) {
            languageElem.push(_this3.getSingleLanguage(key, languages[key]));
          }
        } else {
          languageElem.push(_this3.getSingleLanguage(key, languages[key]));
        }
      });
    }
    if (!languageElem.length) {
      languageElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_languages },
        'Sorry ! no items found.'
      ));
    }
    return languageElem;
  };

  Languages.prototype.handleSearch = function handleSearch(searchText) {
    if (searchText.length >= 1 || searchText === '') {
      this.setState({ search_text: searchText, show_search: false });
    }
  };

  Languages.prototype.handleMouseEnter = function handleMouseEnter(language) {
    this.setState({ cardId: language });
    document.getElementById(language).style.border = '1px solid' + this.props.theme.colorCode;
  };

  Languages.prototype.handleMouseLeave = function handleMouseLeave() {
    document.getElementById(this.state.cardId).style.border = '1px solid #E5E5E5';
  };

  Languages.prototype.render = function render() {
    var _this4 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.languages_page_container, style: { width: '100%' }, id: 'languages_listing_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.language_wrapper },
            !this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6 },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.language_heading },
                    'Select your preferred language'
                  )
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6, xsHidden: true },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.search_container },
                    _react2.default.createElement(_components.Search, {
                      label: '',
                      placeholder: 'Search',
                      handleSearch: this.handleSearch.bind(this),
                      style: { 'float': 'right', 'marginRight': '-15px' }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_list_container, 'data-qa-type': 'list_container' },
                this.getLanguages()
              )
            ),
            this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, style: { marginTop: '20px' } },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.language_heading },
                    'Search a language'
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.language_list_container + ' mobile_search_elements' },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_text_field' },
                  _react2.default.createElement(_mozart_ui.MozartTextBox, {
                    ref: 'textbox_mobile_search',
                    id: 'textbox_mobile_search',
                    multiLine: false,
                    validationBool: false,
                    key: 'textbox_mobile_search',
                    limit: 100
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Cancel',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this4.handleSearch('');
                      }
                    }
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Search',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this4.handleSearch(document.getElementById('textbox_mobile_search').value);
                      }
                    }
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return Languages;
}(_react.Component), _class2.propTypes = {
  onSelectLanguage: _react.PropTypes.func,

  survey: _react.PropTypes.object,
  client: _react.PropTypes.object,
  theme: _react.PropTypes.object,

  selectedLanguage: _react.PropTypes.string,
  currentLanguage: _react.PropTypes.string,

  showSearch: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Languages;
module.exports = exports['default'];

/***/ }),

/***/ 2339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"languages_page_container":"_2QZMnhgAT5gelYo0gjaWR0","language_heading":"_3tt9QDhTdJ-NRojuLQ_Vt_","language_container":"_1OTD_dv32Fl3IoIrHn1Yzz","language_selected":"_20eQ5Q5xBWr0_hVFre3TLa","skyBlue":"_246semTsCSkh3DJQ7kBv5R","brightYellow":"_2VbSoXivKtpBwbco7V71bj","azure":"_1vzUeK_o-yyXB848PKmHIP","orange":"_3gBHD0T3xy1vw6xAvtOoNW","darkBlue":"_2gOuZHDHBCShl_oaoXIZDZ","magenta":"_1TUWEmEa2sCMrFXPp2aybM","yellowGreen":"_3SeKIRTs6qF5uuMeCkXVEy","pink":"_2kBHDSD5pPywnNJa2lzLAc","green":"_3aXGY4P2EUhYztNgP7ySXa","red":"v-SgxqhBgGd8mJ5PT3KNI","darkGreen":"fvJTPGgJ2KjPU3s9AcFuh","brown":"_3YE6Z_YNKdyTxGJOW1CSKO","language_id":"_2e7HNwbkVA9zHIlq-gU-8h","language_name":"_8Fxsf94waSMbvQEr_Kk2_","language_survey_name":"_1WrwvYqmiBnIESRhfqOoB7","language_wrapper":"rV6iFHtNDwXb04-nRwk6P","language_header_container":"_7d6CA9YUav1PoWVSxVpez","language_list_container":"_2G1xe4dkMqC8rKG3x1_0Tq","language_flag":"_3CSKRMvdlyJi3r8sBZSIc-","laguage_circle":"_2wtB8xTXwgJzqXKRXEMOO8","search_container":"_3g141OrZj7NTlYGx9TOfdX","no_languages":"_2qMVSMeZ2A3_K4zpwHAmib"};

/***/ }),

/***/ 2340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRangeslider = __webpack_require__(2341);

var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MozartSlider = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MozartSlider, _Component);

  function MozartSlider(props) {
    (0, _classCallCheck3.default)(this, MozartSlider);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.setSliderValue = function () {
      _this.props.onChange(_this.state.value);
    };

    _this.handleChange = function (value) {
      _this.setState({
        value: value
      });
    };

    _this.styles = __webpack_require__(2345);
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  MozartSlider.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.slider_container + ' mozart_slider' },
      this.props.labels && this.props.labels.length > 0 && _react2.default.createElement(
        'div',
        { className: this.styles.slider_label },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { xs: 6, sm: 6, md: 6, lg: 6, className: this.styles.left_label },
            this.props.labels[0] ? this.props.labels[0] : ''
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 6, sm: 6, md: 6, lg: 6, className: this.styles.right_label },
            this.props.labels[1] ? this.props.labels[1] : ''
          )
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactRangeslider2.default, {
          min: this.props.min,
          max: this.props.max,
          value: this.state.value,
          onChange: this.handleChange,
          onChangeComplete: this.setSliderValue,
          tooltip: false,
          handleLabel: this.state.value
        })
      )
    );
  };

  return MozartSlider;
}(_react.Component), _class.propTypes = {
  onChange: _react.PropTypes.func,

  min: _react.PropTypes.number,
  max: _react.PropTypes.number,
  value: _react.PropTypes.number,
  labels: _react.PropTypes.array
}, _temp);
exports.default = MozartSlider;
module.exports = exports['default'];

/***/ }),

/***/ 2345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slider_container":"mR4UFy-8swBo8sJZ6hfvb","slider_label":"_34sdmSYuXC2P8pub2tZTjF","left_label":"_3be3sZ3Hlgs1s-TqUcZ4NI","right_label":"_35WNO_EyyeF_sjTGwXZ9Lr"};

/***/ }),

/***/ 2346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mozart_ui = __webpack_require__(69);

var _momentTimezone = __webpack_require__(498);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _datePicker = __webpack_require__(319);

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerWeb = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DatePickerWeb, _Component);

  function DatePickerWeb(props) {
    (0, _classCallCheck3.default)(this, DatePickerWeb);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2347);
    _this.state = {
      value: _this.props.value ? _this.props.value : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY')
    };
    return _this;
  }

  DatePickerWeb.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  };

  DatePickerWeb.prototype.onWebDateChange = function onWebDateChange(event, value) {
    this.props.onChange((0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    this.refs.date_box_web.value = (0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY');
  };

  DatePickerWeb.prototype.onDateChange = function onDateChange(value) {
    if (this.isValidDate(value)) {
      this.props.onChange((0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    } else {
      this.refs.date_box_web.value = this.state.value;
    }
    //     if (typeof newvalue[0] === 'undefined') {
    //       this.refs.date_box_web.value = this.state.value;
    //     }
    //     if (!check) {
    //       this.refs.date_box_web.value = value;
    //     }
  };

  DatePickerWeb.prototype.onDateBlur = function onDateBlur(event) {
    var value = event.target.value;
    if (!this.isValidDate(value)) {
      this.props.onChange((0, _momentTimezone2.default)(this.state.value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    }
  };

  DatePickerWeb.prototype.isValidDate = function isValidDate(date) {
    //     const allowedDateFormats = [
    //       'DD/MM/YYYY', 'DD.MM.YYYY', 'DD-MM-YYYY',
    //       'D/M/YYYY', 'D.M.YYYY', 'D-M-YYYY',
    //       'MM/DD/YYYY', 'MM.DD.YYYY', 'MM-DD-YYYY',
    //       'M/D/YYYY', 'M.D.YYYY', 'M-D-YYYY',
    //       'YYYY/MM/DD', 'YYYY.MM.DD', 'MM-DD-YYYY',
    //       'YYYY/M/D', 'YYYY.M.D', 'YYYY-M-D'
    //     ];
    var allowedDateFormats = ['MM-DD-YYYY'];
    return (0, _momentTimezone2.default)(date, allowedDateFormats, true).isValid();
  };

  DatePickerWeb.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      'div',
      { className: this.styles.slider_container + ' mozart_slider' },
      _react2.default.createElement(_mozart_ui.MozartTextBox, {
        ref: 'date_box_web',
        key: Math.random(),
        id: 'date_box_web',
        className: 'date_range',
        borderInputBox: true,
        hintText: 'MM-DD-YYYY',
        validationBool: false,
        multiLine: false,
        value: (0, _momentTimezone2.default)(this.state.value, 'MM-DD-YYYY').format('MM-DD-YYYY'),
        onChange: this.onDateChange.bind(this),
        onBlur: this.onDateBlur.bind(this),
        icon: _react2.default.createElement('span', { className: 'icon-Calendar', onClick: function onClick() {
            if (_this2.refs.date_picker_web) {
              _this2.refs.date_picker_web.focus();
            }
          } })
      }),
      _react2.default.createElement(_datePicker2.default, {
        ref: 'date_picker_web',
        onChange: this.onWebDateChange.bind(this),
        value: new Date(this.state.value.split('-').join('/')),
        key: Math.random(),
        defaultChecked: false,
        formatDate: function formatDate(date) {
          return (0, _momentTimezone2.default)(date, 'MM-DD-YYYY').format('MM-DD-YYYY');
        },
        mode: 'landscape',
        style: { 'width': '0px', height: '0px' },
        className: this.styles.date_picker_web,
        id: 'date_picker_' + this.state.sequence_no,
        container: 'inline' })
    );
  };

  return DatePickerWeb;
}(_react.Component), _class.propTypes = {
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.obj
}, _temp);
exports.default = DatePickerWeb;
module.exports = exports['default'];

/***/ }),

/***/ 2347:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"date_picker_web":"_2NuDv3QG31h5s3pD5OwzkK","binary_filter_date_range_container":"_2Yb_8ejfpudYXcO-64Z0tQ","binary_date_range_container":"_1tTNYhXDGuNMLTFT7_iMq1","date_range":"_2ptUHiIeqA0JTs3mQELtj7","date_range_text":"_3ml13ptDqFwzRTzllpv7Jv","binary_filter_date_range":"_2TTh2jaVjzHqHSawE4jHK0"};

/***/ }),

/***/ 2348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search(props) {
    (0, _classCallCheck3.default)(this, Search);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2349);
    _this.state = {
      lastSearchText: '',
      searchText: ''
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.doSearch = _this.doSearch.bind(_this);
    return _this;
  }

  Search.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.keyReset !== nextProps.keyReset) {
      this.setState({ lastSearchText: '', searchText: '' });
    }
  };

  Search.prototype.handleChange = function handleChange(value) {
    this.setState({ lastSearchText: this.state.searchText, searchText: value });
    if (this.props.handleChange) {
      this.props.handleChange(event.target.value);
    }
  };

  Search.prototype.handleKeyPress = function handleKeyPress(target) {
    if (target.charCode === 13) {
      target.preventDefault();
      this.doSearch();
    }
  };

  Search.prototype.doSearch = function doSearch() {
    var handleSearch = this.props.handleSearch;

    if (typeof handleSearch !== 'undefined') {
      if (this.state.searchText !== this.state.lastSearchText) {
        handleSearch(this.state.searchText);
      }
      this.setState({ lastSearchText: this.state.searchText });
    }
  };

  Search.prototype.render = function render() {
    var _props = this.props,
        placeholder = _props.placeholder,
        helpText = _props.helpText,
        label = _props.label;


    return _react2.default.createElement(
      'div',
      { style: this.props.style, className: this.styles.binary_mention_filter_search },
      _react2.default.createElement(
        _Row2.default,
        { className: 'show-grid' },
        _react2.default.createElement(
          'form',
          null,
          _react2.default.createElement(_mozart_ui.BinaryToolTip, {
            key: 'binary_search_tooltip',
            trigger: 'focus',
            closeAfterMillisecond: 6000,
            onExit: this.doSearch.bind(this),
            node: _react2.default.createElement(
              'div',
              { className: this.styles.binary_search },
              _react2.default.createElement(_mozart_ui.MozartTextBox, {
                value: this.state.value,
                icon: _react2.default.createElement('span', { style: { cursor: 'pointer' }, className: 'icon-Search', onClick: this.doSearch }),
                onChange: this.handleChange.bind(this),
                onKeyPress: this.handleKeyPress.bind(this),
                id: 'binary_search_box',
                type: 'text',
                validationBool: false,
                customClassName: this.styles.binary_search_input,
                style: { height: '30px !important', width: '90%', marginRight: '0px' },
                hintText: placeholder ? placeholder : 'Press Enter To Search In ' + label
              })
            ),
            data: _react2.default.createElement(
              'p',
              null,
              typeof helpText === 'undefined' ? 'Search.' : helpText
            )
          })
        )
      )
    );
  };

  return Search;
}(_react.Component), _class.propTypes = {
  style: _react.PropTypes.object,
  keyReset: _react.PropTypes.string,
  label: _react.PropTypes.string,
  placeholder: _react.PropTypes.string,
  helpText: _react.PropTypes.string,
  handleChange: _react.PropTypes.func,
  handleSearch: _react.PropTypes.func
}, _class.defaultProps = {
  label: 'List',
  helpText: 'Press Enter To Search In List'
}, _temp);
exports.default = Search;
module.exports = exports['default'];

/***/ }),

/***/ 2349:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"binary_mention_filter_search":"_2b0qbyV11wFXoFNPrPzfS","binary_mention_search_overlay":"t7ltF8etbMS3grqPhWZpd","binary_search_input":"_8K-Wo9nCXFE2imTYvnh43"};

/***/ }),

/***/ 2350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(61);

var _Row = __webpack_require__(49);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(48);

var _Col2 = _interopRequireDefault(_Col);

var _utilElement = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Thankyou = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage,
    createdAudienceInfo: state.survey.createdAudienceInfo
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Thankyou, _Component);

  function Thankyou(props) {
    (0, _classCallCheck3.default)(this, Thankyou);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = __webpack_require__(2351);
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      timer: _this.props.survey && _this.props.survey.redirectionCounter ? _this.props.survey.redirectionCounter : 5
    };
    _this.intervalTimer = false;
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading survey thankyou page.');
    return _this;
  }

  Thankyou.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!this.props.code && this.props.redirectFromThankyou) {
      setTimeout(function () {
        window.location.reload();
      }, 15000);
    }
    if (this.props.survey.enableRedirection && this.props.createdAudienceInfo && this.props.createdAudienceInfo.redirectionUrl !== null && !this.props.previewMode && !this.props.surveySubmitted) {
      this.intervalTimer = setInterval(function () {
        if (_this2.state.timer <= 0) {
          clearInterval(_this2.intervalTimer);
          window.location.href = _this2.props.createdAudienceInfo.redirectionUrl;
        } else {
          _this2.setState({
            timer: _this2.state.timer - 1
          });
        }
      }, 1000);
    }
  };

  Thankyou.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    if (nextProps.createdAudienceInfo && nextProps.createdAudienceInfo.redirectionUrl !== null && this.props.createdAudienceInfo !== nextProps.createdAudienceInfo) {
      if (!this.intervalTimer) {
        this.intervalTimer = setInterval(function () {
          if (_this3.state.timer <= 0) {
            clearInterval(_this3.intervalTimer);
            window.location.href = nextProps.createdAudienceInfo.redirectionUrl;
          } else {
            _this3.setState({
              timer: _this3.state.timer - 1
            });
          }
        }, 1000);
      }
    }
  };

  Thankyou.prototype.render = function render() {
    var _props = this.props,
        survey = _props.survey,
        selectedLanguage = _props.selectedLanguage;

    var thankyouMsg = void 0;
    if (this.props.surveySubmitted === true) {
      thankyouMsg = survey && survey.thankYouMessage[survey.feedbackLanguage];
    } else if (this.props.selectedLanguage !== null) {
      thankyouMsg = survey.thankYouMessage[selectedLanguage];
    } else {
      thankyouMsg = 'Thanks for your valuable feedback!';
    }
    var thankyouImg = survey && survey.thankYouImage ? survey.thankYouImage : 'https://static.binaryfountain.com/feedback/v1/Thank-You-Survey-4x.png';
    return _react2.default.createElement(
      'div',
      { className: this.styles.thankyou_container, id: 'thankyou_page' },
      _react2.default.createElement(
        _Row2.default,
        { className: 'show-grid', style: { width: '100%', margin: '0px' } },
        _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 12, sm: 12, md: 4, lg: 4 },
              _react2.default.createElement(
                'div',
                { className: this.styles.client_logo },
                _react2.default.createElement('img', { src: this.props.clientLogoUrl })
              )
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 })
          )
        ),
        this.props.survey && this.props.survey.enableRedirection && this.props.createdAudienceInfo && this.props.createdAudienceInfo.redirectionUrl !== null && !this.props.previewMode && !this.props.surveySubmitted && _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 12, sm: 6, md: 4, lg: 4 },
              _react2.default.createElement(
                'div',
                { className: this.styles.testimonial_redirection },
                _react2.default.createElement(
                  'div',
                  null,
                  this.props.survey.redirectionMessage
                )
              )
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 })
          ),
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xs: 12, sm: 6, md: 4, lg: 4 },
              _react2.default.createElement(
                'div',
                { className: this.styles.testimonial_redirection },
                _react2.default.createElement(
                  'div',
                  { className: this.styles.timer },
                  this.state.timer
                )
              )
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 3, md: 4, lg: 4 })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, md: 12, lg: 12 },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 2, md: 4, lg: 4 }),
            _react2.default.createElement(
              _Col2.default,
              { xsHidden: true, smHidden: true, md: 4, lg: 4 },
              survey && !survey.disableThankYouImage ? _react2.default.createElement(
                'div',
                { className: this.styles.thankyou_img },
                _react2.default.createElement('img', { src: thankyouImg })
              ) : ''
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 8, sm: 8, mdHidden: true, lgHidden: true },
              survey && !survey.disableThankYouImage && !survey.showThankYouMessageForMobileScreen ? _react2.default.createElement(
                'div',
                { className: this.styles.thankyou_img },
                _react2.default.createElement('img', { src: thankyouImg })
              ) : ''
            ),
            _react2.default.createElement(_Col2.default, { xs: 2, sm: 2, md: 4, lg: 4 })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { xsHidden: true, smHidden: true, md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.thankyou_txt },
            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: thankyouMsg } })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { xs: 12, sm: 12, mdHidden: true, lgHidden: true, className: this.styles.thankyou_txt_mobile },
          survey && survey.showThankYouMessageForMobileScreen ? _react2.default.createElement(
            'div',
            { className: this.styles.thankyou_txt },
            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: thankyouMsg } })
          ) : ''
        ),
        this.props.showBranding && _react2.default.createElement(
          _Col2.default,
          { xsHidden: true, smHidden: true, md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.poweredby_label },
            'POWERED BY'
          )
        ),
        this.props.showBranding && _react2.default.createElement(
          _Col2.default,
          { xsHidden: true, smHidden: true, md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.poweredby_logo },
            _react2.default.createElement('img', { src: 'https://cdn.consumerism.pressganey.com/pgforsta.png' })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: this.styles.praivacy_message },
            _react2.default.createElement(
              'a',
              { href: 'https://www.pressganey.com/legal-privacy' },
              'Privacy Policy'
            )
          )
        )
      )
    );
  };

  return Thankyou;
}(_react.Component), _class2.propTypes = {
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  createdAudienceInfo: _react.PropTypes.object,

  code: _react.PropTypes.string,
  clientLogoUrl: _react.PropTypes.string,
  selectedLanguage: _react.PropTypes.string,
  feedbackLanguage: _react.PropTypes.string,

  previewMode: _react.PropTypes.boolean,
  showBranding: _react.PropTypes.boolean,
  surveySubmitted: _react.PropTypes.boolean,
  redirectFromThankyou: _react.PropTypes.boolean
}, _temp)) || _class);
exports.default = Thankyou;
module.exports = exports['default'];

/***/ }),

/***/ 2351:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"thankyou_container":"_318-6Cw01_sRT8U0xSWoTN","client_logo":"_2s9UzNh3B-Xo29dL1FMMBI","testimonial_redirection":"_3ZZeSWiF2JfdxGHxXG8Ddj","timer":"excpp_d1DRE42jFzFjm8k","label-pulsate":"FLMoGWyEuZc8om_XXtus7","thankyou_img":"_2-21LY1vVGZFyT0YaFjg8s","thankyou_txt":"_332NqVUS8S2VbYunvwwAHQ","poweredby_label":"HVBxyJrQm2gwN8-UEy_Hl","poweredby_logo":"_2bBTB4d8PkO44N1Hozh1Mc","praivacy_message":"_2e9owe5zo6JpzI9sU_9c","thankyou_txt_mobile":"_1tyLLPYqd8Ef_fhXFQEB6a"};

/***/ }),

/***/ 2352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var buttonOverride = exports.buttonOverride = function buttonOverride(color, fontColor) {
  return "div[data-theme=\"MozartButton\"] {\n    background: none;\n    color: " + color + ";\n    font-family: 'Montserrat', sans-serif;\n    border: 1px solid " + color + " !important;\n    transition: 0.3s;\n    position: relative;\n  }\n  div[data-theme=\"MozartButton\"] {\n    color: #000;\n  }\n  div[data-theme=\"MozartButton\"]::before{\n    opacity: 1 !important;\n    border: transparent !important;\n    background: " + color + ";\n  }\n  div[data-theme=\"MozartButton\"]:after {\n    content: '';\n    transition: all 0.3s !important;\n    width: 0%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    color: white;\n    z-index: 0;\n  }\n  div[data-theme=\"MozartButton\"]:hover:after {\n    width: 100%;\n    background: " + color + ";\n    color: " + fontColor + ";\n  }\n  div[data-theme=\"MozartButton\"]:hover {\n    width: 100%;\n    background: " + color + ";\n    color: " + fontColor + ";\n  }\n  ";
};

var loaderOverride = exports.loaderOverride = function loaderOverride(color) {
  return ".double-bounce1, .double-bounce2 {\n    background-color:" + color + " !important;\n  }";
};

/***/ }),

/***/ 2353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"survey_header_container_md":"_2h3XC3TqCYzWWPwhq0b_11","survey_desc_container_md":"_3AhvMDYLrZ9_i4IZLeY9vu","survey_header_container_sm":"_1SyELbvr1e9nEKxMwxDwlM","survey_desc_container_sm":"_1al80JhxmIiZzsPtsVRg4k","survey_header":"_1CXZ1q9S79RN52JAHdk2XB","survey_name":"_3c00fvB0-SE31bK66OYcDo","copy_right_lg":"fr_liuuE3JS-ejlAEnicn","powered_by":"_2Z5Vk0jBwxTUa2rcnhVzXB","powered_by_name":"_35oHiKHzjPHOOSUvotWfEL","copy_right_sm":"_3KrWFubcUNyhBLaMvn6-sF","survey_description":"cbzDwBe_FEIWULFH1jOxX","survey_description_text":"_17ReWHOf5VJehGq6NttIIw","survey_button_lg":"_3o_Ka6QmBQ_5kqhzWjOVaC","survey_button_sm":"Zak3QOD0qnMGH3HcbJCBB","client_logo_sm":"_2GCMwm-moufllEaZw557SB","client_logo_md":"_1fELDwT005ShcNlQZ5SpTA"};

/***/ }),

/***/ 2354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _stringify = __webpack_require__(272);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(155);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mozart_ui = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unsubscribe = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Unsubscribe, _Component);

  function Unsubscribe(props) {
    (0, _classCallCheck3.default)(this, Unsubscribe);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.state = {
      loading: true,
      loaded: false,
      error: false
    };
    _this.unsubscribeCode = _this.props.params.unsubscribeCode ? _this.props.params.unsubscribeCode : '';
    _this.clientId = _this.props.params.clientId ? _this.props.params.clientId : '';
    _this.deviceType = (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop';
    return _this;
  }

  Unsubscribe.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.clientId !== '' && this.unsubscribeCode !== '') {
      var data = { 'clientId': this.clientId, 'unsubscribeCode': this.unsubscribeCode };
      fetch('https://' + window.env.devHost + '/api/feedback/unsubscription', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: (0, _stringify2.default)(data)
      }).then(function (response) {
        if (response.status === 200) {
          _this2.setState({
            loading: false,
            loaded: true,
            error: false
          });
        } else {
          _this2.setState({
            loading: false,
            loaded: false,
            error: true
          });
        }
      });
    }
  };

  Unsubscribe.prototype.render = function render() {
    var styles = __webpack_require__(1103);
    var largeFont = this.deviceType === 'mobile' ? '20px' : '30px';
    var smallFont = this.deviceType === 'mobile' ? '15px' : '20px';
    return _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(_reactHelmet2.default, { title: 'Unsubscribe' }),
      _react2.default.createElement(
        'div',
        { className: styles.binary_notfound },
        _react2.default.createElement(
          'div',
          { style: { marginLeft: 'auto', marginRight: 'auto', width: '500px', maxWidth: '100%' } },
          _react2.default.createElement(_mozart_ui.Image, { src: '/img/broken_robot.png' })
        ),
        this.state.loading && _react2.default.createElement(
          'p',
          { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
          'Please wait...'
        ),
        this.state.error && _react2.default.createElement(
          'p',
          { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
          'Sorry, we are having technical difficulties. Please try again later!'
        ),
        this.state.loaded && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
            'You have successfully unsubscribed!'
          ),
          _react2.default.createElement(
            'p',
            { style: { fontSize: smallFont, fontWeight: 300, textAlign: 'center' } },
            'You won\'t get any further emails from us.'
          )
        )
      )
    );
  };

  return Unsubscribe;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  params: _react.PropTypes.object
}, _temp);
exports.default = Unsubscribe;
module.exports = exports['default'];

/***/ }),

/***/ 2355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__(155);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = __webpack_require__(61);

var _redux = __webpack_require__(101);

var _mozart_ui = __webpack_require__(69);

var _reactBootstrap = __webpack_require__(2356);

var _Unsubscription = __webpack_require__(2417);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unsubscription = function (_Component) {
  (0, _inherits3.default)(Unsubscription, _Component);

  function Unsubscription(props) {
    (0, _classCallCheck3.default)(this, Unsubscription);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.state = {
      validate: true,
      identifierValue: '',
      identifier: '',
      show: false,
      action: '',
      response: 'failed'
    };
    _this.clientId = _this.props.params && _this.props.params.clientId ? _this.props.params.clientId : 'undefined';
    _this.phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    _this.emailRegex = /^(([^<>()[\]\\,;:\s@"]+(\.[^<>()[\]\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,20}))$/;
    return _this;
  }

  Unsubscription.prototype.isValidate = function isValidate(data) {
    if (this.emailRegex.test(data) || this.phoneRegex.test(data)) {
      this.setState({
        validate: false,
        identifierValue: data.trim(),
        identifier: this.emailRegex.test(data) ? 'email' : 'phone'
      });
    } else {
      this.setState({
        validate: true,
        identifierValue: data
      });
    }
  };

  Unsubscription.prototype.handleSubmit = function handleSubmit() {
    var _this2 = this;

    this.setState({
      validate: this.state.response === 'unauthorised' ? this.state.validate : true,
      identifierValue: this.state.response === 'unauthorised' ? this.state.identifierValue : '',
      identifier: this.state.response === 'unauthorised' ? this.state.identifier : '',
      show: false,
      response: this.state.response === 'unauthorised' ? this.state.response : 'failed'
    }, function () {
      if (_this2.state.response !== 'unauthorised') {
        document.getElementById('textbox').value = '';
      }
    });
  };

  Unsubscription.prototype.showHide = function showHide() {
    this.setState({ show: true });
  };

  Unsubscription.prototype.handleSubscription = function handleSubscription(action) {
    var _this3 = this;

    this.setState({
      action: action
    }, function () {
      var data = {
        identifierValue: _this3.state.identifierValue,
        action: _this3.state.action,
        clientId: _this3.clientId,
        identifier: _this3.state.identifier
      };
      _this3.props.loadUnsubscription(data).then(function (response) {
        if (response) {
          _this3.setState({
            response: 'success'
          });
        }
        _this3.showHide();
      }).catch(function (response) {
        if (response && response.status === 401) {
          _this3.setState({
            response: 'unauthorised'
          });
        }
        _this3.showHide();
      });
    });
  };

  Unsubscription.prototype.snackbarMessage = function snackbarMessage() {
    var snackbarMessage = this.state.action + 'd Successfully.';
    var message = '';
    if (this.state.response === 'success') {
      message = snackbarMessage.toUpperCase();
    } else if (this.state.response === 'unauthorised') {
      message = 'NO ACCESS. PLEASE LOGIN TO CONTINUE.';
    } else {
      message = 'SOMETHING WENT WRONG';
    }
    return message;
  };

  Unsubscription.prototype.render = function render() {
    var _this4 = this;

    var styles = __webpack_require__(2418);
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_reactHelmet2.default, { title: 'Subscribe / Unsubscribe' }),
      _react2.default.createElement(
        _reactBootstrap.Row,
        null,
        _react2.default.createElement(
          _reactBootstrap.Col,
          { xs: 12, md: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            'Subscribe / Unsubscribe'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.unsubscription_container },
            _react2.default.createElement(
              'div',
              { className: styles.email_phone_textbox },
              _react2.default.createElement(
                'div',
                { className: styles.email_phone_text },
                'Enter Email/Phone :'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.email_phone_box },
                _react2.default.createElement(_mozart_ui.MozartTextBox, {
                  key: 'text',
                  id: 'textbox',
                  className: 'textbox',
                  name: 'text',
                  errorFontSize: '11px',
                  hintText: 'Enter an Email or a Phone',
                  onChange: this.isValidate.bind(this),
                  validationBool: false,
                  style: {
                    // width: '388px'
                  }
                }),
                this.state.validate && (this.state.identifierValue !== '' ? _react2.default.createElement(
                  'div',
                  { className: styles.label },
                  'Please enter a valid text'
                ) : _react2.default.createElement(
                  'div',
                  { className: styles.label },
                  'Please enter a value for text'
                ))
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.submit },
              _react2.default.createElement(_mozart_ui.MozartButton, {
                className: 'subscribe',
                data: 'Subscribe',
                id: 'subscribe',
                disabled: this.state.validate,
                onClick: this.handleSubscription.bind(this, 'subscribe'),
                style: {
                  width: '150px',
                  marginLeft: '168px'
                }
              }),
              _react2.default.createElement(_mozart_ui.MozartButton, {
                className: 'unsubscribe',
                data: 'Unsubscribe',
                id: 'unsubscribe',
                disabled: this.state.validate,
                onClick: this.handleSubscription.bind(this, 'unsubscribe'),
                style: {
                  width: '150px',
                  marginLeft: '84px'
                }
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_mozart_ui.MozartSnackBar, {
                autoHideDuration: '2600',
                message: this.snackbarMessage(),
                onRequestClose: function onRequestClose() {
                  _this4.handleSubmit();
                },
                open: this.state.show
              })
            )
          )
        )
      )
    );
  };

  return Unsubscription;
}(_react.Component);

Unsubscription.propTypes = {
  loadUnsubscription: _propTypes2.default.func,
  params: _propTypes2.default.object
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadUnsubscription: _Unsubscription.loadUnsubscription
  }, dispatch);
};

var mapStateToProps = function mapStateToProps() {
  return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Unsubscription);
module.exports = exports['default'];

/***/ }),

/***/ 2417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(38);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Unsubscription;
exports.loadUnsubscription = loadUnsubscription;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_UNSUBSCRIPTION = 'binary/Unsubscription/LOAD_UNSUBSCRIPTION';
var LOAD_UNSUBSCRIPTION_SUCCESS = 'binary/Unsubscription/LOAD_UNSUBSCRIPTION_SUCCESS';
var LOAD_UNSUBSCRIPTION_FAIL = 'binary/Unsubscription/LOAD_UNSUBSCRIPTION_FAIL';

var initialState = {
  loadedUnsubscription: false,
  loadingUnsubscription: false
};

function Unsubscription() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_UNSUBSCRIPTION:
      return (0, _extends3.default)({}, state, {
        loadingUnsubscription: true
      });
    case LOAD_UNSUBSCRIPTION_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingUnsubscription: false,
        loadedUnsubscription: true,
        data: action.result
      });
    case LOAD_UNSUBSCRIPTION_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingUnsubscription: false,
        loadedUnsubscription: false,
        error: action.error
      });
    default:
      return state;
  }
}

function loadUnsubscription(data) {
  return {
    types: [LOAD_UNSUBSCRIPTION, LOAD_UNSUBSCRIPTION_SUCCESS, LOAD_UNSUBSCRIPTION_FAIL],
    promise: function promise(client) {
      return client.post('/notification/manual/unsubscription', {
        data: data
      });
    }
  };
}

/***/ }),

/***/ 2418:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_2lvlnnwbHAKXleEfXvVPi0","unsubscription_container":"_2X24UPUSVo0BUN6wvQcJEi","email_phone_textbox":"_3huSmM_mbRdoNl8PxVTAzQ","email_phone_text":"_25eamhkozbLjSkL-MRZtDp","email_phone_box":"_39cvjIE6j-8RByXJfu1ryy","label":"_37-_fJ5qHo49OKC10pevct","submit":"HPHdF4pdurW45FpKo0v3W","subscribe":"_3INIwwNFgHDqfMxd0pvPC4","unsubscribe":"_2F_6xR8IWFNVjfzyABxNYm"};

/***/ }),

/***/ 2419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _stringify = __webpack_require__(272);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(155);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mozart_ui = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribeV2 = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UnsubscribeV2, _Component);

  function UnsubscribeV2(props) {
    (0, _classCallCheck3.default)(this, UnsubscribeV2);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.state = {
      loading: true,
      loaded: false,
      error: false
    };
    _this.unsubscribeCode = _this.props.params.unsubscribeCode ? _this.props.params.unsubscribeCode : '';
    _this.clientId = _this.props.params.clientId ? _this.props.params.clientId : '';
    _this.deviceType = (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop';
    return _this;
  }

  UnsubscribeV2.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.clientId !== '' && this.unsubscribeCode !== '') {
      var data = { 'clientId': this.clientId, 'unsubscribeCode': this.unsubscribeCode };
      fetch('https://' + window.env.devHost + '/api/feedback/v2/unsubscription', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: (0, _stringify2.default)(data)
      }).then(function (response) {
        if (response.status === 200) {
          _this2.setState({
            loading: false,
            loaded: true,
            error: false
          });
        } else {
          _this2.setState({
            loading: false,
            loaded: false,
            error: true
          });
        }
      });
    }
  };

  UnsubscribeV2.prototype.render = function render() {
    var styles = __webpack_require__(1103);
    var largeFont = this.deviceType === 'mobile' ? '20px' : '30px';
    var smallFont = this.deviceType === 'mobile' ? '15px' : '20px';
    return _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(_reactHelmet2.default, { title: 'UnsubscribeV2' }),
      _react2.default.createElement(
        'div',
        { className: styles.binary_notfound },
        _react2.default.createElement(
          'div',
          { style: { marginLeft: 'auto', marginRight: 'auto', width: '500px', maxWidth: '100%' } },
          _react2.default.createElement(_mozart_ui.Image, { src: '/img/broken_robot.png' })
        ),
        this.state.loading && _react2.default.createElement(
          'p',
          { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
          'Please wait...'
        ),
        this.state.error && _react2.default.createElement(
          'p',
          { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
          'Sorry, we are having technical difficulties. Please try again later!'
        ),
        this.state.loaded && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { style: { fontSize: largeFont, fontWeight: 300, textAlign: 'center', marginTop: '30px' } },
            'You have successfully unsubscribed!'
          ),
          _react2.default.createElement(
            'p',
            { style: { fontSize: smallFont, fontWeight: 300, textAlign: 'center' } },
            'You won\'t get any further emails from us.'
          )
        )
      )
    );
  };

  return UnsubscribeV2;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  params: _react.PropTypes.object
}, _temp);
exports.default = UnsubscribeV2;
module.exports = exports['default'];

/***/ }),

/***/ 2420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _keys = __webpack_require__(126);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(12);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(13);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReactDOMServer = __webpack_require__(2421);

var _ReactDOMServer2 = _interopRequireDefault(_ReactDOMServer);

var _serializeJavascript = __webpack_require__(2425);

var _serializeJavascript2 = _interopRequireDefault(_serializeJavascript);

var _reactHelmet = __webpack_require__(155);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Analytics = __webpack_require__(2426);

var _config = __webpack_require__(273);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper component containing HTML metadata and boilerplate tags.
 * Used in server-side code only to wrap the string output of the
 * rendered route component.
 *
 * The only thing this component doesn't (and can't) include is the
 * HTML doctype declaration, which is added to the rendered output
 * by the server.js file.
 */
var Html = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Html, _Component);

  function Html() {
    (0, _classCallCheck3.default)(this, Html);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Html.prototype.render = function render() {
    var _props = this.props,
        assets = _props.assets,
        component = _props.component,
        store = _props.store;

    var content = component ? _ReactDOMServer2.default.renderToString(component) : '';
    var head = _reactHelmet2.default.rewind();

    return _react2.default.createElement(
      'html',
      { lang: 'en-us' },
      _react2.default.createElement(
        'head',
        null,
        _react2.default.createElement('meta', { charSet: 'utf-8' }),
        _react2.default.createElement('meta', { httpEquiv: 'X-UA-Compatible', content: 'IE=edge' }),
        _react2.default.createElement('meta', { name: 'theme-color', content: '#403788' }),
        _react2.default.createElement('meta', { name: 'msapplication-navbutton-color', content: '#403788' }),
        _react2.default.createElement('meta', { name: 'apple-mobile-web-app-status-bar-style', content: '#403788' }),
        _react2.default.createElement('meta', { name: 'robots', content: 'noindex' }),
        head.base.toComponent(),
        head.title.toComponent(),
        head.meta.toComponent(),
        head.link.toComponent(),
        head.script.toComponent(),
        _react2.default.createElement('link', { rel: 'shortcut icon', href: '/favicon.ico' }),
        _react2.default.createElement('link', { href: '//fonts.googleapis.com/css?family=Open+Sans', rel: 'stylesheet' }),
        _react2.default.createElement('link', { rel: 'stylesheet', href: '//maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css' }),
        _config2.default.env_bf !== 'prod' && _react2.default.createElement('link', { href: '//static.binaryfountain.com/prod/bha-iconfont/style.css', rel: 'stylesheet' }),
        _config2.default.env_bf === 'prod' && _react2.default.createElement('link', { href: '//static.binaryfountain.com/prod/bha-iconfont/style.css', rel: 'stylesheet' }),
        _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1.0, user-scalable=0' }),
        (0, _keys2.default)(assets.styles).map(function (style, key) {
          return _react2.default.createElement('link', { href: assets.styles[style], key: key, media: 'screen, projection, print',
            rel: 'stylesheet', type: 'text/css', charSet: 'UTF-8' });
        }),
        (0, _keys2.default)(assets.styles).length === 0 ? _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: __webpack_require__(2427) + __webpack_require__(656)._style } }) : null,
        _react2.default.createElement('script', { charSet: 'UTF-8', dangerouslySetInnerHTML: { __html: 'window.env=' + (0, _serializeJavascript2.default)(_config2.default) + ';' } }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'document.domain = window.env.domain;' } }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: '\n            window.addEventListener( "message",\n            function (event) {\n              if(event.origin === window.location.origin && event.data == \'logout\'){\n                var logoutForm = document.createElement(\'FORM\');\n                var button = document.createElement(\'input\');\n                button.setAttribute(\'type\', \'submit\');\n                logoutForm.name = \'logout\';\n                logoutForm.method = \'POST\';\n                logoutForm.action = \'/app/logout\';\n                logoutForm.appendChild(button);\n                document.body.appendChild(logoutForm);\n                logoutForm.submit();\n              }\n            },\n            false);\n            if (window.env === \'production\') {\n              window.onerror = function(msg, url, line, col, error) {\n                 // Log information\n                 console.error("Error: " + msg + " - url: " + url + " - line: " + line + " - col: " + col + " - error: " + error);\n\n                 // TODO: Report this error via ajax so can keep track of what pages have JS issues\n\n                 var suppressErrorAlert = true;\n                 // If return true, then error alerts (like in older versions of  Internet Explorer) will be suppressed.\n                 return suppressErrorAlert;\n              };\n            }\n            if (\'onhashchange\' in window) {\n              window.onhashchange = function() {\n                if (location.hash.indexOf(\'mentions\') !== -1 && location.hash.indexOf(\'dateRange\') !== -1 && location.hash.indexOf(\'inputDateTimeZone=UTC\') !== -1) {\n                  document.body.remove();\n                  window.location.href = location.hash.replace(\'inputDateTimeZone=UTC\', \'\');\n                  window.location.reload(true);\n                }\n              }\n            }\n          ' } })
      ),
      _react2.default.createElement(
        'body',
        null,
        _react2.default.createElement('div', { id: 'content', dangerouslySetInnerHTML: { __html: content } }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'window.__data=' + (0, _serializeJavascript2.default)(store.getState()) + ';' }, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: _Analytics.googleAnalyticsCode }, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'window.env=' + (0, _serializeJavascript2.default)(_config2.default) + ';' }, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { src: assets.javascript.vendors, charSet: 'UTF-8' }),
        _react2.default.createElement('script', { src: assets.javascript.main, charSet: 'UTF-8' }),
        _react2.default.createElement(
          'noscript',
          null,
          _react2.default.createElement(
            'div',
            { style: { 'margin': '20px', 'text-align': 'center' } },
            _react2.default.createElement(
              'h1',
              null,
              'Javascript disabled'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Sorry, our application needs Javascript in order to work. Please enable Javascript and reload this page.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Here are the ',
              _react2.default.createElement(
                'a',
                { href: 'https://www.enable-javascript.com/', target: '_blank' },
                'instructions how to enable JavaScript in your web browser'
              ),
              '.'
            )
          )
        )
      )
    );
  };

  return Html;
}(_react.Component), _class.propTypes = {
  assets: _react.PropTypes.object,
  component: _react.PropTypes.node,
  store: _react.PropTypes.object
}, _temp);
exports.default = Html;
module.exports = exports['default'];

/***/ }),

/***/ 2426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var FATAL = exports.FATAL = true;
var NOT_FATAL = exports.NOT_FATAL = false;

var googleAnalyticsCode = exports.googleAnalyticsCode = "\n  if (window.env.domain !== 'feedback.consumerism.pressganey.com' && window.env.domain !== 'feedback.uclahealth.org' && window.env.domain !== 'survey-feedback.fountain-analytics.com') {\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','GTM-N67G8SW');\n  } else {\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','GTM-T596S26');\n  }\n";

/***/ }),

/***/ 2427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Bootstrap configuration for bootstrap-sass-loader
 *
 * Scripts are disabled to not load jQuery.
 * If you depend on Bootstrap scripts consider react-bootstrap instead.
 * https://github.com/react-bootstrap/react-bootstrap
 *
 * In order to keep the bundle size low in production
 * disable components you don't use.
 *
 */

module.exports = {
  preBootstrapCustomizations: './src/theme/variables.scss',
  mainSass: './src/theme/bootstrap.overrides.scss',
  verbose: false,
  debug: false,
  scripts: {
    transition: false,
    alert: false,
    button: false,
    carousel: false,
    collapse: false,
    dropdown: false,
    modal: false,
    tooltip: false,
    popover: false,
    scrollspy: false,
    tab: false,
    affix: false
  },
  styles: {
    mixins: true,
    normalize: true,
    print: true,
    glyphicons: true,
    scaffolding: true,
    type: true,
    code: true,
    grid: true,
    tables: false,
    forms: true,
    buttons: true,
    'component-animations': true,
    dropdowns: true,
    'button-groups': true,
    'input-groups': false,
    navs: true,
    navbar: true,
    breadcrumbs: false,
    pagination: true,
    pager: true,
    labels: true,
    badges: false,
    jumbotron: true,
    thumbnails: true,
    alerts: true,
    'progress-bars': false,
    media: false,
    'list-group': true,
    panels: true,
    wells: false,
    'responsive-embed': true,
    close: true,
    modals: true,
    tooltip: false,
    popovers: true,
    carousel: false,
    utilities: true,
    'responsive-utilities': true
  }
};

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _assign = __webpack_require__(503);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(508);

var isProduction = {
  development: {
    isProduction: false
  },
  mock: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}["production" || global.window && global.window.env.env || 'development'];

var environment = Object({"NODE_ENV":"production"}).ENV || global.window && global.window.env.env_bf || 'env3';
// hack for prop type warning due to older version of react and some dependencies using prop types
if (environment !== 'prod') {
  (function () {
    var _error = console.error;
    console.error = function (errMessage) {
      var check = errMessage && errMessage.indexOf('Warning: Failed Context Types: Calling PropTypes validators directly is not supported by the') !== -1;
      if (!check) {
        _error.call(console, errMessage);
      }
    };
  })();
}
module.exports = (0, _assign2.default)(Object({"NODE_ENV":"production"}).ENV ? {
  host: Object({"NODE_ENV":"production"}).HOST || 'localhost',
  port: Object({"NODE_ENV":"production"}).PORT || 443,
  env: "production" || 'development', //  production or development
  env_bf: environment,
  local: Object({"NODE_ENV":"production"}).LOCAL || true,
  domain: Object({"NODE_ENV":"production"}).DOMAIN || environment + '.consumerism.pressganey.com',
  apiHost: Object({"NODE_ENV":"production"}).APIHOST || 'localhost', // mock API
  apiPort: Object({"NODE_ENV":"production"}).APIPORT,
  devHost: Object({"NODE_ENV":"production"}).DEVHOST || 'feedback-api.' + environment + '.consumerism.pressganey.com',
  nextgenHost: Object({"NODE_ENV":"production"}).NEXTGENHOST || 'reputation.' + environment + '.consumerism.pressganey.com',
  nextgenApiHost: Object({"NODE_ENV":"production"}).NEXTGENAPIHOST || 'nextgenbha-api.' + environment + '.consumerism.pressganey.com',
  notificationHost: Object({"NODE_ENV":"production"}).NOTIFICATIONHOST || 'notification-api.' + environment + '.consumerism.pressganey.com',
  devPort: 443,
  loginHost: Object({"NODE_ENV":"production"}).LOGINHOST || 'login.' + environment + '.consumerism.pressganey.com',
  idleTime: Object({"NODE_ENV":"production"}).IDLE_TIME || 15,
  app: {
    title: 'Press Ganey Consumer Experience',
    description: 'Press Ganey Consumer Experience',
    head: {
      titleTemplate: '%s - Press Ganey Consumer Experience',
      meta: [{ name: 'description', content: 'binary' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'binary' }, { property: 'og:image', content: 'binary' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'binary' }, { property: 'og:description', content: 'binary' }, { property: 'og:card', content: 'binary' }, { property: 'og:site', content: 'binary' }, { property: 'og:creator', content: 'binary' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  }

} : (0, _assign2.default)({}, global.window && global.window.env), isProduction);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(38);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = client;
exports.loadClient = loadClient;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_CLIENT = 'binary/client/LOAD_CLIENT';
var LOAD_CLIENT_SUCCESS = 'binary/client/LOAD_CLIENT_SUCCESS';
var LOAD_CLIENT_FAIL = 'binary/client/LOAD_CLIENT_FAIL';

var initialState = {
  loadedClient: false,
  loadingClient: false,
  theme: false
};

function client() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_CLIENT:
      return (0, _extends3.default)({}, state, {
        loadingClient: true
      });
    case LOAD_CLIENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingClient: false,
        loadedClient: true,
        data: action.result
      });
    case LOAD_CLIENT_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingClient: false,
        loadedClient: false,
        error: action.error
      });
    default:
      return state;
  }
}

function loadClient(clientId) {
  return {
    types: [LOAD_CLIENT, LOAD_CLIENT_SUCCESS, LOAD_CLIENT_FAIL],
    promise: function promise(promiseClient) {
      return promiseClient.get('/feedback/' + clientId + '/details', {
        params: {}
      });
    }
  };
}

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"binary_logo":"_25f9iUUM_cj9XyZfy6Khzr","binary_breadcrums":"YnOnMyPHgYrxdTdzx6MqA","app":"_3sz-Jorbvi2LDO38TpQcMl","logo":"_3FPdgYCH7ng4B01tIp7UlO","binary_nav":"_2eyLCXxwodEkd3ONaUuzAo","appContent":"gsYlqHuubB3bKiaXdybMG","navbar-nav":"g2P5efLY-IeGePZ8DEfOn","dropdown":"_1y38NVCFHauRTs5uXFYEa6","navbar-default":"_34DB0575Q-BhMZQX9ALFgG","open":"_2Dul3KyNeaTSpl9od8OX6e"};

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getSurveyStartTexts = getSurveyStartTexts;
exports.getSkipButtonText = getSkipButtonText;
exports.getNextButtonText = getNextButtonText;
exports.getSubmitButtonText = getSubmitButtonText;
exports.getBackButtonText = getBackButtonText;
exports.getLanguageAbbreviation = getLanguageAbbreviation;
exports.checkDevice = checkDevice;
exports.getSurveyNameLength = getSurveyNameLength;
exports.getTextForLanguage = getTextForLanguage;
exports.fireGTMEvent = fireGTMEvent;
/* Survey start button text */
function getSurveyStartTexts() {
  return {
    en: 'Start Survey',
    es: 'Empezar Encuesta',
    de: 'Umfrage Starten',
    fr: 'Commencer l\'enquête',
    pt: 'Iniciar Pesquisa',
    zh: '开始调查',
    ko: '설문 조사 시작',
    vi: 'Bắt đầu cuộc điều tra',
    hi: 'सर्वेक्षण शुरू करें'
  };
}

function getSkipButtonText() {
  return {
    en: 'Skip',
    es: 'saltar',
    de: 'überspringen',
    fr: 'sauter',
    pt: 'pular',
    zh: '跳过',
    ko: '건너 뛰기',
    vi: 'Nhảy lớp',
    hi: 'छोड़ें'
  };
}

function getNextButtonText() {
  return {
    en: 'Next',
    es: 'próxima',
    de: 'nächste',
    fr: 'Prochain',
    pt: 'próxima',
    zh: '下一个',
    ko: '다음',
    vi: 'tiếp theo',
    hi: 'अगला'
  };
}

function getSubmitButtonText() {
  return {
    en: 'Submit',
    es: 'Enviar',
    de: 'Einreichen',
    fr: 'Soumettez',
    pt: 'Enviar',
    zh: '提交',
    ko: '제출하다',
    vi: 'đệ trình',
    hi: 'प्रस्तुत'
  };
}

function getBackButtonText() {
  return {
    en: 'Back',
    es: 'Espalda',
    de: 'zurück',
    fr: 'arrière',
    pt: 'De volta',
    zh: '背部',
    ko: '뒤',
    vi: 'Trở lại',
    hi: 'वापस'
  };
}

function getLanguageAbbreviation() {
  return {
    en: 'ENG',
    es: 'ESP',
    de: 'GER',
    fr: 'FRA',
    pt: 'POR',
    zh: 'MAN',
    ko: 'KOR',
    vi: 'VIE',
    hi: 'HIN'
  };
}

function checkDevice() {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
}

function getSurveyNameLength(textObj, language) {
  var textLength = '';
  if (textObj[language]) {
    textLength = textObj[language].length;
  } else if (textObj.en) {
    textLength = textObj.en.length;
  }
  return textLength;
}

function getTextForLanguage(textObj, language) {
  var text = '';
  if (textObj[language]) {
    text = textObj[language];
  } else if (textObj.en) {
    text = textObj.en;
  }
  return text;
}

function fireGTMEvent(eventName, eventAction, eventLabel) {
  var dataLayer = [];
  if (typeof window.dataLayer !== 'undefined') {
    dataLayer = window.dataLayer;
  }
  var eventCategory = 'others';
  switch (eventName) {
    case 'page_load':
      eventCategory = 'page_load';
      break;
    case 'button_click':
    case 'search':
      eventCategory = 'button_click';
      break;
    case 'set_data':
      eventCategory = 'data_selection';
      break;
    default:
      eventCategory = 'others';
      break;
  }
  dataLayer.push({
    'event': eventName,
    'eventCategory': eventCategory,
    'eventAction': eventAction,
    'eventLabel': eventLabel
  });
}

exports.EVENT_PAGE_LOAD = 'page_load';
exports.EVENT_BTN_CLICK = 'button_click';
exports.EVENT_SET_DATA = 'set_data';
exports.EVENT_SEARCH = 'search';

/***/ })

},[1120]);


// WEBPACK FOOTER //
// main-cd270fb07d338dd44b52.js